import AirbnbLogo from 'images/airbnb-logo.png';
import AgodaLogo from 'images/agoda-logo-icon.png';
import AgodaHomesLogo from 'images/agodahomes-logo-icon.png';
import BookingComLogo from 'images/booking-logo-icon.png';
import CtripLogo from 'images/ctrip-logo-icon.png';
import CtripCMLogo from 'images/ctrip-logo-icon.png';
import ExpediaLogo from 'images/expedia-logo-icon.png';
import HomeAwayLogo from 'images/homeaway-logo-icon.png';
import TravelokaLogo from 'images/traveloka-logo-icon.png';
import TiketcomLogo from 'images/tiketcom-logo-icon.png';
import OthersLogo from 'images/others-logo-icon.png';
import HostPlatformLogo from 'images/hostplatform-logo-icon.png';
import BELogo from 'images/HBE-BE-logo-2.png';
import ExtIntegrationLogo from 'images/extIntegration-logo-icon.png';
import usFlag from '../images/us-flag.png';
import chFlag from '../images/china-flag.png';
import thFlag from '../images/thai-flag.png';
import myFlag from '../images/my-flag.png';
import idFlag from '../images/id-flag.png';

/* ------------------------------general constants------------------------------*/
// ------------------------------date
// Date format
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_WITH_WEEKDAY_FORMAT = 'YYYY-MM-DD, dddd';
export const FORMAL_DATE_FORMAT = 'DD-MM-YYYY';
export const MONTH_FORMAT = `YYYY-MM`;
export const MONTH_YEAR_DISPLAY_FORMAT = 'MMMM YYYY';
export const DATE_DATE_TIME_FORMAT = `${DATE_FORMAT} HH:mm`;

export const MONTHS = [
  { label: 'January', code: 0 },
  { label: 'February', code: 1 },
  { label: 'March', code: 2 },
  { label: 'April', code: 3 },
  { label: 'May', code: 4 },
  { label: 'June', code: 5 },
  { label: 'July', code: 6 },
  { label: 'August', code: 7 },
  { label: 'September', code: 8 },
  { label: 'October', code: 9 },
  { label: 'November', code: 10 },
  { label: 'December', code: 11 }
];

export const constructDateFormat = (separator = '-') => `YYYY${separator}MM${separator}DD`;

// ------------------------------regex
export const CONTACT_NUMBER_REGEX = /^[+0-9][-\s0-9]*$/;
export const EMAIL_REGEX = '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$';
export const REGEX_NOT_NUMBER_N_DOT = /[^0-9.]/g;
export const LETTER_N_NUMBER = '^[a-zA-Z0-9]*$';

// ------------------------------general
export const SEPARATOR_DASH = '-';
export const STANDARD_RATE_CODE = 'STD';

export const MIN_INTL_CONTACT_NO_LEN = 7;

export const BLANK_IMAGE = 'https:dashboard-operator-image.s3.amazonaws.com/3386bffc-75c9-4390-a670-fc11ed8febe1_blanksquare.png';

/* ------------------------------specific constants------------------------------*/
// Rate Distribution
export const RATE_DISTRIBUTION_TAB = 'Rate Distribution Tab';
export const RATE_DERIVATIVE = 'rateDerivative';
export const WEEKDAY_RATE = 'weekdayRate';
export const WEEKEND_RATE = 'weekendRate';
export const PAX_THRESHOLD = 'noOfPaxThreshold';
export const EXTRA_PAX_FEE = 'feePerExtraPax';
export const RATE_DERIVATIVES = [
  { code: 'independent', value: 'Independent', key: 'independent', isDerived: false, isDefault: true },
  { code: 'derived', value: 'Derived from Web', key: 'derived', isDerived: true, isDefault: false }
];

// Pricing
export const PRICING_TAB = 'Pricing Tab';
export const CLEANING_FEE = 'Cleaning Fee';
export const CHARGE_TYPE = 'Charge Type';

// Rate Modifier
export const MODIFIER_TYPE = 'modifierType';
export const MODIFIER_SIGN = 'modifierSign';
export const MODIFIER_AMOUNT = 'modifierAmount';

// Booking Status
export const BOOKINGTYPE_MAINTENANCE = 5;
export const BOOKINGTYPE_BLOCK = 6;

// OTAs
export const OTAS = [
  { code: 'agoda', label: 'Agoda', logo: AgodaLogo },
  { code: 'agodahomes', label: 'Agoda Homes', logo: AgodaHomesLogo },
  { code: 'airbnb', label: 'Airbnb', logo: AirbnbLogo, isAirbnb: true },
  { code: 'bookingcom', label: 'Booking.com', logo: BookingComLogo },
  { code: 'ctrip', label: 'Ctrip', logo: CtripLogo },
  { code: 'ctripcm', label: 'CtripCM', logo: CtripCMLogo },
  { code: 'expedia', label: 'Expedia', logo: ExpediaLogo },
  { code: 'homeaway', label: 'HomeAway', logo: HomeAwayLogo },
  { code: 'traveloka', label: 'Traveloka', logo: TravelokaLogo },
  { code: 'tiketcom', label: 'Tiket.com', logo: TiketcomLogo },
  { code: 'hostplatform', label: 'HostPlatform', logo: HostPlatformLogo },
  { code: 'bookingEngine', label: 'Homes Booking Website', logo: BELogo },
  { code: 'hotelBookingEngine', label: 'Hotel Booking Website', logo: BELogo },
  { code: 'extIntegration', label: 'ExtIntegration', logo: ExtIntegrationLogo },
  { code: 'others', label: 'Others', logo: OthersLogo, isDefault: true }
];

/** hostConnect keys used for Unified Inbox OTA billing (matches nebulapi inventory hostConnectRecordSchema). */
export const HOST_CONNECT_OTA_CODES = ['airbnb', 'agoda', 'agodahomes', 'bookingcom', 'ctrip', 'expedia', 'traveloka', 'tiketcom'];

export const HOST_CONNECT_OTA_OPTIONS = OTAS.filter(ota => HOST_CONNECT_OTA_CODES.includes(ota.code));

// OTA Form
export const INTEGRATION_TYPES = [
  { code: 'listing', tabTitle: 'Listing Integration', isListingIntegration: true },
  { code: 'hotel', tabTitle: 'Hotel Integration' }
];

// User Profile
export const DEFAULT_USER_PROFILE_URL = 'https://dashboard-operator-image.s3.amazonaws.com/e1b4d0a0-3114-4122-85ff-ef0f54022485_notfound.png';

// Fine Print for Invoice, Guest Registration Card, Quotation
// Note: If you're changing this, please change in titan too.
export const DEFAULT_FINE_PRINT =
  'NOTICE TO GUESTS: This property is privately owned and the management reserves the right to refuse service to anyone. Management will not be responsible for accidents or injury to guests or for loss of money, jewelry or valuables of any kind. Management will not be responsible for any item left in the room. \n CHECK OUT TIME : 12:00 PM SELF REGISTRATION ONLY. \n I AGREE that my liability for this bill is not waived and agree to be held personally liable in the event that the indicated person or company failed to pay for any part or full amount of these charges including any missing/damages items. I agree that if an attorney is retained to collect these charges, I will pay all reasonable attorney’s fees and costs incurred. If payment is by credit card you are authorized to charge my account for all charges incurred, including any and all damages/missing items, etc. I agree that the sole purpose of renting this room is for my own residency only.';

export const acceptedUserList = [
  '621da15492136241fa97c37d', // Eunice admin
  '5bc40e3561f43c781215c981', // Jayden
  '61d011ebcfa2731ae09444b2' // Benny
  // '61a0a826cfa2731ae04bf3e3' // Johnson
];

export const SuperAdminList = [
  '621da15492136241fa97c37d', // Eunice admin
  '5bc40e3561f43c781215c981', // Jayden
  '61d011ebcfa2731ae09444b2', // Benny
  '61a0a826cfa2731ae04bf3e3', // Johnson
  '631969b4c560f80f72b553c2' // Harris
];

export const AIRBNB_REVIEW_CATEGORY = [
  { tag: 'host_review_guest_positive_neat_and_tidy', category: 'cleanliness', description: 'Neat & tidy' },
  { tag: 'host_review_guest_positive_kept_in_good_condition', category: 'cleanliness', description: 'Kept in good condition' },
  { tag: 'host_review_guest_positive_took_care_of_garbage', category: 'cleanliness', description: 'Took care of garbage' },
  { tag: 'host_review_guest_negative_ignored_checkout_directions', category: 'cleanliness', description: 'Ignored check-out directions' },
  { tag: 'host_review_guest_negative_garbage', category: 'cleanliness', description: 'Excessive garbage' },
  { tag: 'host_review_guest_negative_messy_kitchen', category: 'cleanliness', description: 'Messy kitchen' },
  { tag: 'host_review_guest_negative_damage', category: 'cleanliness', description: 'Damaged property' },
  { tag: 'host_review_guest_negative_ruined_bed_linens', category: 'cleanliness', description: 'Ruined bed linens' },
  { tag: 'host_review_guest_negative_arrived_early', category: 'respect_house_rules', description: 'Arrived too early' },
  { tag: 'host_review_guest_negative_stayed_past_checkout', category: 'respect_house_rules', description: 'Stayed past checkout' },
  { tag: 'host_review_guest_negative_unapproved_guests', category: 'respect_house_rules', description: 'Unapproved guests' },
  { tag: 'host_review_guest_negative_unapproved_pet', category: 'respect_house_rules', description: 'Unapproved pet' },
  { tag: 'host_review_guest_negative_did_not_respect_quiet_hours', category: 'respect_house_rules', description: 'Didn’t respect quiet hours' },
  { tag: 'host_review_guest_negative_unapproved_filming	', category: 'respect_house_rules', description: 'Unapproved filming or photography' },
  { tag: 'host_review_guest_negative_unapproved_event', category: 'respect_house_rules', description: 'Unapproved event' },
  { tag: 'host_review_guest_negative_smoking', category: 'respect_house_rules', description: 'Smoking' },
  { tag: 'host_review_guest_positive_helpful_messages', category: 'communication', description: 'Helpful messages' },
  { tag: 'host_review_guest_positive_respectful', category: 'communication', description: 'Respectful' },
  { tag: 'host_review_guest_positive_always_responded', category: 'communication', description: 'Always responded' },
  { tag: 'host_review_guest_negative_unhelpful_messages', category: 'communication', description: 'Unhelpful responses' },
  { tag: 'host_review_guest_negative_disrespectful', category: 'communication', description: 'Disrespectful' },
  { tag: 'host_review_guest_negative_unreachable', category: 'communication', description: 'Unreachable' },
  { tag: 'host_review_guest_negative_slow_responses', category: 'communication', description: 'Slow responses' }
];

export const AIRBNB_GUEST_REVIEW_CATEGORY = [
  { tag: 'guest_review_host_positive_looked_like_photos', category: 'accuracy', description: 'Looked like the photos' },
  { tag: 'guest_review_host_positive_matched_description', category: 'accuracy', description: 'Matched the description' },
  { tag: 'guest_review_host_positive_had_listed_amenities_and_services', category: 'accuracy', description: 'Had listed amenities & services' },
  { tag: 'guest_review_host_negative_smaller_than_expected', category: 'accuracy', description: 'Smaller than expected' },
  { tag: 'guest_review_host_negative_did_not_match_photos', category: 'accuracy', description: 'Didn’t match the photos' },
  { tag: 'guest_review_host_negative_needs_maintenance', category: 'accuracy', description: 'Needs maintenance' },
  { tag: 'guest_review_host_negative_unexpected_fees', category: 'accuracy', description: 'Unexpected fees' },
  { tag: 'guest_review_host_negative_excessive_rules', category: 'accuracy', description: 'Excessive rules' },
  { tag: 'guest_review_host_negative_unexpected_noise', category: 'accuracy', description: 'Unexpected noise' },
  { tag: 'guest_review_host_negative_inaccurate_location', category: 'accuracy', description: 'Inaccurate location' },
  { tag: 'guest_review_host_negative_missing_amenity', category: 'accuracy', description: 'Missing amenity or service' },
  { tag: 'guest_review_host_negative_broken_or_missing_lock', category: 'accuracy', description: 'Broken or missing lock on door' },
  { tag: 'guest_review_host_negative_unexpected_guests	', category: 'accuracy', description: 'Unexpected guest(s) in space' },
  { tag: 'guest_review_host_negative_incorrect_bathroom', category: 'accuracy', description: 'Incorrect bathroom type' },
  { tag: 'guest_review_host_positive_responsive_host', category: 'checkin', description: 'Responsive host' },
  { tag: 'guest_review_host_positive_clear_instructions', category: 'checkin', description: 'Clear instructions' },
  { tag: 'guest_review_host_positive_easy_to_find	', category: 'checkin', description: 'Easy to find' },
  { tag: 'guest_review_host_positive_easy_to_get_inside', category: 'checkin', description: 'Easy to get inside' },
  { tag: 'guest_review_host_positive_flexible_check_in', category: 'checkin', description: 'Flexible check-in' },
  { tag: 'guest_review_host_negative_hard_to_locate', category: 'checkin', description: 'Hard to locate' },
  { tag: 'guest_review_host_negative_unclear_instructions', category: 'checkin', description: 'Unclear instructions' },
  { tag: 'guest_review_host_negative_trouble_with_lock', category: 'checkin', description: 'Trouble with lock' },
  { tag: 'guest_review_host_negative_unresponsive_host', category: 'checkin', description: 'Unresponsive Host' },
  { tag: 'guest_review_host_negative_had_to_wait', category: 'checkin', description: 'Had to wait' },
  { tag: 'guest_review_host_negative_hard_to_get_inside', category: 'checkin', description: 'Hard to get inside' },
  { tag: 'guest_review_host_positive_felt_at_home', category: 'checkin', description: 'Felt right at home' },
  { tag: 'guest_review_host_positive_spotless_furniture_and_linens', category: 'cleanliness', description: 'Spotless furniture & linens' },
  { tag: 'guest_review_host_positive_free_of_clutter', category: 'cleanliness', description: 'Free of clutter' },
  { tag: 'guest_review_host_positive_squeaky_clean_bathroom	', category: 'cleanliness', description: 'Squeaky-clean bathroom' },
  { tag: 'guest_review_host_positive_pristine_kitchen', category: 'cleanliness', description: 'Pristine kitchen' },
  { tag: 'guest_review_host_negative_dirty_or_dusty', category: 'cleanliness', description: 'Dirty or dusty' },
  { tag: 'guest_review_host_negative_noticeable_smell', category: 'cleanliness', description: 'Noticeable smell' },
  { tag: 'guest_review_host_negative_stains', category: 'cleanliness', description: 'Stains' },
  { tag: 'guest_review_host_negative_excessive_clutter', category: 'cleanliness', description: 'Excessive clutter' },
  { tag: 'guest_review_host_negative_messy_kitchen', category: 'cleanliness', description: 'Messy kitchen' },
  { tag: 'guest_review_host_negative_hair_or_pet_hair', category: 'cleanliness', description: 'Hair or pet hair' },
  { tag: 'guest_review_host_negative_dirty_bathroom', category: 'cleanliness', description: 'Dirty bathroom' },
  { tag: 'guest_review_host_negative_trash_left_behind', category: 'cleanliness', description: 'Trash left behind' },
  { tag: 'guest_review_host_positive_always_responsive', category: 'communication', description: 'Always responsive' },
  { tag: 'guest_review_host_positive_local_recommendations	', category: 'communication', description: 'Local recommendations' },
  { tag: 'guest_review_host_positive_proactive', category: 'communication', description: 'Proactive' },
  { tag: 'guest_review_host_positive_helpful_instructions', category: 'communication', description: 'Helpful instructions' },
  { tag: 'guest_review_host_positive_considerate', category: 'communication', description: 'Considerate' },
  { tag: 'guest_review_host_negative_slow_to_respond', category: 'communication', description: 'Slow to respond' },
  { tag: 'guest_review_host_negative_not_helpful', category: 'communication', description: 'Not helpful' },
  { tag: 'guest_review_host_negative_missing_house_instructions', category: 'communication', description: 'Missing house instructions' },
  { tag: 'guest_review_host_negative_unclear_checkout_tasks', category: 'communication', description: 'Unclear checkout tasks' },
  { tag: 'guest_review_host_negative_inconsiderate', category: 'communication', description: 'Inconsiderate' },
  { tag: 'guest_review_host_negative_excessive_checkout_tasks', category: 'communication', description: 'Excessive checkout tasks' },
  { tag: 'guest_review_host_positive_peaceful', category: 'location', description: 'Peaceful' },
  { tag: 'guest_review_host_positive_beautiful_surroundings	', category: 'location', description: 'Beautiful surroundings' },
  { tag: 'guest_review_host_positive_private', category: 'location', description: 'Private' },
  { tag: 'guest_review_host_positive_great_restaurants', category: 'location', description: 'Great restaurants' },
  { tag: 'guest_review_host_positive_lots_to_do', category: 'location', description: 'Lots to do' },
  { tag: 'guest_review_host_positive_walkable', category: 'location', description: 'Walkable' },
  { tag: 'guest_review_host_negative_noisy', category: 'location', description: 'Noisy' },
  { tag: 'guest_review_host_negative_not_much_to_do', category: 'location', description: 'Not much to do' },
  { tag: 'guest_review_host_negative_bland_surroundings', category: 'location', description: 'Bland surroundings' },
  { tag: 'guest_review_host_negative_not_private', category: 'location', description: 'Not private' },
  { tag: 'guest_review_host_negative_inconvenient_location', category: 'location', description: 'Inconvenient location' }
];

export const AIRBNB_CANCELLATION_POLICIES = [
  { code: 'flexible', label: 'Flexible' },
  { code: 'moderate', label: 'Moderate' },
  { code: 'better_strict_with_grace_period', label: 'Firm' },
  { code: 'strict_14_with_grace_period', label: 'Strict' },
  { code: 'super_strict_30', label: 'Super Strict 30 Days' },
  { code: 'super_strict_60', label: 'Super Strict 60 Days' },
  { code: 'firm_14', label: 'Firm 14 Days' }
];

export const parentProductCategory = [
  { label: 'System', value: 'system' },
  { label: 'Subscription Add-On', value: 'subscriptionAddOn' },
  { label: 'Host Protect', value: 'hostProtect', addOnAfter: '/unit' },
  { label: 'Integration', value: 'integration' },
  { label: 'Training', value: 'training', addOnAfter: '/session' },
  { label: 'MISC', value: 'misc' }
];

export const billingFunctions = [
  { label: 'Host Manage', value: 'hostManage', color: 'blue' },
  { label: 'Host Connect (OTAs)', value: 'hostConnect', color: 'yellow' },
  { label: 'DORA (Service Package, Expenses, Payout)', value: 'dora', color: 'pink' },
  { label: 'Host Protect', value: 'hostProtect', color: 'orange' },
  { label: 'Subscription Add On', value: 'subscriptionAddOn', color: 'green' }
];

export const defaultPricingModel = '66b4372d7e8539324c9a8516';

export const currencyLists = [
  { cc: 'AED', symbol: '\u062f.\u0625;', name: 'UAE dirham' },
  { cc: 'AFN', symbol: 'Afs', name: 'Afghan afghani' },
  { cc: 'ALL', symbol: 'L', name: 'Albanian lek' },
  { cc: 'AMD', symbol: 'AMD', name: 'Armenian dram' },
  { cc: 'ANG', symbol: 'NA\u0192', name: 'Netherlands Antillean gulden' },
  { cc: 'AOA', symbol: 'Kz', name: 'Angolan kwanza' },
  { cc: 'ARS', symbol: '$', name: 'Argentine peso' },
  { cc: 'AUD', symbol: '$', name: 'Australian dollar' },
  { cc: 'AWG', symbol: '\u0192', name: 'Aruban florin' },
  { cc: 'AZN', symbol: 'AZN', name: 'Azerbaijani manat' },
  { cc: 'BAM', symbol: 'KM', name: 'Bosnia and Herzegovina konvertibilna marka' },
  { cc: 'BBD', symbol: 'Bds$', name: 'Barbadian dollar' },
  { cc: 'BDT', symbol: '\u09f3', name: 'Bangladeshi taka' },
  { cc: 'BGN', symbol: 'BGN', name: 'Bulgarian lev' },
  { cc: 'BHD', symbol: '.\u062f.\u0628', name: 'Bahraini dinar' },
  { cc: 'BIF', symbol: 'FBu', name: 'Burundi franc' },
  { cc: 'BMD', symbol: 'BD$', name: 'Bermudian dollar' },
  { cc: 'BND', symbol: 'B$', name: 'Brunei dollar' },
  { cc: 'BOB', symbol: 'Bs.', name: 'Bolivian boliviano' },
  { cc: 'BRL', symbol: 'R$', name: 'Brazilian real' },
  { cc: 'BSD', symbol: 'B$', name: 'Bahamian dollar' },
  { cc: 'BTN', symbol: 'Nu.', name: 'Bhutanese ngultrum' },
  { cc: 'BWP', symbol: 'P', name: 'Botswana pula' },
  { cc: 'BYR', symbol: 'Br', name: 'Belarusian ruble' },
  { cc: 'BZD', symbol: 'BZ$', name: 'Belize dollar' },
  { cc: 'CAD', symbol: '$', name: 'Canadian dollar' },
  { cc: 'CDF', symbol: 'F', name: 'Congolese franc' },
  { cc: 'CHF', symbol: 'Fr.', name: 'Swiss franc' },
  { cc: 'CLP', symbol: '$', name: 'Chilean peso' },
  { cc: 'CNY', symbol: '\u00a5', name: 'Chinese/Yuan renminbi' },
  { cc: 'COP', symbol: 'Col$', name: 'Colombian peso' },
  { cc: 'CRC', symbol: '\u20a1', name: 'Costa Rican colon' },
  { cc: 'CUC', symbol: '$', name: 'Cuban peso' },
  { cc: 'CVE', symbol: 'Esc', name: 'Cape Verdean escudo' },
  { cc: 'CZK', symbol: 'K\u010d', name: 'Czech koruna' },
  { cc: 'DJF', symbol: 'Fdj', name: 'Djiboutian franc' },
  { cc: 'DKK', symbol: 'Kr', name: 'Danish krone' },
  { cc: 'DOP', symbol: 'RD$', name: 'Dominican peso' },
  { cc: 'DZD', symbol: '\u062f.\u062c', name: 'Algerian dinar' },
  { cc: 'EEK', symbol: 'KR', name: 'Estonian kroon' },
  { cc: 'EGP', symbol: '\u00a3', name: 'Egyptian pound' },
  { cc: 'ERN', symbol: 'Nfa', name: 'Eritrean nakfa' },
  { cc: 'ETB', symbol: 'Br', name: 'Ethiopian birr' },
  { cc: 'EUR', symbol: '\u20ac', name: 'European Euro' },
  { cc: 'FJD', symbol: 'FJ$', name: 'Fijian dollar' },
  { cc: 'FKP', symbol: '\u00a3', name: 'Falkland Islands pound' },
  { cc: 'GBP', symbol: '\u00a3', name: 'British pound' },
  { cc: 'GEL', symbol: 'GEL', name: 'Georgian lari' },
  { cc: 'GHS', symbol: 'GH\u20b5', name: 'Ghanaian cedi' },
  { cc: 'GIP', symbol: '\u00a3', name: 'Gibraltar pound' },
  { cc: 'GMD', symbol: 'D', name: 'Gambian dalasi' },
  { cc: 'GNF', symbol: 'FG', name: 'Guinean franc' },
  { cc: 'GQE', symbol: 'CFA', name: 'Central African CFA franc' },
  { cc: 'GTQ', symbol: 'Q', name: 'Guatemalan quetzal' },
  { cc: 'GYD', symbol: 'GY$', name: 'Guyanese dollar' },
  { cc: 'HKD', symbol: 'HK$', name: 'Hong Kong dollar' },
  { cc: 'HNL', symbol: 'L', name: 'Honduran lempira' },
  { cc: 'HRK', symbol: 'kn', name: 'Croatian kuna' },
  { cc: 'HTG', symbol: 'G', name: 'Haitian gourde' },
  { cc: 'HUF', symbol: 'Ft', name: 'Hungarian forint' },
  { cc: 'IDR', symbol: 'Rp', name: 'Indonesian rupiah' },
  { cc: 'ILS', symbol: '\u20aa', name: 'Israeli new sheqel' },
  { cc: 'INR', symbol: '\u20B9', name: 'Indian rupee' },
  { cc: 'IQD', symbol: '\u062f.\u0639', name: 'Iraqi dinar' },
  { cc: 'IRR', symbol: 'IRR', name: 'Iranian rial' },
  { cc: 'ISK', symbol: 'kr', name: 'Icelandic kr\u00f3na' },
  { cc: 'JMD', symbol: 'J$', name: 'Jamaican dollar' },
  { cc: 'JOD', symbol: 'JOD', name: 'Jordanian dinar' },
  { cc: 'JPY', symbol: '\u00a5', name: 'Japanese yen' },
  { cc: 'KES', symbol: 'KSh', name: 'Kenyan shilling' },
  { cc: 'KGS', symbol: '\u0441\u043e\u043c', name: 'Kyrgyzstani som' },
  { cc: 'KHR', symbol: '\u17db', name: 'Cambodian riel' },
  { cc: 'KMF', symbol: 'KMF', name: 'Comorian franc' },
  { cc: 'KPW', symbol: 'W', name: 'North Korean won' },
  { cc: 'KRW', symbol: 'W', name: 'South Korean won' },
  { cc: 'KWD', symbol: 'KWD', name: 'Kuwaiti dinar' },
  { cc: 'KYD', symbol: 'KY$', name: 'Cayman Islands dollar' },
  { cc: 'KZT', symbol: 'T', name: 'Kazakhstani tenge' },
  { cc: 'LAK', symbol: 'KN', name: 'Lao kip' },
  { cc: 'LBP', symbol: '\u00a3', name: 'Lebanese lira' },
  { cc: 'LKR', symbol: 'Rs', name: 'Sri Lankan rupee' },
  { cc: 'LRD', symbol: 'L$', name: 'Liberian dollar' },
  { cc: 'LSL', symbol: 'M', name: 'Lesotho loti' },
  { cc: 'LTL', symbol: 'Lt', name: 'Lithuanian litas' },
  { cc: 'LVL', symbol: 'Ls', name: 'Latvian lats' },
  { cc: 'LYD', symbol: 'LD', name: 'Libyan dinar' },
  { cc: 'MAD', symbol: 'MAD', name: 'Moroccan dirham' },
  { cc: 'MDL', symbol: 'MDL', name: 'Moldovan leu' },
  { cc: 'MGA', symbol: 'FMG', name: 'Malagasy ariary' },
  { cc: 'MKD', symbol: 'MKD', name: 'Macedonian denar' },
  { cc: 'MMK', symbol: 'K', name: 'Myanma kyat' },
  { cc: 'MNT', symbol: '\u20ae', name: 'Mongolian tugrik' },
  { cc: 'MOP', symbol: 'P', name: 'Macanese pataca' },
  { cc: 'MRO', symbol: 'UM', name: 'Mauritanian ouguiya' },
  { cc: 'MUR', symbol: 'Rs', name: 'Mauritian rupee' },
  { cc: 'MVR', symbol: 'Rf', name: 'Maldivian rufiyaa' },
  { cc: 'MWK', symbol: 'MK', name: 'Malawian kwacha' },
  { cc: 'MXN', symbol: '$', name: 'Mexican peso' },
  { cc: 'MYR', symbol: 'RM', name: 'Malaysian ringgit' },
  { cc: 'MZM', symbol: 'MTn', name: 'Mozambican metical' },
  { cc: 'NAD', symbol: 'N$', name: 'Namibian dollar' },
  { cc: 'NGN', symbol: '\u20a6', name: 'Nigerian naira' },
  { cc: 'NIO', symbol: 'C$', name: 'Nicaraguan c\u00f3rdoba' },
  { cc: 'NOK', symbol: 'kr', name: 'Norwegian krone' },
  { cc: 'NPR', symbol: 'NRs', name: 'Nepalese rupee' },
  { cc: 'NZD', symbol: 'NZ$', name: 'New Zealand dollar' },
  { cc: 'OMR', symbol: 'OMR', name: 'Omani rial' },
  { cc: 'PAB', symbol: 'B./', name: 'Panamanian balboa' },
  { cc: 'PEN', symbol: 'S/.', name: 'Peruvian nuevo sol' },
  { cc: 'PGK', symbol: 'K', name: 'Papua New Guinean kina' },
  { cc: 'PHP', symbol: '\u20b1', name: 'Philippine peso' },
  { cc: 'PKR', symbol: 'Rs.', name: 'Pakistani rupee' },
  { cc: 'PLN', symbol: 'z\u0142', name: 'Polish zloty' },
  { cc: 'PYG', symbol: '\u20b2', name: 'Paraguayan guarani' },
  { cc: 'QAR', symbol: 'QR', name: 'Qatari riyal' },
  { cc: 'RON', symbol: 'L', name: 'Romanian leu' },
  { cc: 'RSD', symbol: 'din.', name: 'Serbian dinar' },
  { cc: 'RUB', symbol: 'R', name: 'Russian ruble' },
  { cc: 'SAR', symbol: 'SR', name: 'Saudi riyal' },
  { cc: 'SBD', symbol: 'SI$', name: 'Solomon Islands dollar' },
  { cc: 'SCR', symbol: 'SR', name: 'Seychellois rupee' },
  { cc: 'SDG', symbol: 'SDG', name: 'Sudanese pound' },
  { cc: 'SEK', symbol: 'kr', name: 'Swedish krona' },
  { cc: 'SGD', symbol: 'S$', name: 'Singapore dollar' },
  { cc: 'SHP', symbol: '\u00a3', name: 'Saint Helena pound' },
  { cc: 'SLL', symbol: 'Le', name: 'Sierra Leonean leone' },
  { cc: 'SOS', symbol: 'Sh.', name: 'Somali shilling' },
  { cc: 'SRD', symbol: '$', name: 'Surinamese dollar' },
  { cc: 'SYP', symbol: 'LS', name: 'Syrian pound' },
  { cc: 'SZL', symbol: 'E', name: 'Swazi lilangeni' },
  { cc: 'THB', symbol: '\u0e3f', name: 'Thai baht' },
  { cc: 'TJS', symbol: 'TJS', name: 'Tajikistani somoni' },
  { cc: 'TMT', symbol: 'm', name: 'Turkmen manat' },
  { cc: 'TND', symbol: 'DT', name: 'Tunisian dinar' },
  { cc: 'TRY', symbol: 'TRY', name: 'Turkish new lira' },
  { cc: 'TTD', symbol: 'TT$', name: 'Trinidad and Tobago dollar' },
  { cc: 'TWD', symbol: 'NT$', name: 'New Taiwan dollar' },
  { cc: 'TZS', symbol: 'TZS', name: 'Tanzanian shilling' },
  { cc: 'UAH', symbol: 'UAH', name: 'Ukrainian hryvnia' },
  { cc: 'UGX', symbol: 'USh', name: 'Ugandan shilling' },
  { cc: 'USD', symbol: 'US$', name: 'United States dollar' },
  { cc: 'UYU', symbol: '$U', name: 'Uruguayan peso' },
  { cc: 'UZS', symbol: 'UZS', name: 'Uzbekistani som' },
  { cc: 'VEB', symbol: 'Bs', name: 'Venezuelan bolivar' },
  { cc: 'VND', symbol: '\u20ab', name: 'Vietnamese dong' },
  { cc: 'VUV', symbol: 'VT', name: 'Vanuatu vatu' },
  { cc: 'WST', symbol: 'WS$', name: 'Samoan tala' },
  { cc: 'XAF', symbol: 'CFA', name: 'Central African CFA franc' },
  { cc: 'XCD', symbol: 'EC$', name: 'East Caribbean dollar' },
  { cc: 'XDR', symbol: 'SDR', name: 'Special Drawing Rights' },
  { cc: 'XOF', symbol: 'CFA', name: 'West African CFA franc' },
  { cc: 'XPF', symbol: 'F', name: 'CFP franc' },
  { cc: 'YER', symbol: 'YER', name: 'Yemeni rial' },
  { cc: 'ZAR', symbol: 'R', name: 'South African rand' },
  { cc: 'ZMK', symbol: 'ZK', name: 'Zambian kwacha' },
  { cc: 'ZWR', symbol: 'Z$', name: 'Zimbabwean dollar' }
];

export const languageOptions = [
  { key: 'en-US', label: 'English', flagUrl: usFlag, value: 'en-US' },
  { key: 'zh-CN', label: '简体中文', flagUrl: chFlag, value: 'zh-CN' },
  { key: 'zh-TW', label: '繁體中文', flagUrl: chFlag, value: 'zh-TW' },
  { key: 'th-TH', label: 'ภาษาไทย', flagUrl: thFlag, value: 'th-TH' },
  { key: 'ms-MY', label: 'Bahasa Malaysia', flagUrl: myFlag, value: 'ms-MY' },
  { key: 'id-ID', label: 'Bahasa Indonesia', flagUrl: idFlag, value: 'id-ID' }
];
// Add more languages as needed
export const listingDeletionReasons = [
  { label: 'Returned to owner', key: 'Returned to owner', value: 0 },
  { label: 'Convert to long stay', key: 'Convert to long stay', value: 1 },
  { label: 'Duplicate listing', key: 'Duplicate listing', value: 2 },
  { label: 'Venture to others business', key: 'Venture to others business', value: 3 },
  { label: 'Change PMS/Channel manager', key: 'Change PMS/Channel manager', value: 4 },
  { label: 'Wrong creation', key: 'Wrong creation', value: 5 }
];

// Special Host IDs
export const SPECIAL_HOST_IDS = [
  '67b834191b208904d0b94070',
  '67a0205060c37704799b183d',
  '67f676bee83b745d0454480f',
  //testing id (63171c26bd45a051211e8d81)
  '63171c26bd45a051211e8d81'
];

// Hosts allowlisted for the Stripe security-deposit pre-auth feature (production rollout).
export const PREAUTH_HOST_IDS = [
  '6278ae7546cba778003b0251', // Riskolution Advisory Sdn Bhd
  '699eb8bd59bcec03f16afe5f', // KAMII STAY (M) SDN. BHD.
  '5e2692104be7845599b3d2fe' // Demo Host 01
];

export const MSU_HOST = ['67a0205060c37704799b183d'];

export const SELANGOR_DREDGING_BERHAD_HOST_ID = '69a9312af0cce203b2e81e8f'; //// Selangor Dredging Berhad or SDB Management Services Sdn Bhd
// export const SELANGOR_DREDGING_BERHAD_HOST_ID = '5e2692104be7845599b3d2fe'; //// Demo Host 01

// VEEDU HAUZ HOST ID
export const VEEDU_HAUZ_HOST_ID = '63ac0518f3fb6d3b6b8141ff';

// MapleHome
export const MAPLEHOME_HOST_IDS = [
  '5ca17d46124e180f8e0628e7', // Maplehome
  '6075025a04ed5b2c0aac2204' // Maplehome - Romanee Conte Estate Management Sdn Bhd
];

export const OTA_CHAT_ALLOWED_HOST_IDS = [
  '6406eec0c1cc933f2ef481cd', // Alviv
  '666c1c2a809745541f51c1b6', // Ecoprop
  '65f96e6fd6a30f04ce61356d', //BNB4U
  '661014a3fd8f251ea07fbc0c', //Irumah Resources (child host of BNB4U)
  '69083aaa29ea8f03c16adf8f', // Silaslee Management Sdn Bhd
  '624a573db4e53f6c30a13d83', // Anju
  '65489df987e4b0581506cbbc', // Helios Management

  '64cb6953431a150a9ae596cc', // Cowidea
  '5d5b898c035263118f4a5665', // Rentradise
  '65e7cb8e3a512004c59fd6be', // MW Hospitality
  '672c53785b47b804a0a282c2', // Gyden Staycation
  '642aa1995be811487227f38b', // R9
  '65c4a2808ae6d33c19f0e5f3', // Our Stay
  '635e877c68ee9f11fd0db197', // Comfort Places Management
  '6486d74428def204d4581643', // Nest Home
  '5dba518ee675a83d911da9ec', // Neofrontier

  '6364ddbd68ee9f11fdf0a293', // Guestonic,

  '5ca17d46124e180f8e0628e7', // Maplehome

  '6948f816806d1c03ea6b31ad', // Like Decoration Sdn. Bhd.
  '690d75234f4480038d41bbd0', // R.CHI IDEAS MANAGEMENT COMPANY
  '65165c773a2335081725fc98', // NGN Venture
  '636b76cf0453a17292fe200e', // Ecoland Design Sdn Bhd
  '63bbb0f21e3c672820963457', // Ecoland Design | SA
  '683563a1ce6e1c354f8cb51a', // Hey Guest House
  '694b5e6b5af71ebd143df1aa', // top well mamangement

  //batch 1
  '656553e281d80d04bec86a9a',
  '63574217bd08dd57e0cf3b11',
  '607ff4010f3a7420cf0c6a77',
  '643a85fdabfe36368777099b',
  '643e349f4c3c57648731d04d',
  '68da0f642f52430567c17bff',
  '6405ab1782d3ea319d1467f1',
  '623459ee80bf7768a07dec4d',
  '5dca71e853eab76fabe9fd3f',
  '621f15e26b1470485b543eca',
  '68d4acf51a47bf04e1e27cf9',
  '689063f5cc4c3804f546b3ee',
  '648ae24c3af3e80af918522b',
  '63686f3d1e8e845a0a5b0ad5',
  '64f6ea51e08871047da402e4',
  '633262dabd667445d038b2d7',
  '6806222da4a22504b48847a3',
  '651a4c0a63970f04da94504e',
  '6440f501a8a0fa7c77bdcc2a',
  '5c172b5f8741c42f97d8df47',
  '652f600376d8a9046b48242f',
  '659b9ac15b4b1804c801f46f',
  '614c39d7e5cf9a0ea83e8990',
  '67b827361b208904d0a8ed2f',
  '66b441b3781eed04f50b0738',
  '625d334b9d77d8017f85b84e',
  '65ae8f0f0f5e2b30d37d5c3e',
  '5cff3d026c2cfe3641bec9fa',
  '5fbf22ba840bdc681f49b073',
  '63832cd22171f004698bbaa7',
  '5def07af501eab720e3f4e4f',
  '5f44b7a64938a36e38133953',
  '5f83d440dfdef9468ff2d8e4',
  '5be150b8e786941f2f025a1e',
  '625d28769d77d8017f830ff2',
  '5c92ee62d694e43ea67f351c',
  '642123b688be93066c549fdf',
  '6499584d75217504fe02d811',
  '688c2ebd4e87eb1ffd589943',
  '637c4ad0b242b96788efeedd',
  '5d1313dbe11510281d02b931',
  '5cb69824fb6da76f2f70fd23',
  '5e216e365d96014437fd11a3',
  '5cc5c86117e7b112d38f7023',
  '5e1d686358beaa29ade35424',
  '5e4f6737505c895d0aa83648',
  '620a07ce77f16e54d4fee023',
  '6188a286cfa2731ae01f4db2',
  '5e1724bec1db8315c28beda1',
  '617bb96ae5cf9a0ea88132b4',
  '5dafa4a1edaabd1d8d9182cd',
  '5de4bfe4d187cc53c88799db',
  '5d35612794a65e10fdbfc27a',
  '5db8fd63e675a83d911d1c18',
  '61c542a2cfa2731ae0835b4d',
  '5d6dceea1de2163a1c0b2262',
  '5c37005cd10d1c2356c0fa5d',
  '5d6dd0bf1de2163a1c0b2342',
  '61d2c678cfa2731ae0992217',
  '5d7757412e27636416ee7023',
  '5faa74ef4610e548b1627c34',
  '6543315e23a53004a2b55b56',
  '6350cd1ccd62272ec1b8e138',
  '6350cc53cd62272ec1b87fdb',
  '5f7158ba746b1b21b13a9314',
  '651b7c3fdc350604eb024c16',
  '6650302c2e18d853d091e3a3',
  '5f2b72e8d0329854e7f57a2d',
  '5f2b7408d0329854e7f5847e',
  '628b388cb1c5952ddfff97a8',
  '636a1ca31e8e845a0ae0380e',
  '63d08d0c85ea6f2c7ade3e57',
  '64dee015f5b79504e4b41c45',
  '65cad36e47c2560a44f8c382',
  '5ddf438afa2bff3ed982dd7e',
  '5deb02f85bdfb8689e411e53',
  '60487c29ffbb45550d667a3c',
  '684a8fc0860c960520936824',
  '6278ae7546cba778003b0251',
  '636b76cf0453a17292fe200e',
  '63bbb0f21e3c672820963457',
  '63d36b9a85ea6f2c7afd27d8',
  '63858be0f3a7be2503a80ca8',
  '64e42c2913cb5304b8a33347',
  '67a57a3e905a3c04ec50e9c5',
  '6045b5be82be0e14a743a2c6',
  '67c9724362b58004c0df27c4',

  // batch 2
  '61d41478cfa2731ae09b038a',
  '61d4180acfa2731ae09b1e6d',
  '61e0f307cfa2731ae0b057eb',
  '61dfa27dcfa2731ae0ae4dd2',
  '621313f30c17e24fabe4e7ff',
  '6225964b83da0a65e79c2818',
  '608657e0ddc3d97c6a969087',
  '62c4ff9f24ca1d2c35a0d4d9',
  '62301839458e4617c2c2d3f2',
  '626bb82746cba7780040734b',
  '624e492b7c285914b8eae3c8',
  '62a69d2d2760d9153a623e7b',
  '62abf956e78f503f2b672e07',
  '6327f045bd667445d0e03ee5',
  '62beac6724ca1d2c35876635',
  '62d4c35ee9a8ba25e83e00a5',
  '637f23c9822e2b022ffdde04',
  '63b7ad9a90b38d535d803d11',
  '63218182bd667445d0b3fc31',
  '633675025ec1b7613097009c',
  '63ac0518f3fb6d3b6b8141ff',
  '63b54a2590b38d535d9f8b3e',
  '5e4b8e73fa120b4efd597753',
  '5f2b7c07d0329854e7f590ce',
  '6316fd1e59c0ca7bac2d9fe4',
  '651a6a9dccd3d00ea9fcdf1c',
  '5dc1114bbac0b75ed432a5ed',
  '5e8d2a264dfc3431ca28e26a',
  '5f6b04b22227311223b60113',
  '62b0316ae78f503f2b173e70',
  '67c97113a21bc668a96f81df',
  '67d1443da9e57f4ae2feade5',
  '67d267cac17a0f04ea4de2fe',
  '67d2a910ccec6154a6e9d79d',
  '67d7dbb773d9f204f4b6173d',
  '67dd3860e1a15c04d147d239',
  '67ef8baf6b1adf0535f9d997',
  '67f3a75cab4e6c04cc31b047',
  '67f79141e406b604c10f248a',
  '680769ba6f4e2b053be3097f',
  '680770206f4e2b053be7db5a',
  '68147e11619577052a36bfd3',
  '6826c431f5dc0b0527bdbfe4',
  '6834005b0d6f8304d198bbc3',
  '6836978d1df86408c86c3191',
  '683699d51df86408c87069ca',
  '683ff05255a5e677203c6ce8',
  '686242b02f3fc705599b49fb',
  '6874d10f6956a504f17a3b68',
  '687a23fe279e14051ef6378e',
  '68871aa5fcac3a090652147f',
  '688b40014e87eb1ffde695ef',
  '688b440944b0030a2ef9f6ae',

  // batch 3
  '5dad7343edaabd1d8d901045',
  '5cdb76f62bd9c06765cf5648',
  '5dc0e114bac0b75ed4326b06',
  '5ef00fd386f9a1383e326b7f',
  '5fc705c2efc8b4232879befb',
  '5c875bf64dbd1d752750b1f2',
  '5c8761d64dbd1d752750b24c',
  '5d2440ffe11510281d098864',
  '63842d20f9896e21dd7ef99e',
  '6396c5f77babcf15bed5984f',
  '639826d4427d6633902c46ee',
  '63982687427d6633902c0448',
  '63326372bd667445d038f8a1',
  '6331771bbd667445d00c8b6d',
  '5c88ac53255cdc01cd2b9a80',
  '5e0d9dd9b5a11a2598323633',
  '63b3a73e90b38d535deca1b6',
  '63b3a66490b38d535dec0765',
  '63b3a6cf90b38d535dec5d33',
  '63b3a7f990b38d535ded3b0d',
  '63fd706872e1d57847747359',
  '642130d400ceab07d863f1f2',
  '642e02bb5336c862dad56a32',
  '64706a4b9beefc03f159bd97',
  '64891935f0c1253bce76b3ae',
  '6499126807380e6671f2ca21',
  '64d982ef9499f3493ff0b94d',
  '64f94f35c9bec204998190e4',
  '6507b001826ecd04879a3b28',
  '6513e0f5e577fc04b19f6a38',
  '6548454b32473b04d024c981',
  '655577e67eb733121bec0606',
  '6565432a81d80d04bec20723',
  '6565439481d80d04bec21ca6',
  '6576a23afb72d0117871f27a',
  '657a864397dbc431399c0e62',
  '65b312fccf5ef80bcdd4ca55',
  '65b312b8cf5ef80bcdd4a9db',
  '65bb16c95d6f2f04d8a52ca3',
  '65bb1af95d6f2f04d8a70858',
  '65bb1b2ae50ac536d81cb9ae',
  '65c04bf88ae6d33c1974e246',
  '65dc4a990b888604c0aee186',
  '65e6d575a7d723681564b4b2',
  '6600db2fd7216941e6384664',
  '6603812646577c04b9693a89',
  '6603821846577c04b9699bec',
  '661e0b5a985e9b560332df67',
  '6638a8c63046d56a2f4e7781',
  '667a51823e873d0bb07696fe',
  '66a88496e03c9a04c639e309',
  '66b9a295c0b72004a1af06c6',
  '66d1ff0f23353005851842f7',
  '66d825e235bf322693eb473d',
  '66ebb8910411130517f8b89f',
  '66fe1efe25f11b4856a66041',
  '6705eb364e05f904dc9bf961',
  '67076e920dc4ea04aa685b7e',
  '67076e120dc4ea04aa6811e3',
  '6719e18a9b328804b37bf1d3',
  '673a86cabeffbc4e36e04956',
  '673a868abeffbc4e36e04246',
  '673c18413ab4cf5351443981',
  '673c18a03ab4cf5351446fcc',
  '673c18d63ab4cf5351449d92',
  '675bf1e7106b6f617353bf1e',
  '676d4edc8d39b704c55aca90',
  '676d4f0d8d39b704c55aef54',
  '677b6e1fac810c04b0ec2152',
  '67848b59a4dea513624fc561',
  '67848ae1abb89004e2d98a2a',
  '67b40705f79e2404f9effed9',
  '67b408333ca0fe04cf4b6a54',
  '67b4087ef79e2404f9f1aa43',
  '67b408bcde7bbd75a6857369',
  '67b409533ca0fe04cf4c85fa',
  '67b408f5f79e2404f9f21d3c',
  '67b833751b208904d0b84b15',
  '67d29293ccec6154a6d592c7',
  '67d292ddccec6154a6d5e1aa',
  '67c69a4ba21bc668a9081afa',
  '6801cceb9e0c191ca832ebe2',
  '6801cca89e0c191ca832a81e',
  '680edde653e17905152ce5b2',
  '68353f423679000537a6d3eb',
  '6835437e3679000537ad4336',
  '684a5d8dac03930543ca555c',
  '684a5ffba70bc3679e492fe0',
  '6851215e228ada0566396f2e',
  '685121c3228ada056639cb3e',
  '68664b1981fe3704f344a0e1',
  '686b85dfb3fcdb63adcaae12',
  '687461066d5e6504ad6133ff',
  '6874d3406d5e6504adf157d3',
  '6879ed1fff159742d2708416',
  '687d9823ad39184be1403087',
  '6889813144890119c1b98fd1',
  '6889824885f92919c1b224d3',
  '689d881437533958acb4e51a',
  '68d4af0f99acf8210d82dd72',
  '68de501a5dfb6e04bfd44fb6',
  '68e7679a1713e8047dad5158',
  '68f0c8e890c8f5048710e55b',
  '69131f1c0e1df0038c3133c9',
  '69131e568b9d5b0392319e8f',
  '691c3057d1277103a269b07d',
  '692939534bab3203e48a9356',
  '6937bf7bcb72ba1004eb6142',
  '6937bfb6cb72ba1004eb8eb0',
  '695f6f93e9af3d03b3cbd761',
  '695f6ee3d9de7203e857da22',
  '695f6f11c0fbc803a1fc72cb',
  '695f71bec0fbc803a10009d5',
  '6964f52d92b94603bcfa7849',
  '6964f5668c41d803cdbcc1f4',
  '6964f5d4e3585b491ee3fd69',
  '6964f6971002450a6bf00cae',
  '6964f7963c335003d03129fb',
  '6964f61992b94603bcfac99f',
  '6964f6e6b88ce303c3103df0',
  '6964f6571002450a6befe293',
  '6973457402d4f303d67c7e6d',
  '63ad3924f3fb6d3b6bfaa3e1',
  '63e332469c7a4b08869f0c71',
  '63c7b518d405f87c1baa4ad3',
  '63edf29f3aa3f301f7c6da72',
  '63fdca9672e1d57847b46077',
  '640ea0ee8127eb75430cebd1',
  '6412dcc668abe40f75f3f7f0',
  '64194eeb4dc95e1e84090341',
  '6421366500ceab07d866a129',
  '642669ca0f63932edc34c617',
  '6811c1bd7ba9fa05014a5353',
  '643599e3d1806e242fa33c39',
  '6448bb32cc0ccc05a2357576',
  '6437ce0dabfe363687732ef4',
  '64f5464c45722d649844ea01',
  '610cb2543eadb54198c14100',
  '5d47dce4d562c84ec2da02f4',
  '5caada6d9089043a095c1936',
  '5ea1158d0413816aa85cf1c3',
  '5de4d89fd187cc53c887ea0f',
  '5ff3f7eeaf61851289273bdf',
  '616cffebe5cf9a0ea86a56f3',
  '5f44c5594938a36e381351bc',
  '5c6a213184ba2267e8c6c5ba',
  '6397d379427d663390f9a9ac',
  '5ce79adbc8ccf50ddea766a2',
  '5d5a553118bd2a06a14bedf2',
  '61d41112cfa2731ae09af506',
  '61a471d5cfa2731ae054fd94',
  '625f724f96b0ba247b1cdfc6',
  '628365997c6ff108852562e5',
  '62a7f7c36fcc15260b9290eb',
  '62d4c59ce9a8ba25e83ea863',
  '62cd28d724ca1d2c350d9ae1',
  '62e73edce9a8ba25e8897cda',
  '63575e1ebd08dd57e0db70ca',
  '638819a2d5e2ea3eb8ab3939',
  '63d3595585ea6f2c7af39821',
  '5c1b077098ce0e5825380d86',
  '5dca5e1453eab76fabe9e913',
  '5cd13602fa9afc3aff98fe2d',
  '607a82fa0f3a7420cf08c95d',
  '6524b01d2ecd6a0498a5cb9f',

  // batch 4
  '64548c487156de1a8bd736ae',
  '6459f534acc7023a999b9ef9',
  '6462bea98bd93460d21fadbe',
  '646344ff8bd93460d26f2758',
  '64708b549beefc03f17a938b',
  '6475a49dc99fba0f66fbb4ea',
  '648c44ed3af3e80af90741a5',
  '64917edb2e75e33c66032da0',
  '64a39ba5a32ccc1c58b49d17',
  '64a54ad023f69d5da4c96ae0',
  '64a6a05d9d9f646e46d6ce06',
  '64a7e258a0b50f04ecde58ea',
  '64b8f5f86855d204c67179d4',
  '64c087d897a4ec04d3eb55d8',
  '64c8ceb38508ee48137b6196',
  '64c8db5e9f48bc0945fd899b',
  '64defece8f3db7052a120aed',
  '64e443a813cb5304b8aa8cea',
  '64e6b353247b1804ad06f7ef',
  '64eea1170ef6e94199701b6f',
  '64f54053bf70c704ae7695c7',
  '64f5464c45722d649844ea01',
  '64f54ba143646b04b21efa31',
  '64f550aebf70c704ae79e973',
  '64f6e24ce08871047da23edc',
  '6156d523e5cf9a0ea84f5ca4',
  '61d54d70cfa2731ae09c6676',
  '5e378ab9e038b10e9b42467d',
  '625649d1cc68b3636500596b',
  '62cd2b4a24ca1d2c350eaad6',
  '635b5ca59fac2a048d33e127',
  '5c9cbda89b628e7de1fcfc87',
  '5cd2775cfa9afc3aff99997e',
  '5d9c313a2b4d7a5bbcaf0ccc',
  '6237db6d80bf7768a0d53c5d',
  '6360921f68ee9f11fd9e19fb',
  '6360932568ee9f11fd9edaa1',
  '61dbe39bcfa2731ae0a8be28',
  '5f02c42605d2c05b91a193b1',
  '62383cae80bf7768a0e897af',
  '637499ae73414e29c2425026',
  '640ad2f131abea4a86f34654',
  '641173be10de5a78912096a9',
  '5d3555cb94a65e10fdbfbe10',
  '64218064ed44970a7311bac7',
  '642d4f5c5336c862dab433e8',
  '6449eacbba70d93a6f4e25aa',
  '645875637156de1a8b5f2f3a',
  '645da083f1c611547f522d7e',
  '64784c598d403d67fe18f600',

  // batch 5
  '64f6ea51e08871047da402e4',
  '650bdb3cb72ed0463e109f32',
  '65123d8ad7736567d4375c04',
  '6513e4c14caf8c046b4c62fb',
  '651f5d333a642a0475d0ea3e',
  '651f63cc66cec2049f5a7659',
  '65276885d51cba0498265e0c',
  '652ca866b2d98860c4ebeb1b',
  '652d02429db3ef629a2c26d7',
  '652f600376d8a9046b48242f',
  '6530b646a1b8d670c6081b57',
  '6539c98d02f3e71924a00d4a',
  '6541b30f891e683c0c122c1e',
  '654840ce87e4b05815e94f61',
  '6556d3c30d40eb046abc791a',
  '656d53ccafccc904a00bdae5',
  '65795bd94a6c220491e569d7',
  '657a8ca997dbc431399f5dab',
  '657a927497dbc43139a206f6',
  '657aa3ad03790708af73f69a',
  '6583d7b2d1f7b34f8c3cda23',
  '658a7f77ac7e0b64cdb62d43',
  '67511c8922e5dd049b44f403',
  '6594c685a6750d1a1ab85f7a',
  '624bf6cf7c285914b8ac5b08',
  '6833d1a176a31004823ec5f2',
  '659b9ac15b4b1804c801f46f',
  '659fb0298e086b0134874f6a',
  '65165c773a2335081725fc98',
  '651bc983d9c4761767a986a7',
  '651beb0ed9c4761767b376e6',
  '651e960b1fcbe604ab0def38',
  '652d03730b322d08aa3e5f0a',
  '652f3cc976d8a9046b3d0dcf',
  '652fbb895c357b0864e6a3d8',
  '653a09b5fcb478049472cec9',
  '6540636b08dc11347eae3f0b',
  '68e6036a757a7704b9e5b08d',
  '6542177c891e683c0c3a2ca0',
  '6549964bbc18c804a907f4ce',
  '657677cc869c2c04b182680f',
  '657a804b475abd08818180f3',
  '657a8c2897dbc431399f264f',
  '65855fb830062b048ffc6c3d',
  '6549fea30819110478f44128',
  '65840707d1f7b34f8c5c1346',
  '6594bf00870e2404e87c3a03',
  '65a4dbaa9b571d04773dfa1c',
  '65a4bb499b571d04772f6063',
  '65a50ca89b571d047756fa45',
  '65a781c37ce01f04b33f309f',
  '65ae40750f5e2b30d365124c',
  '65c1e1e1d3adcc04d859d778',
  '651fb97d66cec2049f71440f',

  // batch 6
  '65ae7007c35cd604d4c8c0af',
  '65b73b40ef2c042207508cf3',
  '65b741a5ef2c04220752ff04',
  '65c1d3e78ae6d33c19f76efc',
  '65de9be924115e4b84d37f78',
  '65e7c52ea7d7236815a417bd',
  '65e7cb8e3a512004c59fd6be',
  '65e95455a7d72368154395f6',
  '6437c1aeabfe3636876a0459',
  '65fd340bd7216941e6446984',
  '661ddfe56c998c04b928bf5d',
  '661f8cde985e9b5603bb4e25',
  '6633678b919ae708788a2ffa',
  '6642aafe0f1f7404b54b02e2',
  '6642afcc0f1f7404b54b8a62',
  '6642b37b50810410ac9917c3',
  '666029bd09667304b9a11a92',
  '6672aea9966add04a8301d7c',
  '6678ec703e873d0bb02b21d4',
  '667a288b512f2904dc6dbb9d',
  '65139590e577fc04b18baec8',
  '5f58e6d9cf979451aaa3ffe4',
  '66837d1265e8670502759acd',
  '6683818cd972d4053f267fad',
  '668381efd972d4053f26d290',
  '6864c9bd7294a805971a362c',
  '6683903265e8670502844fb7',
  '6684e1b3539bd904e899edeb',
  '668dec1e39df6504f42a3f3e',
  '66a9b15e6b2f8b04fffbac97',
  '65c47f568ae6d33c19d7f0d1',
  '6826c4f6f5dc0b0527beb4d9',
  '6826c3caf5dc0b0527bd1bbd',
  '6826c6aa776fa605378a73f5',
  '65c4a2808ae6d33c19f0e5f3',
  '65e96e750fe4b30485c2269f',
  '660bc22b80d838091d303ecd',
  '660bc41f80d838091d3191ff',
  '661cf96d85f3694fa27b20eb',
  '6621f438985e9b56039713e8',
  '662794f8b29e681ea663ae47',
  '662a14346d0c9f04e67b25b2',
  '664aefe6e7758b2f4e71e60e',
  '664ef74b4c6f1c04e8e2dd8d',
  '666a7675b8c6211684ad98a4',
  '66729eaa3587156de2606f48',
  '6678ec8521bf5f04cf984e9d',
  '667b9110b47fc204c0b723ca',
  '667ccdd298e891053d3e5e74',
  '668df1a539df6504f42da05e',
  '668f5bba9dccc604714bfe10',
  '66ac8453972567086c139e56',
  '66b0a9a8ee84eb04dcbe09dc',
  '66bb105345b3c4049c0ccdff',
  '66d6acd067553f04fca78759',
  '66dac0229f200230b28e0dd6',
  '66e256edb9122704a9924257',
  '66ea7ab2396f4e70e0e8344f',
  '66ac68b3584c096d30e7c59b',
  '5cee2de685066b295a2984ed',
  '617e84e77cd4875ba5470ce4',
  '66ac830d972567086c11f6e8',
  '635a75c1d470e07c0f21f5cb',

  // batch 7
  '66b44639781eed04f50f8c3a',
  '66b438066cbc9f109d7cc43f',
  '66b441b3781eed04f50b0738',
  '66bc2c2313f74004a375476d',
  '66d95c0335bf3226939dd453',
  '66dae0629f200230b2ab2b40',
  '66dfaa8b09125a04e1710fe5',
  '66e108ad5c54930504c48a5d',
  '66f3a8903c1db3055a8cca69',
  '66fa5c1ce4356504b92b1cb2',
  '66ff5ef622060e4f1df5ca6d',
  '6706219788e8bc04b8c11923',
  '670c9619345b9304729e39bd',
  '679236865ae15304e8783be1',
  '670f42448fccc104f3506fb9',
  '6711eeb7dc209204e540734d',
  '6717309e539750048fed8670',
  '671f1dcae1528c53b8eda829',
  '670f88181800fd0474031e8e',
  '6721d46e0351d504b294062b',
  '6728826c1dd97804d6880417',
  '6729df330fe6dd04b8316cec',
  '672adc9b36edd60a767d16f1',
  '672b1b4c36edd60a76ac0ecc',
  '67319362ab60ca27409b31f1',
  '66eaaf0d396f4e70e01bc8e8',
  '66f63460851d6c04f0a0e91c',
  '66fa5e3de4356504b92cdcbd',
  '66fdffc25ac0b5050938f2ea',
  '670f21826c529804d94dac66',
  '6715fb256cc20d04d2f8696f',
  '67172d78cd7832049668f512',
  '67501abf23f53d0496e1380e',
  '675aa0499caeaa04a81758c8',
  '675fa70b7420c06fb0ba6e45',
  '67690fede8be8804e5216a99',
  '677f583bf0366e0507bdeff2',
  '657a9c3997dbc43139a6a9ec',
  '688c6756cc4c3804f5b0fa65',
  '688b43a344b0030a2ef9cd8e',
  '68a699478ab99c051034461c',
  '68c0f73eaef9fe0a0bc186fa',
  '68da0171f5f91b38378d269d',
  '6549fea30819110478f44128',
  '68ef2ae0a27aff04b4fde9b3',
  '68f718457215592b312e9a20',
  '68ff38dbe92e4d15100ce45c',
  '68ff3cfae92e4d1510115c16',
  '69004b8befd2730d5b9ffb0b',
  '69083aaa29ea8f03c16adf8f',
  '690d75234f4480038d41bbd0',
  '691c2e79ed4bce53cbdcd790',
  '692e60838835de8116e3f577',
  '693bed799c168c03d641e621',
  '693beb6592789303a7789c5c',
  '693fb9c14f42a003dc1d600a',
  '6948f0c23b317803c7127fa5',
  '6948f471806d1c03ea64fc6a',
  '6948f816806d1c03ea6b31ad',
  '694b5c8b2ac45803e173fa15',
  '6960ab074addbd04048b704a',
  '696de59269fd6314b2272ca2',
  '6983129905299003d15d7ee4',
  '69844c0b1dffc403e60169cb',
  '698ab5a1edba2a03f3e82be1',
  '68a3f371779c1905093dfea2',
  '68a829856b4e9e050d29386e',
  '68b6964162c3ea04f692716d',
  '68db862fc5f96f04bf686ad1',
  '68f1aa251a86330eb34ac18d',
  '68f853ab00877875f4e15775',
  '68fae872efd2730d5b8b8118',
  '690040a722eb4e27ad1e6bb8',
  '690428c588f6a9038a86e4a0',
  '690db178a3eb1bbfc9cd1c95',
  '692e64020efbf503e7d4f9dc',
  '6943d24656510e03e8cd1d2e',
  '686b94ceb3fcdb63adde7b53',
  '69845a231dffc403e60f4276',
  '698ed85c57a7530632a9e349',
  '67353b5b13c6363884fca724',
  '673c1b293ab4cf5351464a32',
  '67492918d1f63304c0418a20',
  '67567a9f0b3c8e045e163613',
  '67721bafb4fc8904bd0004ae',
  '68ce1803b5be770491e31af5',
  '6777437a24522d04d2ac2c61',
  '677ca518474ac604d98c3f79',
  '677f2e8fbe4e9d7c7e49a881',
  '67972a8a8caed30483968726',
  '67ac19d5e9c38e04dfd686ee',
  '67c9735ca21bc668a9709614',
  '67caa912deb3d604b8512011',
  '67d297a0ccec6154a6daa6e3',
  '67d41deb7b21fb08dfcad3d2',
  '67d7e7aa65a6d605165dc13f',
  '67dd25460d10ac049b844b9b',
  '67edf66d33a0f34d75b3ede9',
  '67fe10ad9e0c191ca88fb2e3',
  '6822efa41b7d2239b71383e8',
  '68342db65e4eba052da09b74',
  '683563a1ce6e1c354f8cb51a',
  '6836bcbebb918c3d5c8194e7',
  '683fd7f755a5e6772020c08f',
  '6848e72446417860b1aaeb09',
  '68524ce789774204ec1afb32',
  '685ccbd1a3684e24db324cf8',
  '68678d549382f30512f8a848',
  '686b2c8ac12d9904d9002899',
  '686b7c8c4eff2604ebb53c21',
  '68d6749d99acf8210d349c1e',
  '6878cb50492e5c3d078c167b',
  '687a1421843509051723edfc',
  '687d993dd6c14504def62076',
  '688109ba1357420992ad0bc0',
  '68810ecec409966c49c1422d',
  '67248cb4ad4a5904f52a144a',
  '5dbfd613ec00b55697230d83',
  '61b84ae0cfa2731ae0730929',
  '61bb5b52cfa2731ae076ff5b',
  '635b3f56af251e7e988bede0',
  '635e877c68ee9f11fd0db197',
  '63bcdc322aefdf33bf315fd8',
  '6196079acfa2731ae03782c5',
  '639800c6427d663390173887',
  '6397fc2a427d6633901447b5',
  '63980019427d66339016c7f5',
  '6397ffa6427d663390169f3a',
  '5de4c542d187cc53c8879ea8',
  '5de4dda8d187cc53c887f420',
  '5de4db3bd187cc53c887f0e1',
  '5d7763ed2e27636416ee7c02',
  '623aed7280bf7768a033ee43',
  '6405ba33239cf2343e4659e7',
  '64e5db214d724909e8bca221',
  '64f6c8a1e08871047d9b726b',
  '66865ed404596b0500e0ccb3',
  '652ca356f0f9bb0476c27c9d',
  '64a7dfb9c4ac681152c9b3d0',
  '64aceb3bb7ddc0048c1aec98',
  '64c8b75e9f48bc0945f29cc7',
  '64d0c6a77f86b3102365986f',
  '639826e2427d6633902c54af',
  '63ea09b5ec6f466812cc0693',
  '68901a4644a30b2a5ef61c84',
  '68a2c5ada5cc820fc9c63e41',
  '68a6b4a39e475010a9e14f4c',
  '68b6ab6e30029104c946bfb3',
  '68be8a333c1aea22c95f244f',
  '68c3fc1fd1ce1105020d3a09',
  '68d648371a47bf04e154805b',
  '65a784c37ce01f04b3419273',
  '68ef296f90c8f50487d80cb5',
  '68f8901c2b847b04f36087f2',
  '690055397aae2c0d5459c924',
  '69018e6b22eb4e27ad45f6d4',
  '6909d76f29ea8f03c1480641',
  '690d6d7f3f566d038d90ff44',
  '6914202dbb23111236e33eca',
  '6925246d24e9b103a185f4c8',
  '6930f04ed8c44903d1a8c658',
  '6932ab98053b25d6764b793d',
  '694b5e6b5af71ebd143df1aa',
  '6954d5798dcf2703b7e800e9',
  '695f7511d9de7203e85f84fb',
  '696df6e09b1c2cb9218393f0',
  '698411fe1c3e17c1d052ce58',
  '69a50a30449fb8041771fa1f',
  '6502de954ce52723e959add1',
  '62789b3f46cba77800368cc2',
  '62fc5c7ee9a8ba25e8570301'
];

export const ACCESS_TOKEN_ADMINS = [
  // Production
  '631969b4c560f80f72b553c2', // harris_teo@hostplatform.com
  '61a0a826cfa2731ae04bf3e3', // johnson@hostplatform.com
  '61d011ebcfa2731ae09444b2', // benny@hostplatform.com
  '65e13d1ad9b1bf04d15afdd2', // sam@hostplatform.com
  '621da15492136241fa97c37d', // eunice@hostplatform.com
  '6948cba304ea86a60b965a0d', // clara@hostplatform.com
  '5d9415ad3abe041c073448ab', // derise@hostplatform.com

  // Staging
  '6316e645d353c96ffed28ce9', // harris_teo@hostplatform.com
  '61c16ffc4c36d36a38c25da3', // johnson@hostplatform.com
  '61ee9ac4be177d666e9431ee', // benny@hostplatform.com
  '65e13f2165ab1a075815a8ad', // sam@hostplatform.com
  '6268b423e96c0837c0a6043a', // eunice@hostplatform.com
  '690883954e35671e5edabae2', // clara@hostplatform.com
  '6163ee6790fd0119af4808fe' // derise@hostplatform.com
];

export const API_SCOPE_OPTIONS = [{ value: 'reservations', label: 'Reservations' }, { value: 'messaging', label: 'Messaging' }];

export const apiScopeLabel = code => {
  const option = API_SCOPE_OPTIONS.find(o => o.value === code);
  return option ? option.label : code;
};

export const msicCodes = [
  {
    code: '00000',
    label: 'NOT APPLICABLE',
    msicCategoryReference: ''
  },
  {
    code: '01111',
    label: 'Growing of maize',
    msicCategoryReference: 'A'
  },
  {
    code: '01112',
    label: 'Growing of leguminous crops',
    msicCategoryReference: 'A'
  },
  {
    code: '01113',
    label: 'Growing of oil seeds',
    msicCategoryReference: 'A'
  },
  {
    code: '01119',
    label: 'Growing of other cereals n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01120',
    label: 'Growing of paddy',
    msicCategoryReference: 'A'
  },
  {
    code: '01131',
    label: 'Growing of leafy or stem vegetables',
    msicCategoryReference: 'A'
  },
  {
    code: '01132',
    label: 'Growing of fruits bearing vegetables',
    msicCategoryReference: 'A'
  },
  {
    code: '01133',
    label: 'Growing of melons',
    msicCategoryReference: 'A'
  },
  {
    code: '01134',
    label: 'Growing of mushrooms and truffles',
    msicCategoryReference: 'A'
  },
  {
    code: '01135',
    label: 'Growing of vegetables seeds, except beet seeds',
    msicCategoryReference: 'A'
  },
  {
    code: '01136',
    label: 'Growing of other vegetables',
    msicCategoryReference: 'A'
  },
  {
    code: '01137',
    label: 'Growing of sugar beet',
    msicCategoryReference: 'A'
  },
  {
    code: '01138',
    label: 'Growing of roots, tubers, bulb or tuberous vegetables',
    msicCategoryReference: 'A'
  },
  {
    code: '01140',
    label: 'Growing of sugar cane',
    msicCategoryReference: 'A'
  },
  {
    code: '01150',
    label: 'Growing of tobacco',
    msicCategoryReference: 'A'
  },
  {
    code: '01160',
    label: 'Growing of fibre crops',
    msicCategoryReference: 'A'
  },
  {
    code: '01191',
    label: 'Growing of flowers',
    msicCategoryReference: 'A'
  },
  {
    code: '01192',
    label: 'Growing of flower seeds',
    msicCategoryReference: 'A'
  },
  {
    code: '01193',
    label: 'Growing of sago (rumbia)',
    msicCategoryReference: 'A'
  },
  {
    code: '01199',
    label: 'Growing of other non-perennial crops n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01210',
    label: 'Growing of grapes',
    msicCategoryReference: 'A'
  },
  {
    code: '01221',
    label: 'Growing of banana',
    msicCategoryReference: 'A'
  },
  {
    code: '01222',
    label: 'Growing of mango',
    msicCategoryReference: 'A'
  },
  {
    code: '01223',
    label: 'Growing of durian',
    msicCategoryReference: 'A'
  },
  {
    code: '01224',
    label: 'Growing of rambutan',
    msicCategoryReference: 'A'
  },
  {
    code: '01225',
    label: 'Growing of star fruit',
    msicCategoryReference: 'A'
  },
  {
    code: '01226',
    label: 'Growing of papaya',
    msicCategoryReference: 'A'
  },
  {
    code: '01227',
    label: 'Growing of pineapple',
    msicCategoryReference: 'A'
  },
  {
    code: '01228',
    label: 'Growing of pitaya (dragon fruit)',
    msicCategoryReference: 'A'
  },
  {
    code: '01229',
    label: 'Growing of other tropical and subtropical fruits n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01231',
    label: 'Growing of pomelo',
    msicCategoryReference: 'A'
  },
  {
    code: '01232',
    label: 'Growing of lemon and limes',
    msicCategoryReference: 'A'
  },
  {
    code: '01233',
    label: 'Growing of tangerines and mandarin',
    msicCategoryReference: 'A'
  },
  {
    code: '01239',
    label: 'Growing of other citrus fruits n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01241',
    label: 'Growing of guava',
    msicCategoryReference: 'A'
  },
  {
    code: '01249',
    label: 'Growing of other pome fruits and stones fruits n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01251',
    label: 'Growing of berries',
    msicCategoryReference: 'A'
  },
  {
    code: '01252',
    label: 'Growing of fruit seeds',
    msicCategoryReference: 'A'
  },
  {
    code: '01253',
    label: 'Growing of edible nuts',
    msicCategoryReference: 'A'
  },
  {
    code: '01259',
    label: 'Growing of other tree and bush fruits',
    msicCategoryReference: 'A'
  },
  {
    code: '01261',
    label: 'Growing of oil palm (estate)',
    msicCategoryReference: 'A'
  },
  {
    code: '01262',
    label: 'Growing of oil palm (smallholdings)',
    msicCategoryReference: 'A'
  },
  {
    code: '01263',
    label: 'Growing of coconut (estate and smallholdings)',
    msicCategoryReference: 'A'
  },
  {
    code: '01269',
    label: 'Growing of other oleaginous fruits n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01271',
    label: 'Growing of coffee',
    msicCategoryReference: 'A'
  },
  {
    code: '01272',
    label: 'Growing of tea',
    msicCategoryReference: 'A'
  },
  {
    code: '01273',
    label: 'Growing of cocoa',
    msicCategoryReference: 'A'
  },
  {
    code: '01279',
    label: 'Growing of other beverage crops n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01281',
    label: 'Growing of pepper (piper nigrum)',
    msicCategoryReference: 'A'
  },
  {
    code: '01282',
    label: 'Growing of chilies and pepper (capsicum spp.)',
    msicCategoryReference: 'A'
  },
  {
    code: '01283',
    label: 'Growing of nutmeg',
    msicCategoryReference: 'A'
  },
  {
    code: '01284',
    label: 'Growing of ginger',
    msicCategoryReference: 'A'
  },
  {
    code: '01285',
    label: 'Growing of plants used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes',
    msicCategoryReference: 'A'
  },
  {
    code: '01289',
    label: 'Growing of other spices and aromatic crops n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01291',
    label: 'Growing  of rubber trees (estate)',
    msicCategoryReference: 'A'
  },
  {
    code: '01292',
    label: 'Growing of rubber trees (smallholdings)',
    msicCategoryReference: 'A'
  },
  {
    code: '01293',
    label: 'Growing of trees for extraction of sap',
    msicCategoryReference: 'A'
  },
  {
    code: '01294',
    label: 'Growing of nipa palm',
    msicCategoryReference: 'A'
  },
  {
    code: '01295',
    label: 'Growing of areca',
    msicCategoryReference: 'A'
  },
  {
    code: '01296',
    label: 'Growing of roselle',
    msicCategoryReference: 'A'
  },
  {
    code: '01299',
    label: 'Growing of other perennial crops n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01301',
    label: 'Growing of plants for planting',
    msicCategoryReference: 'A'
  },
  {
    code: '01302',
    label: 'Growing of plants for ornamental purposes',
    msicCategoryReference: 'A'
  },
  {
    code: '01303',
    label: 'Growing of live plants for bulbs, tubers and roots; cuttings and slips; mushroom spawn',
    msicCategoryReference: 'A'
  },
  {
    code: '01304',
    label: 'Operation of tree nurseries',
    msicCategoryReference: 'A'
  },
  {
    code: '01411',
    label: 'Raising, breeding and production of cattle or buffaloes',
    msicCategoryReference: 'A'
  },
  {
    code: '01412',
    label: 'Production of raw milk from cows or buffaloes',
    msicCategoryReference: 'A'
  },
  {
    code: '01413',
    label: 'Production of bovine semen',
    msicCategoryReference: 'A'
  },
  {
    code: '01420',
    label: 'Raising and breeding of horses, asses, mules or hinnes',
    msicCategoryReference: 'A'
  },
  {
    code: '01430',
    label: 'Raising and breeding of camels (dromedary) and camelids',
    msicCategoryReference: 'A'
  },
  {
    code: '01441',
    label: 'Raising, breeding and production of sheep and goats',
    msicCategoryReference: 'A'
  },
  {
    code: '01442',
    label: 'Production of raw sheep or goat’s milk',
    msicCategoryReference: 'A'
  },
  {
    code: '01443',
    label: 'Production of raw wool',
    msicCategoryReference: 'A'
  },
  {
    code: '01450',
    label: 'Raising, breeding and production of swine/pigs',
    msicCategoryReference: 'A'
  },
  {
    code: '01461',
    label: 'Raising, breeding and production of chicken, broiler',
    msicCategoryReference: 'A'
  },
  {
    code: '01462',
    label: 'Raising, breeding and production of ducks',
    msicCategoryReference: 'A'
  },
  {
    code: '01463',
    label: 'Raising, breeding and production of geese',
    msicCategoryReference: 'A'
  },
  {
    code: '01464',
    label: 'Raising, breeding and production of quails',
    msicCategoryReference: 'A'
  },
  {
    code: '01465',
    label: 'Raising and breeding of other poultry n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01466',
    label: 'Production of chicken eggs',
    msicCategoryReference: 'A'
  },
  {
    code: '01467',
    label: 'Production of duck eggs',
    msicCategoryReference: 'A'
  },
  {
    code: '01468',
    label: 'Production of other poultry eggs n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01469',
    label: 'Operation of poultry hatcheries',
    msicCategoryReference: 'A'
  },
  {
    code: '01491',
    label: 'Raising, breeding and production of semi-domesticated',
    msicCategoryReference: 'A'
  },
  {
    code: '01492',
    label: 'Production of fur skins, reptile or bird’s skin from ranching operation',
    msicCategoryReference: 'A'
  },
  {
    code: '01493',
    label: 'Operation of worm farms, land mollusc farms, snail farms',
    msicCategoryReference: 'A'
  },
  {
    code: '01494',
    label: 'Raising of silk worms and production of silk worm cocoons',
    msicCategoryReference: 'A'
  },
  {
    code: '01495',
    label: 'Bee keeping and production of honey and beeswax',
    msicCategoryReference: 'A'
  },
  {
    code: '01496',
    label: 'Raising and breeding of pet animals',
    msicCategoryReference: 'A'
  },
  {
    code: '01497',
    label: 'Raising and breeding of swiflet',
    msicCategoryReference: 'A'
  },
  {
    code: '01499',
    label: 'Raising of diverse/other animals n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '01500',
    label: 'Mixed Farming',
    msicCategoryReference: 'A'
  },
  {
    code: '01610',
    label: 'Agricultural activities for crops production on a fee or contract basis',
    msicCategoryReference: 'A'
  },
  {
    code: '01620',
    label: 'Agricultural activities for animal production on a fee or contract basis',
    msicCategoryReference: 'A'
  },
  {
    code: '01631',
    label: 'Preparation of crops for primary markets',
    msicCategoryReference: 'A'
  },
  {
    code: '01632',
    label: 'Preparation of tobacco leaves',
    msicCategoryReference: 'A'
  },
  {
    code: '01633',
    label: 'Preparation of cocoa beans',
    msicCategoryReference: 'A'
  },
  {
    code: '01634',
    label: 'Sun-drying of fruits and vegetables',
    msicCategoryReference: 'A'
  },
  {
    code: '01640',
    label: 'Seed processing for propagation',
    msicCategoryReference: 'A'
  },
  {
    code: '01701',
    label: 'Hunting and trapping on a commercial basis',
    msicCategoryReference: 'A'
  },
  {
    code: '01702',
    label: 'Taking of animals (dead or alive)',
    msicCategoryReference: 'A'
  },
  {
    code: '02101',
    label: 'Planting, replanting, transplanting, thinning and conserving of forests and timber tracts',
    msicCategoryReference: 'A'
  },
  {
    code: '02102',
    label: 'Growing of coppice, pulpwood and fire wood',
    msicCategoryReference: 'A'
  },
  {
    code: '02103',
    label: 'Operation of forest tree nurseries',
    msicCategoryReference: 'A'
  },
  {
    code: '02104',
    label: 'Collection and raising of wildings (peat swamp forest tree species)',
    msicCategoryReference: 'A'
  },
  {
    code: '02105',
    label: 'Forest plantation',
    msicCategoryReference: 'A'
  },
  {
    code: '02201',
    label: 'Production of round wood for forest-based manufacturing industries',
    msicCategoryReference: 'A'
  },
  {
    code: '02202',
    label: 'Production of round wood used in an unprocessed form',
    msicCategoryReference: 'A'
  },
  {
    code: '02203',
    label: 'Production of charcoal in the forest (using traditional methods)',
    msicCategoryReference: 'A'
  },
  {
    code: '02204',
    label: 'Rubber wood logging',
    msicCategoryReference: 'A'
  },
  {
    code: '02301',
    label: 'Collection of rattan, bamboo',
    msicCategoryReference: 'A'
  },
  {
    code: '02302',
    label: 'Bird’s nest collection',
    msicCategoryReference: 'A'
  },
  {
    code: '02303',
    label: 'Wild sago palm collection',
    msicCategoryReference: 'A'
  },
  {
    code: '02309',
    label: 'Gathering of non-wood forest products n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '02401',
    label: 'Carrying out part of the forestry and forest plantation operation on a fee or contract basis for forestry service activities',
    msicCategoryReference: 'A'
  },
  {
    code: '02402',
    label: 'Carrying out part of the forestry operation on a fee or contract basis for logging service activities',
    msicCategoryReference: 'A'
  },
  {
    code: '03111',
    label: 'Fishing on a commercial basis in ocean and coastal waters',
    msicCategoryReference: 'A'
  },
  {
    code: '03112',
    label: 'Collection of marine crustaceans and molluscs',
    msicCategoryReference: 'A'
  },
  {
    code: '03113',
    label: 'Taking of aquatic animals: sea squirts, tunicates, sea urchins',
    msicCategoryReference: 'A'
  },
  {
    code: '03114',
    label: 'Activities of vessels engaged both in fishing and in processing and preserving of fish',
    msicCategoryReference: 'A'
  },
  {
    code: '03115',
    label: 'Gathering of other marine organisms and materials (natural pearls, sponges, coral and algae)',
    msicCategoryReference: 'A'
  },
  {
    code: '03119',
    label: 'Marine fishing n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '03121',
    label: 'Fishing on a commercial basis in inland waters',
    msicCategoryReference: 'A'
  },
  {
    code: '03122',
    label: 'Taking of freshwater crustaceans and molluscs',
    msicCategoryReference: 'A'
  },
  {
    code: '03123',
    label: 'Taking of freshwater aquatic animals',
    msicCategoryReference: 'A'
  },
  {
    code: '03124',
    label: 'Gathering of freshwater flora and fauna',
    msicCategoryReference: 'A'
  },
  {
    code: '03129',
    label: 'Freshwater fishing n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '03211',
    label: 'Fish farming in sea water',
    msicCategoryReference: 'A'
  },
  {
    code: '03212',
    label: 'Production of bivalve spat (oyster, mussel), lobster lings, shrimp post-larvae, fish fry and fingerlings',
    msicCategoryReference: 'A'
  },
  {
    code: '03213',
    label: 'Growing of laver and other edible seaweeds',
    msicCategoryReference: 'A'
  },
  {
    code: '03214',
    label: 'Culture of crustaceans, bivalves, other molluscs and other aquatic animals in sea water',
    msicCategoryReference: 'A'
  },
  {
    code: '03215',
    label: 'Aquaculture activities in brackish water',
    msicCategoryReference: 'A'
  },
  {
    code: '03216',
    label: 'Aquaculture activities in salt water filled tanks or reservoirs',
    msicCategoryReference: 'A'
  },
  {
    code: '03217',
    label: 'Operation of  hatcheries (marine)',
    msicCategoryReference: 'A'
  },
  {
    code: '03218',
    label: 'Operation of marine worm farms for fish feed',
    msicCategoryReference: 'A'
  },
  {
    code: '03219',
    label: 'Marine aquaculture n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '03221',
    label: 'Fish farming in freshwater',
    msicCategoryReference: 'A'
  },
  {
    code: '03222',
    label: 'Shrimp farming in freshwater',
    msicCategoryReference: 'A'
  },
  {
    code: '03223',
    label: 'Culture of freshwater crustaceans, bivalves, other molluscs and other aquatic animals',
    msicCategoryReference: 'A'
  },
  {
    code: '03224',
    label: 'Operation of hatcheries (freshwater)',
    msicCategoryReference: 'A'
  },
  {
    code: '03225',
    label: 'Farming of frogs',
    msicCategoryReference: 'A'
  },
  {
    code: '03229',
    label: 'Freshwater aquaculture n.e.c.',
    msicCategoryReference: 'A'
  },
  {
    code: '05100',
    label: 'Mining of hard coal',
    msicCategoryReference: 'B'
  },
  {
    code: '05200',
    label: 'Mining of lignite (brown coal)',
    msicCategoryReference: 'B'
  },
  {
    code: '06101',
    label: 'Extraction of crude petroleum oils',
    msicCategoryReference: 'B'
  },
  {
    code: '06102',
    label: 'Extraction of bituminous or oil shale and tar sand',
    msicCategoryReference: 'B'
  },
  {
    code: '06103',
    label: 'Production of crude petroleum from bituminous shale and sand',
    msicCategoryReference: 'B'
  },
  {
    code: '06104',
    label: 'Processes to obtain crude oils',
    msicCategoryReference: 'B'
  },
  {
    code: '06201',
    label: 'Production of crude gaseous hydrocarbon (natural gas)',
    msicCategoryReference: 'B'
  },
  {
    code: '06202',
    label: 'Extraction of condensates',
    msicCategoryReference: 'B'
  },
  {
    code: '06203',
    label: 'Draining and separation of liquid hydrocarbon fractions',
    msicCategoryReference: 'B'
  },
  {
    code: '06204',
    label: 'Gas desulphurization',
    msicCategoryReference: 'B'
  },
  {
    code: '06205',
    label: 'Mining of hydrocarbon liquids, obtain through liquefaction or pyrolysis',
    msicCategoryReference: 'B'
  },
  {
    code: '07101',
    label: 'Mining of ores valued chiefly for iron content',
    msicCategoryReference: 'B'
  },
  {
    code: '07102',
    label: 'Beneficiation and agglomeration of iron ores',
    msicCategoryReference: 'B'
  },
  {
    code: '07210',
    label: 'Mining of uranium and thorium ores',
    msicCategoryReference: 'B'
  },
  {
    code: '07291',
    label: 'Mining of tin ores',
    msicCategoryReference: 'B'
  },
  {
    code: '07292',
    label: 'Mining of copper',
    msicCategoryReference: 'B'
  },
  {
    code: '07293',
    label: 'Mining of bauxite (aluminium)',
    msicCategoryReference: 'B'
  },
  {
    code: '07294',
    label: 'Mining of ilmenite',
    msicCategoryReference: 'B'
  },
  {
    code: '07295',
    label: 'Mining of gold',
    msicCategoryReference: 'B'
  },
  {
    code: '07296',
    label: 'Mining of silver',
    msicCategoryReference: 'B'
  },
  {
    code: '07297',
    label: 'Mining of platinum',
    msicCategoryReference: 'B'
  },
  {
    code: '07298',
    label: 'Amang retreatment',
    msicCategoryReference: 'B'
  },
  {
    code: '07299',
    label: 'Mining of other non-ferrous metal ores n.e.c.',
    msicCategoryReference: 'B'
  },
  {
    code: '08101',
    label: 'Quarrying, rough trimming and sawing of monumental and building stone such as marble, granite (dimension stone), sandstone',
    msicCategoryReference: 'B'
  },
  {
    code: '08102',
    label: 'Quarrying, crushing and breaking of limestone',
    msicCategoryReference: 'B'
  },
  {
    code: '08103',
    label: 'Mining of gypsum and anhydrite',
    msicCategoryReference: 'B'
  },
  {
    code: '08104',
    label: 'Mining of chalk and uncalcined dolomite',
    msicCategoryReference: 'B'
  },
  {
    code: '08105',
    label: 'Extraction and dredging of industrial sand, sand for construction and gravel',
    msicCategoryReference: 'B'
  },
  {
    code: '08106',
    label: 'Breaking and crushing of stone and gravel',
    msicCategoryReference: 'B'
  },
  {
    code: '08107',
    label: 'Quarrying of sand',
    msicCategoryReference: 'B'
  },
  {
    code: '08108',
    label: 'Mining of clays, refractory clays and kaolin',
    msicCategoryReference: 'B'
  },
  {
    code: '08109',
    label: 'Quarrying, crushing and breaking of granite',
    msicCategoryReference: 'B'
  },
  {
    code: '08911',
    label: 'Mining of natural phosphates',
    msicCategoryReference: 'B'
  },
  {
    code: '08912',
    label: 'Mining of natural potassium salts',
    msicCategoryReference: 'B'
  },
  {
    code: '08913',
    label: 'Mining of native sulphur',
    msicCategoryReference: 'B'
  },
  {
    code: '08914',
    label: 'Extraction and preparation of pyrites and pyrrhotite, except roasting',
    msicCategoryReference: 'B'
  },
  {
    code: '08915',
    label: 'Mining of natural barium sulphate and carbonate (barytes and witherite)',
    msicCategoryReference: 'B'
  },
  {
    code: '08916',
    label: 'Mining of natural borates, natural magnesium sulphates (kieserite)',
    msicCategoryReference: 'B'
  },
  {
    code: '08917',
    label: 'Mining of earth colours, fluorspar and other minerals valued chiefly as a source of chemicals',
    msicCategoryReference: 'B'
  },
  {
    code: '08918',
    label: 'Guano mining',
    msicCategoryReference: 'B'
  },
  {
    code: '08921',
    label: 'Peat digging',
    msicCategoryReference: 'B'
  },
  {
    code: '08922',
    label: 'Peat agglomeration',
    msicCategoryReference: 'B'
  },
  {
    code: '08923',
    label: 'Preparation of peat to improve quality or facilitate transport or storage',
    msicCategoryReference: 'B'
  },
  {
    code: '08931',
    label: 'Extraction of salt from underground',
    msicCategoryReference: 'B'
  },
  {
    code: '08932',
    label: 'Salt production by evaporation of sea water or other saline waters',
    msicCategoryReference: 'B'
  },
  {
    code: '08933',
    label: 'Crushing, purification and refining of salt by the producer',
    msicCategoryReference: 'B'
  },
  {
    code: '08991',
    label: 'Mining and quarrying of abrasive materials',
    msicCategoryReference: 'B'
  },
  {
    code: '08992',
    label: 'Mining and quarrying of asbestos',
    msicCategoryReference: 'B'
  },
  {
    code: '08993',
    label: 'Mining and quarrying of siliceous fossil meals',
    msicCategoryReference: 'B'
  },
  {
    code: '08994',
    label: 'Mining and quarrying of natural graphite',
    msicCategoryReference: 'B'
  },
  {
    code: '08995',
    label: 'Mining and quarrying of steatite (talc)',
    msicCategoryReference: 'B'
  },
  {
    code: '08996',
    label: 'Mining and quarrying of gemstones',
    msicCategoryReference: 'B'
  },
  {
    code: '08999',
    label: 'Other mining and quarrying n.e.c.',
    msicCategoryReference: 'B'
  },
  {
    code: '09101',
    label: 'Oil and gas extraction service activities provided on a fee or contract basis',
    msicCategoryReference: 'B'
  },
  {
    code: '09102',
    label: 'Oil and gas field fire fighting services',
    msicCategoryReference: 'B'
  },
  {
    code: '09900',
    label: 'Support activities for other mining and quarrying',
    msicCategoryReference: 'B'
  },
  {
    code: '10101',
    label: 'Processing and preserving of meat and production of meat products',
    msicCategoryReference: 'C'
  },
  {
    code: '10102',
    label: 'Processing and preserving of poultry and poultry products',
    msicCategoryReference: 'C'
  },
  {
    code: '10103',
    label: 'Production of hides and skins originating from slaughterhouses',
    msicCategoryReference: 'C'
  },
  {
    code: '10104',
    label: 'Operation of slaughterhouses engaged in killing, houses dressing or packing meat',
    msicCategoryReference: 'C'
  },
  {
    code: '10109',
    label: 'Processing and preserving of meat n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '10201',
    label: 'Canning of fish, crustaceans and mollusks',
    msicCategoryReference: 'C'
  },
  {
    code: '10202',
    label: 'Processing, curing and preserving of fish, crustacean and molluscs',
    msicCategoryReference: 'C'
  },
  {
    code: '10203',
    label: 'Production of fish meals for human consumption or animal feed',
    msicCategoryReference: 'C'
  },
  {
    code: '10204',
    label: 'Production of keropok including keropok lekor',
    msicCategoryReference: 'C'
  },
  {
    code: '10205',
    label: 'Processing of seaweed',
    msicCategoryReference: 'C'
  },
  {
    code: '10301',
    label: 'Manufacture of fruits and vegetable food products',
    msicCategoryReference: 'C'
  },
  {
    code: '10302',
    label: 'Manufacture of fruit and vegetable juices',
    msicCategoryReference: 'C'
  },
  {
    code: '10303',
    label: 'Pineapple canning',
    msicCategoryReference: 'C'
  },
  {
    code: '10304',
    label: 'Manufacture of jams, marmalades and table jellies',
    msicCategoryReference: 'C'
  },
  {
    code: '10305',
    label: 'Manufacture of nuts and nut products',
    msicCategoryReference: 'C'
  },
  {
    code: '10306',
    label: 'Manufacture of bean curd products',
    msicCategoryReference: 'C'
  },
  {
    code: '10401',
    label: 'Manufacture of crude palm oil',
    msicCategoryReference: 'C'
  },
  {
    code: '10402',
    label: 'Manufacture of refined palm oil',
    msicCategoryReference: 'C'
  },
  {
    code: '10403',
    label: 'Manufacture of palm kernel oil',
    msicCategoryReference: 'C'
  },
  {
    code: '10404',
    label: 'Manufacture of crude and refined vegetable oil',
    msicCategoryReference: 'C'
  },
  {
    code: '10405',
    label: 'Manufacture of coconut oil',
    msicCategoryReference: 'C'
  },
  {
    code: '10406',
    label: 'Manufacture of compound cooking fats',
    msicCategoryReference: 'C'
  },
  {
    code: '10407',
    label: 'Manufacture of animal oils and fats',
    msicCategoryReference: 'C'
  },
  {
    code: '10501',
    label: 'Manufacture of ice cream and other edible ice such as sorbet',
    msicCategoryReference: 'C'
  },
  {
    code: '10502',
    label: 'Manufacture of condensed, powdered and evaporated milk',
    msicCategoryReference: 'C'
  },
  {
    code: '10509',
    label: 'Manufacture of other dairy products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '10611',
    label: 'Rice milling',
    msicCategoryReference: 'C'
  },
  {
    code: '10612',
    label: 'Provision of milling services',
    msicCategoryReference: 'C'
  },
  {
    code: '10613',
    label: 'Flour milling',
    msicCategoryReference: 'C'
  },
  {
    code: '10619',
    label: 'Manufacture of grain mill products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '10621',
    label: 'Manufacture of starches and starch products',
    msicCategoryReference: 'C'
  },
  {
    code: '10622',
    label: 'Manufacture of glucose, glucose syrup, maltose, inulin',
    msicCategoryReference: 'C'
  },
  {
    code: '10623',
    label: 'Manufacture of sago and tapioca flour/products',
    msicCategoryReference: 'C'
  },
  {
    code: '10711',
    label: 'Manufacture of biscuits and cookies',
    msicCategoryReference: 'C'
  },
  {
    code: '10712',
    label: 'Manufacture of bread, cakes and other bakery products',
    msicCategoryReference: 'C'
  },
  {
    code: '10713',
    label: 'Manufacture of snack products',
    msicCategoryReference: 'C'
  },
  {
    code: '10714',
    label: 'Manufacture of frozen bakery products',
    msicCategoryReference: 'C'
  },
  {
    code: '10721',
    label: 'Manufacture of sugar',
    msicCategoryReference: 'C'
  },
  {
    code: '10722',
    label: 'Manufacture of sugar products',
    msicCategoryReference: 'C'
  },
  {
    code: '10731',
    label: 'Manufacture of cocoa products',
    msicCategoryReference: 'C'
  },
  {
    code: '10732',
    label: 'Manufacture of chocolate and chocolate products',
    msicCategoryReference: 'C'
  },
  {
    code: '10733',
    label: 'Manufacture of sugar confectionery',
    msicCategoryReference: 'C'
  },
  {
    code: '10741',
    label: 'Manufacture of meehoon, noodles and other related products',
    msicCategoryReference: 'C'
  },
  {
    code: '10742',
    label: 'Manufacture of pastas',
    msicCategoryReference: 'C'
  },
  {
    code: '10750',
    label: 'Manufacture of prepared meals and dishes',
    msicCategoryReference: 'C'
  },
  {
    code: '10791',
    label: 'Manufacture of coffee',
    msicCategoryReference: 'C'
  },
  {
    code: '10792',
    label: 'Manufacture of tea',
    msicCategoryReference: 'C'
  },
  {
    code: '10793',
    label: 'Manufacture of sauces and condiments',
    msicCategoryReference: 'C'
  },
  {
    code: '10794',
    label: 'Manufacture of spices and curry powder',
    msicCategoryReference: 'C'
  },
  {
    code: '10795',
    label: 'Manufacture of egg products',
    msicCategoryReference: 'C'
  },
  {
    code: '10799',
    label: 'Manufacture of other food products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '10800',
    label: 'Manufacture of prepared animal feeds',
    msicCategoryReference: 'C'
  },
  {
    code: '11010',
    label: 'Distilling, rectifying and blending of spirits',
    msicCategoryReference: 'C'
  },
  {
    code: '11020',
    label: 'Manufacture of wines',
    msicCategoryReference: 'C'
  },
  {
    code: '11030',
    label: 'Manufacture of malt liquors and malt',
    msicCategoryReference: 'C'
  },
  {
    code: '11041',
    label: 'Manufacture of soft drinks',
    msicCategoryReference: 'C'
  },
  {
    code: '11042',
    label: 'Production of natural mineral water and other bottled water',
    msicCategoryReference: 'C'
  },
  {
    code: '12000',
    label: 'MANUFACTURE OF TOBACCO PRODUCTS',
    msicCategoryReference: 'C'
  },
  {
    code: '13110',
    label: 'Preparation and spinning of textile fibres',
    msicCategoryReference: 'C'
  },
  {
    code: '13120',
    label: 'Weaving of textiles',
    msicCategoryReference: 'C'
  },
  {
    code: '13131',
    label: 'Batik making',
    msicCategoryReference: 'C'
  },
  {
    code: '13132',
    label: 'Dyeing, bleaching, printing and finishing of yarns and fabrics',
    msicCategoryReference: 'C'
  },
  {
    code: '13139',
    label: 'Other finishing textiles',
    msicCategoryReference: 'C'
  },
  {
    code: '13910',
    label: 'Manufacture of knitted and crocheted fabrics',
    msicCategoryReference: 'C'
  },
  {
    code: '13921',
    label: 'Manufacture of made-up articles of any textile materials, including of knitted or crocheted fabrics',
    msicCategoryReference: 'C'
  },
  {
    code: '13922',
    label: 'Manufacture of made-up furnishing articles',
    msicCategoryReference: 'C'
  },
  {
    code: '13930',
    label: 'Manufacture of carpets and rugs',
    msicCategoryReference: 'C'
  },
  {
    code: '13940',
    label: 'Manufacture of cordage, rope, twine and netting',
    msicCategoryReference: 'C'
  },
  {
    code: '13990',
    label: 'Manufacture of other textiles n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '14101',
    label: 'Manufacture of specific wearing apparel',
    msicCategoryReference: 'C'
  },
  {
    code: '14102',
    label: 'Manufacture of clothings',
    msicCategoryReference: 'C'
  },
  {
    code: '14103',
    label: 'Custom tailoring',
    msicCategoryReference: 'C'
  },
  {
    code: '14109',
    label: 'Manufacture of other clothing accessories',
    msicCategoryReference: 'C'
  },
  {
    code: '14200',
    label: 'Manufacture of articles made of fur skins',
    msicCategoryReference: 'C'
  },
  {
    code: '14300',
    label: 'Manufacture of knitted and crocheted apparel',
    msicCategoryReference: 'C'
  },
  {
    code: '15110',
    label: 'Tanning and dressing of leather; dressing and dyeing of fur',
    msicCategoryReference: 'C'
  },
  {
    code: '15120',
    label: 'Manufacture of luggage, handbags and the like, saddlery and harness',
    msicCategoryReference: 'C'
  },
  {
    code: '15201',
    label: 'Manufacture of leather footwear',
    msicCategoryReference: 'C'
  },
  {
    code: '15202',
    label: 'Manufacture of plastic footwear',
    msicCategoryReference: 'C'
  },
  {
    code: '15203',
    label: 'Manufacture of rubber footwear',
    msicCategoryReference: 'C'
  },
  {
    code: '15209',
    label: 'Manufacture of other footwear n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '16211',
    label: 'Manufacture of veneer sheets and plywood',
    msicCategoryReference: 'C'
  },
  {
    code: '16221',
    label: "Manufacture of builders' carpentry",
    msicCategoryReference: 'C'
  },
  {
    code: '16222',
    label: 'Manufacture of joinery wood products',
    msicCategoryReference: 'C'
  },
  {
    code: '16230',
    label: 'Manufacture of wooden containers',
    msicCategoryReference: 'C'
  },
  {
    code: '16291',
    label: 'Manufacture of wood charcoal',
    msicCategoryReference: 'C'
  },
  {
    code: '16292',
    label: 'Manufacture of other products of wood, cane, articles of cork, straw and plaiting materials',
    msicCategoryReference: 'C'
  },
  {
    code: '17010',
    label: 'Manufacture of pulp, paper and paperboard',
    msicCategoryReference: 'C'
  },
  {
    code: '17020',
    label: 'Manufacture of corrugated paper and paperboard and of containers of paper and paperboard',
    msicCategoryReference: 'C'
  },
  {
    code: '17091',
    label: 'Manufacture of envelopes and letter-card',
    msicCategoryReference: 'C'
  },
  {
    code: '17092',
    label: 'Manufacture of household and personal hygiene paper',
    msicCategoryReference: 'C'
  },
  {
    code: '17093',
    label: 'Manufacture of gummed or adhesive paper in strips or rolls and labels and wall paper',
    msicCategoryReference: 'C'
  },
  {
    code: '17094',
    label: 'Manufacture of effigies, funeral paper goods, joss paper',
    msicCategoryReference: 'C'
  },
  {
    code: '17099',
    label: 'Manufacture of other articles of paper and paperboard n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '18110',
    label: 'Printing',
    msicCategoryReference: 'C'
  },
  {
    code: '18120',
    label: 'Service activities related to printing',
    msicCategoryReference: 'C'
  },
  {
    code: '18200',
    label: 'Reproduction of recorded media',
    msicCategoryReference: 'C'
  },
  {
    code: '19100',
    label: 'Manufacture of coke oven products',
    msicCategoryReference: 'C'
  },
  {
    code: '19201',
    label: 'Manufacture of refined petroleum products',
    msicCategoryReference: 'C'
  },
  {
    code: '19202',
    label: 'Manufacture of bio-diesel products',
    msicCategoryReference: 'C'
  },
  {
    code: '20111',
    label: 'Manufacture of liquefied or compressed inorganic industrial or medical gases',
    msicCategoryReference: 'C'
  },
  {
    code: '20112',
    label: 'Manufacture of basic organic chemicals',
    msicCategoryReference: 'C'
  },
  {
    code: '20113',
    label: 'Manufacture of inorganic compounds',
    msicCategoryReference: 'C'
  },
  {
    code: '20119',
    label: 'Manufacture of other basic chemicals n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '20121',
    label: 'Manufacture of fertilizers',
    msicCategoryReference: 'C'
  },
  {
    code: '20129',
    label: 'Manufacture of associated nitrogen products',
    msicCategoryReference: 'C'
  },
  {
    code: '20131',
    label: 'Manufacture of plastic in primary forms',
    msicCategoryReference: 'C'
  },
  {
    code: '20132',
    label: 'Manufacture of synthetic rubber in primary forms: synthetic rubber, factice',
    msicCategoryReference: 'C'
  },
  {
    code: '20133',
    label: 'Manufacture of mixtures of synthetic rubber and natural rubber or rubber - like gums',
    msicCategoryReference: 'C'
  },
  {
    code: '20210',
    label: 'Manufacture of pesticides and other agrochemical products',
    msicCategoryReference: 'C'
  },
  {
    code: '20221',
    label: 'Manufacture of paints, varnishes and similar coatings ink and mastics',
    msicCategoryReference: 'C'
  },
  {
    code: '20222',
    label: 'Manufacture of printing ink',
    msicCategoryReference: 'C'
  },
  {
    code: '20231',
    label: 'Manufacture of soap and detergents, cleaning and polishing preparations',
    msicCategoryReference: 'C'
  },
  {
    code: '20232',
    label: 'Manufacture of perfumes and toilet preparations',
    msicCategoryReference: 'C'
  },
  {
    code: '20291',
    label: 'Manufacture of photographic plates, films, sensitized paper and other sensitized unexposed materials',
    msicCategoryReference: 'C'
  },
  {
    code: '20292',
    label: 'Manufacture of writing and drawing ink',
    msicCategoryReference: 'C'
  },
  {
    code: '20299',
    label: 'Manufacture of other chemical products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '20300',
    label: 'Manufacture of man-made fibres',
    msicCategoryReference: 'C'
  },
  {
    code: '21001',
    label: 'Manufacture of medicinal active substances to be used for their pharmacological properties in the manufacture of medicaments',
    msicCategoryReference: 'C'
  },
  {
    code: '21002',
    label: 'Processing of blood',
    msicCategoryReference: 'C'
  },
  {
    code: '21003',
    label: 'Manufacture of medicaments',
    msicCategoryReference: 'C'
  },
  {
    code: '21004',
    label: 'Manufacture of chemical contraceptive products',
    msicCategoryReference: 'C'
  },
  {
    code: '21005',
    label: 'Manufacture of medical diagnostic preparation',
    msicCategoryReference: 'C'
  },
  {
    code: '21006',
    label: 'Manufacture of radioactive in-vivo diagnostic substances',
    msicCategoryReference: 'C'
  },
  {
    code: '21007',
    label: 'Manufacture of biotech pharmaceuticals',
    msicCategoryReference: 'C'
  },
  {
    code: '21009',
    label: 'Manufacture of other pharmaceuticals, medicinal chemical and botanical products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '22111',
    label: 'Manufacture of rubber tyres for vehicles',
    msicCategoryReference: 'C'
  },
  {
    code: '22112',
    label: 'Manufacture of interchangeable tyre treads and retreading rubber tyres',
    msicCategoryReference: 'C'
  },
  {
    code: '22191',
    label: 'Manufacture of other products of natural or synthetic rubber, unvulcanized, vulcanized or hardened',
    msicCategoryReference: 'C'
  },
  {
    code: '22192',
    label: 'Manufacture of rubber gloves',
    msicCategoryReference: 'C'
  },
  {
    code: '22193',
    label: 'Rubber remilling and latex processing',
    msicCategoryReference: 'C'
  },
  {
    code: '22199',
    label: 'Manufacture of other rubber products n.e.c',
    msicCategoryReference: 'C'
  },
  {
    code: '22201',
    label: 'Manufacture of semi-manufactures of plastic products',
    msicCategoryReference: 'C'
  },
  {
    code: '22202',
    label: 'Manufacture of finished plastic products',
    msicCategoryReference: 'C'
  },
  {
    code: '22203',
    label: 'Manufacture of plastic articles for the packing of goods',
    msicCategoryReference: 'C'
  },
  {
    code: '22204',
    label: "Manufacture of builders' plastics ware",
    msicCategoryReference: 'C'
  },
  {
    code: '22205',
    label: 'Manufacture of plastic tableware, kitchenware and toilet articles',
    msicCategoryReference: 'C'
  },
  {
    code: '22209',
    label: 'Manufacture of diverse plastic products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '23101',
    label: 'Manufacture of flat glass, including wired, coloured or tinted flat glass',
    msicCategoryReference: 'C'
  },
  {
    code: '23102',
    label: 'Manufacture of laboratory, hygienic or pharmaceutical glassware',
    msicCategoryReference: 'C'
  },
  {
    code: '23109',
    label: 'Manufacture of other glass products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '',
    label: 'Manufacture of non-metallic mineral products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '23911',
    label: 'Manufacture of refractory mortars and concretes',
    msicCategoryReference: 'C'
  },
  {
    code: '23912',
    label: 'Manufacture of refractory ceramic goods',
    msicCategoryReference: 'C'
  },
  {
    code: '23921',
    label: 'Manufacture of non-refractory ceramic',
    msicCategoryReference: 'C'
  },
  {
    code: '23929',
    label: 'Manufacture of other clay building materials',
    msicCategoryReference: 'C'
  },
  {
    code: '23930',
    label: 'Manufacture of other porcelain and ceramic products',
    msicCategoryReference: 'C'
  },
  {
    code: '23941',
    label: 'Manufacture of hydraulic cement',
    msicCategoryReference: 'C'
  },
  {
    code: '23942',
    label: 'Manufacture of lime and plaster',
    msicCategoryReference: 'C'
  },
  {
    code: '23951',
    label: 'Manufacture of ready-mix and dry-mix concrete and mortars',
    msicCategoryReference: 'C'
  },
  {
    code: '23952',
    label: 'Manufacture of precast concrete, cement or artificial stone articles for use in construction',
    msicCategoryReference: 'C'
  },
  {
    code: '23953',
    label: 'Manufacture of prefabricated structural components for building or civil engineering of cement, concrete or artificial stone',
    msicCategoryReference: 'C'
  },
  {
    code: '23959',
    label: 'Manufacture of other articles of concrete, cement and plaster n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '23960',
    label: 'Cutting, shaping and finishing of stone',
    msicCategoryReference: 'C'
  },
  {
    code: '23990',
    label: 'Manufacture of other non-metallic mineral products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '24101',
    label: 'Production of pig iron and spiegeleisen in pigs, blocks or other primary forms',
    msicCategoryReference: 'C'
  },
  {
    code: '24102',
    label: 'Production of bars and rods of stainless steel or other alloy steel',
    msicCategoryReference: 'C'
  },
  {
    code: '24103',
    label: 'Manufacture of seamless tubes, by hot rolling, hot extrusion or hot drawing, or by cold drawing or cold rolling',
    msicCategoryReference: 'C'
  },
  {
    code: '24104',
    label: 'Manufacture of steel tube fittings',
    msicCategoryReference: 'C'
  },
  {
    code: '24109',
    label: 'Manufacture of other basic iron and steel products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '24201',
    label: 'Tin smelting',
    msicCategoryReference: 'C'
  },
  {
    code: '24202',
    label: 'Production of aluminium from alumina',
    msicCategoryReference: 'C'
  },
  {
    code: '24209',
    label: 'Manufacture of other basic precious and other non-ferrous metals n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '24311',
    label: 'Casting of iron',
    msicCategoryReference: 'C'
  },
  {
    code: '24312',
    label: 'Casting of steel',
    msicCategoryReference: 'C'
  },
  {
    code: '24320',
    label: 'Casting of non-ferrous metals',
    msicCategoryReference: 'C'
  },
  {
    code: '25111',
    label: 'Manufacture of industrial frameworks in metal',
    msicCategoryReference: 'C'
  },
  {
    code: '25112',
    label: 'Manufacture of prefabricated buildings mainly of metal',
    msicCategoryReference: 'C'
  },
  {
    code: '25113',
    label: 'Manufacture of metal doors, windows and their frames, shutters and gates',
    msicCategoryReference: 'C'
  },
  {
    code: '25119',
    label: 'Manufacture of other structural metal products',
    msicCategoryReference: 'C'
  },
  {
    code: '25120',
    label: 'Manufacture of tanks, reservoirs and containers of metal',
    msicCategoryReference: 'C'
  },
  {
    code: '25130',
    label: 'Manufacture of steam generators, except central heating hot water boilers',
    msicCategoryReference: 'C'
  },
  {
    code: '25200',
    label: 'Manufacture of weapons and ammunition',
    msicCategoryReference: 'C'
  },
  {
    code: '25910',
    label: 'Forging, pressing, stamping and roll-forming of metal; powder metallurgy',
    msicCategoryReference: 'C'
  },
  {
    code: '25920',
    label: 'Treatment and coating of metals; machining',
    msicCategoryReference: 'C'
  },
  {
    code: '25930',
    label: 'Manufacture of cutlery, hand tools and general hardware',
    msicCategoryReference: 'C'
  },
  {
    code: '25991',
    label: 'Manufacture of tins and cans for food products, collapsible tubes and boxes',
    msicCategoryReference: 'C'
  },
  {
    code: '25992',
    label: 'Manufacture of metal cable, plaited bands and similar articles',
    msicCategoryReference: 'C'
  },
  {
    code: '25993',
    label: 'Manufacture of bolts, screws, nuts and similar threaded products',
    msicCategoryReference: 'C'
  },
  {
    code: '25994',
    label: 'Manufacture of metal household articles',
    msicCategoryReference: 'C'
  },
  {
    code: '25999',
    label: 'Manufacture of any other fabricated metal products n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '26101',
    label: 'Manufacture of diodes, transistors and similar semiconductor devices',
    msicCategoryReference: 'C'
  },
  {
    code: '26102',
    label: 'Manufacture electronic integrated circuits micro assemblies',
    msicCategoryReference: 'C'
  },
  {
    code: '26103',
    label: 'Manufacture of electrical capacitors and resistors',
    msicCategoryReference: 'C'
  },
  {
    code: '26104',
    label: 'Manufacture of printed circuit boards',
    msicCategoryReference: 'C'
  },
  {
    code: '26105',
    label: 'Manufacture of display components',
    msicCategoryReference: 'C'
  },
  {
    code: '26109',
    label: 'Manufacture of other components for electronic applications',
    msicCategoryReference: 'C'
  },
  {
    code: '26201',
    label: 'Manufacture of computers',
    msicCategoryReference: 'C'
  },
  {
    code: '26202',
    label: 'Manufacture of peripheral equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '26300',
    label: 'Manufacture of communication equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '26400',
    label: 'Manufacture of consumer electronics',
    msicCategoryReference: 'C'
  },
  {
    code: '26511',
    label: 'Manufacture of measuring, testing, navigating and control equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '26512',
    label: 'Manufacture of industrial process control equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '26520',
    label: 'Manufacture of watches and clocks and parts',
    msicCategoryReference: 'C'
  },
  {
    code: '26600',
    label: 'Manufacture of irradiation, electro medical and electrotherapeutic equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '26701',
    label: 'Manufacture of optical instruments and equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '26702',
    label: 'Manufacture of photographic equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '26800',
    label: 'Manufacture of magnetic and optical recording media',
    msicCategoryReference: 'C'
  },
  {
    code: '27101',
    label: 'Manufacture of electric motors, generators and transformers',
    msicCategoryReference: 'C'
  },
  {
    code: '27102',
    label: 'Manufacture of electricity distribution and control apparatus',
    msicCategoryReference: 'C'
  },
  {
    code: '27200',
    label: 'Manufacture of batteries and accumulators',
    msicCategoryReference: 'C'
  },
  {
    code: '27310',
    label: 'Manufacture of fibre optic cables',
    msicCategoryReference: 'C'
  },
  {
    code: '27320',
    label: 'Manufacture of other electronic and electric wires and cables',
    msicCategoryReference: 'C'
  },
  {
    code: '27330',
    label: 'Manufacture of current-carrying and non current-carrying wiring devices for electrical circuits regardless of material',
    msicCategoryReference: 'C'
  },
  {
    code: '27400',
    label: 'Manufacture of electric lighting equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '27500',
    label: 'Manufacture of domestic appliances',
    msicCategoryReference: 'C'
  },
  {
    code: '27900',
    label:
      'Manufacture of miscellaneous electrical equipment other than motors, generators and transformers, batteries and accumulators, wires and wiring devices, lighting equipment or domestic appliances',
    msicCategoryReference: 'C'
  },
  {
    code: '28110',
    label: 'Manufacture of engines and turbines, except aircraft, vehicle and cycle engines',
    msicCategoryReference: 'C'
  },
  {
    code: '28120',
    label: 'Manufacture of fluid power equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '28130',
    label: 'Manufacture of other pumps, compressors, taps and valves',
    msicCategoryReference: 'C'
  },
  {
    code: '28140',
    label: 'Manufacture of bearings, gears, gearing and driving elements',
    msicCategoryReference: 'C'
  },
  {
    code: '28150',
    label: 'Manufacture of ovens, furnaces and furnace burners',
    msicCategoryReference: 'C'
  },
  {
    code: '28160',
    label: 'Manufacture of lifting and handling equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '28170',
    label: 'Manufacture of office machinery and equipment (except computers and peripheral equipment)',
    msicCategoryReference: 'C'
  },
  {
    code: '28180',
    label: 'Manufacture of power-driven hand tools with self-contained electric or non-electric motor or pneumatic drives',
    msicCategoryReference: 'C'
  },
  {
    code: '28191',
    label: 'Manufacture of refrigerating or freezing industrial equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '28192',
    label: 'Manufacture of air-conditioning machines, including for motor vehicles',
    msicCategoryReference: 'C'
  },
  {
    code: '28199',
    label: 'Manufacture of other general-purpose machinery n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '28210',
    label: 'Manufacture of agricultural and forestry machinery',
    msicCategoryReference: 'C'
  },
  {
    code: '28220',
    label: 'Manufacture of metal-forming machinery and machine tools',
    msicCategoryReference: 'C'
  },
  {
    code: '28230',
    label: 'Manufacture of machinery for metallurgy',
    msicCategoryReference: 'C'
  },
  {
    code: '28240',
    label: 'Manufacture of machinery for mining, quarrying and construction',
    msicCategoryReference: 'C'
  },
  {
    code: '28250',
    label: 'Manufacture of machinery for food, beverage and tobacco processing',
    msicCategoryReference: 'C'
  },
  {
    code: '28260',
    label: 'Manufacture of machinery for textile, apparel and leather production',
    msicCategoryReference: 'C'
  },
  {
    code: '28290',
    label: 'Manufacture of other special-purpose machinery n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '29101',
    label: 'Manufacture of passenger cars',
    msicCategoryReference: 'C'
  },
  {
    code: '29102',
    label: 'Manufacture of commercial vehicles',
    msicCategoryReference: 'C'
  },
  {
    code: '29200',
    label: 'Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi- trailers',
    msicCategoryReference: 'C'
  },
  {
    code: '29300',
    label: 'Manufacture of parts and accessories for motor vehicles',
    msicCategoryReference: 'C'
  },
  {
    code: '30110',
    label: 'Building of ships and floating structures',
    msicCategoryReference: 'C'
  },
  {
    code: '30120',
    label: 'Building of pleasure and sporting boats',
    msicCategoryReference: 'C'
  },
  {
    code: '30200',
    label: 'Manufacture of railway locomotives and rolling stock',
    msicCategoryReference: 'C'
  },
  {
    code: '30300',
    label: 'Manufacture of air and spacecraft and related machinery',
    msicCategoryReference: 'C'
  },
  {
    code: '30400',
    label: 'Manufacture of military fighting vehicles',
    msicCategoryReference: 'C'
  },
  {
    code: '30910',
    label: 'Manufacture of motorcycles',
    msicCategoryReference: 'C'
  },
  {
    code: '30920',
    label: 'Manufacture of bicycles and invalid carriages',
    msicCategoryReference: 'C'
  },
  {
    code: '30990',
    label: 'Manufacture of other transport equipments n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '31001',
    label: 'Manufacture of wooden and cane furniture',
    msicCategoryReference: 'C'
  },
  {
    code: '31002',
    label: 'Manufacture of metal furniture',
    msicCategoryReference: 'C'
  },
  {
    code: '31003',
    label: 'Manufacture of mattress',
    msicCategoryReference: 'C'
  },
  {
    code: '31009',
    label: 'Manufacture of other furniture, except of stone, concrete or ceramic',
    msicCategoryReference: 'C'
  },
  {
    code: '32110',
    label: 'Manufacture of jewellery and related articles',
    msicCategoryReference: 'C'
  },
  {
    code: '32120',
    label: 'Manufacture of imitation jewellery and related articles',
    msicCategoryReference: 'C'
  },
  {
    code: '32200',
    label: 'Manufacture of musical instruments',
    msicCategoryReference: 'C'
  },
  {
    code: '32300',
    label: 'Manufacture of sports goods',
    msicCategoryReference: 'C'
  },
  {
    code: '32400',
    label: 'Manufacture of games and toys',
    msicCategoryReference: 'C'
  },
  {
    code: '32500',
    label: 'Manufacture of medical and dental instrument and supplies',
    msicCategoryReference: 'C'
  },
  {
    code: '32901',
    label: 'Manufacture of stationery',
    msicCategoryReference: 'C'
  },
  {
    code: '32909',
    label: 'Other manufacturing n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '33110',
    label: 'Repair of fabricated metal products',
    msicCategoryReference: 'C'
  },
  {
    code: '33120',
    label: 'Repair and maintenance of industrial machinery and equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '33131',
    label: 'Repair and maintenance of the measuring, testing, navigating and control equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '33132',
    label: 'Repair and maintenance of irradiation, electro medical and electrotherapeutic equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '33133',
    label: 'Repair of optical instruments and photographic equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '33140',
    label: 'Repair and maintenance of electrical equipment except domestic appliances',
    msicCategoryReference: 'C'
  },
  {
    code: '33150',
    label: 'Repair and maintenance of transport equipment except motorcycles and bicycles',
    msicCategoryReference: 'C'
  },
  {
    code: '33190',
    label: 'Repair and maintenance of other equipment n.e.c.',
    msicCategoryReference: 'C'
  },
  {
    code: '33200',
    label: 'Installation of industrial machinery and equipment',
    msicCategoryReference: 'C'
  },
  {
    code: '35101',
    label: 'Operation of generation facilities that produce electric energy',
    msicCategoryReference: 'D'
  },
  {
    code: '35102',
    label: 'Operation of transmission, distribution and sales of electricity',
    msicCategoryReference: 'D'
  },
  {
    code: '35201',
    label:
      'Manufacture of gaseous fuels with a specified calorific value, by purification, blending and other processes from gases of various types including natural gas',
    msicCategoryReference: 'D'
  },
  {
    code: '35202',
    label: 'Transportation, distribution and supply of gaseous fuels of all kinds through a system of mains',
    msicCategoryReference: 'D'
  },
  {
    code: '35203',
    label: 'Sale of gas to the user through mains',
    msicCategoryReference: 'D'
  },
  {
    code: '35301',
    label: 'Production, collection and distribution of steam and hot water for heating, power and other purposes',
    msicCategoryReference: 'D'
  },
  {
    code: '35302',
    label: 'Production and distribution of cooled air, chilled water for cooling purposes',
    msicCategoryReference: 'D'
  },
  {
    code: '35303',
    label: 'Production of ice, including ice for food and non-food (e.g. cooling) purposes',
    msicCategoryReference: 'D'
  },
  {
    code: '36001',
    label: 'Purification and distribution of water for water supply purposes',
    msicCategoryReference: 'E'
  },
  {
    code: '36002',
    label: 'Desalting of sea or ground water to produce water as the principal product of interest',
    msicCategoryReference: 'E'
  },
  {
    code: '37000',
    label: 'Sewerage and similar activities',
    msicCategoryReference: 'E'
  },
  {
    code: '38111',
    label: 'Collection of non-hazardous solid waste (i.e. garbage) within a local area',
    msicCategoryReference: 'E'
  },
  {
    code: '38112',
    label: 'Collection of recyclable materials',
    msicCategoryReference: 'E'
  },
  {
    code: '38113',
    label: 'Collection of refuse in litter-bins in public places',
    msicCategoryReference: 'E'
  },
  {
    code: '38114',
    label: 'Collection of construction and demolition waste',
    msicCategoryReference: 'E'
  },
  {
    code: '38115',
    label: 'Operation of waste transfer stations for non-hazardous waste',
    msicCategoryReference: 'E'
  },
  {
    code: '38121',
    label: 'Collection of hazardous waste',
    msicCategoryReference: 'E'
  },
  {
    code: '38122',
    label: 'Operation of waste transfer stations for hazardous waste',
    msicCategoryReference: 'E'
  },
  {
    code: '38210',
    label: 'Treatment and disposal of non-hazardous waste',
    msicCategoryReference: 'E'
  },
  {
    code: '38220',
    label: 'Treatment and disposal of hazardous waste',
    msicCategoryReference: 'E'
  },
  {
    code: '38301',
    label: 'Mechanical crushing of metal waste',
    msicCategoryReference: 'E'
  },
  {
    code: '38302',
    label: 'Dismantling of automobiles, computers, televisions and other equipment for material recover',
    msicCategoryReference: 'E'
  },
  {
    code: '38303',
    label: 'Reclaiming of rubber such as used tires to produce secondary raw material',
    msicCategoryReference: 'E'
  },
  {
    code: '38304',
    label: 'Reuse of rubber products',
    msicCategoryReference: 'E'
  },
  {
    code: '38309',
    label: 'Materials recovery n.e.c.',
    msicCategoryReference: 'E'
  },
  {
    code: '39000',
    label: 'Remediation activities and other waste management services',
    msicCategoryReference: 'E'
  },
  {
    code: '41001',
    label: 'Residential buildings',
    msicCategoryReference: 'F'
  },
  {
    code: '41002',
    label: 'Non-residential buildings',
    msicCategoryReference: 'F'
  },
  {
    code: '41003',
    label: 'Assembly and erection of prefabricated constructions on the site',
    msicCategoryReference: 'F'
  },
  {
    code: '41009',
    label: 'Construction of buildings n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '42101',
    label: 'Construction of motorways, streets, roads, other vehicular and pedestrian ways',
    msicCategoryReference: 'F'
  },
  {
    code: '42102',
    label: 'Surface work on streets, roads, highways, bridges or tunnels',
    msicCategoryReference: 'F'
  },
  {
    code: '42103',
    label: 'Construction of bridges, including those for elevated highways',
    msicCategoryReference: 'F'
  },
  {
    code: '42104',
    label: 'Construction of tunnels',
    msicCategoryReference: 'F'
  },
  {
    code: '42105',
    label: 'Construction of railways and subways',
    msicCategoryReference: 'F'
  },
  {
    code: '42106',
    label: 'Construction of airfield/airports runways',
    msicCategoryReference: 'F'
  },
  {
    code: '42109',
    label: 'Construction of roads and railways n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '42201',
    label: 'Long-distance pipelines, communication and power lines',
    msicCategoryReference: 'F'
  },
  {
    code: '42202',
    label: 'Urban pipelines, urban communication and power lines; ancillary urban works',
    msicCategoryReference: 'F'
  },
  {
    code: '42203',
    label: 'Water main and line construction',
    msicCategoryReference: 'F'
  },
  {
    code: '42204',
    label: 'Reservoirs',
    msicCategoryReference: 'F'
  },
  {
    code: '42205',
    label: 'Construction of irrigation systems (canals)',
    msicCategoryReference: 'F'
  },
  {
    code: '42206',
    label: 'Construction of sewer systems (including repair) and sewage disposal plants',
    msicCategoryReference: 'F'
  },
  {
    code: '42207',
    label: 'Construction of power plants',
    msicCategoryReference: 'F'
  },
  {
    code: '42209',
    label: 'Construction of utility projects n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '42901',
    label: 'Construction of refineries',
    msicCategoryReference: 'F'
  },
  {
    code: '42902',
    label: 'Construction of waterways, harbour and river works, pleasure ports (marinas), locks',
    msicCategoryReference: 'F'
  },
  {
    code: '42903',
    label: 'Construction of dams and dykes',
    msicCategoryReference: 'F'
  },
  {
    code: '42904',
    label: 'Dredging of waterways',
    msicCategoryReference: 'F'
  },
  {
    code: '42905',
    label: 'Outdoor sports facilities',
    msicCategoryReference: 'F'
  },
  {
    code: '42906',
    label: 'Land subdivision with land improvement',
    msicCategoryReference: 'F'
  },
  {
    code: '42909',
    label: 'Construction of other engineering projects n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '43110',
    label: 'Demolition or wrecking of buildings and other structures',
    msicCategoryReference: 'F'
  },
  {
    code: '43121',
    label: 'Clearing of building sites',
    msicCategoryReference: 'F'
  },
  {
    code: '43122',
    label: 'Earth moving',
    msicCategoryReference: 'F'
  },
  {
    code: '43123',
    label: 'Drilling, boring and core sampling for construction, geophysical, geological or similar purposes',
    msicCategoryReference: 'F'
  },
  {
    code: '43124',
    label: 'Site preparation for mining',
    msicCategoryReference: 'F'
  },
  {
    code: '43125',
    label: 'Drainage of agricultural or forestry land',
    msicCategoryReference: 'F'
  },
  {
    code: '43126',
    label: 'Land reclamation work',
    msicCategoryReference: 'F'
  },
  {
    code: '43129',
    label: 'Other site preparation activities n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '43211',
    label: 'Electrical wiring and fittings',
    msicCategoryReference: 'F'
  },
  {
    code: '43212',
    label: 'Telecommunications wiring',
    msicCategoryReference: 'F'
  },
  {
    code: '43213',
    label: 'Computer network and cable television wiring',
    msicCategoryReference: 'F'
  },
  {
    code: '43214',
    label: 'Satellite dishes',
    msicCategoryReference: 'F'
  },
  {
    code: '43215',
    label: 'Lighting systems',
    msicCategoryReference: 'F'
  },
  {
    code: '43216',
    label: 'Security systems',
    msicCategoryReference: 'F'
  },
  {
    code: '43219',
    label: 'Electrical installation n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '43221',
    label: 'Installation of heating systems (electric, gas and oil)',
    msicCategoryReference: 'F'
  },
  {
    code: '43222',
    label: 'Installation of furnaces, cooling towers',
    msicCategoryReference: 'F'
  },
  {
    code: '43223',
    label: 'Installation of non-electric solar energy collectors',
    msicCategoryReference: 'F'
  },
  {
    code: '43224',
    label: 'Installation of plumbing and sanitary equipment',
    msicCategoryReference: 'F'
  },
  {
    code: '43225',
    label: 'Installation of ventilation, refrigeration or air-conditioning equipment and ducts',
    msicCategoryReference: 'F'
  },
  {
    code: '43226',
    label: 'Installation of gas fittings',
    msicCategoryReference: 'F'
  },
  {
    code: '43227',
    label: 'Installation of fire and lawn sprinkler systems',
    msicCategoryReference: 'F'
  },
  {
    code: '43228',
    label: 'Steam piping',
    msicCategoryReference: 'F'
  },
  {
    code: '43229',
    label: 'Plumbing, heat and air-conditioning installation n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '43291',
    label: 'Installation of elevators, escalators in buildings or other construction projects',
    msicCategoryReference: 'F'
  },
  {
    code: '43292',
    label: 'Installation of automated and revolving doors in buildings or other construction projects',
    msicCategoryReference: 'F'
  },
  {
    code: '43293',
    label: 'Installation of lighting conductors in buildings or other construction projects',
    msicCategoryReference: 'F'
  },
  {
    code: '43294',
    label: 'Installation vacuum cleaning systems in buildings or other construction projects',
    msicCategoryReference: 'F'
  },
  {
    code: '43295',
    label: 'Installation thermal, sound or vibration insulation in buildings or other construction projects',
    msicCategoryReference: 'F'
  },
  {
    code: '43299',
    label: 'Other construction installation n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '43301',
    label:
      'Installation of doors, windows, door and window frames of wood or other materials, fitted kitchens, staircases, shop fittings and furniture',
    msicCategoryReference: 'F'
  },
  {
    code: '43302',
    label: 'Laying, tiling, hanging or fitting in buildings or other construction projects of various types of materials',
    msicCategoryReference: 'F'
  },
  {
    code: '43303',
    label: 'Interior and exterior painting of buildings',
    msicCategoryReference: 'F'
  },
  {
    code: '43304',
    label: 'Painting of civil engineering structures',
    msicCategoryReference: 'F'
  },
  {
    code: '43305',
    label: 'Installation of glass, mirrors',
    msicCategoryReference: 'F'
  },
  {
    code: '43306',
    label: 'Interior completion',
    msicCategoryReference: 'F'
  },
  {
    code: '43307',
    label: 'Cleaning of new buildings after construction',
    msicCategoryReference: 'F'
  },
  {
    code: '43309',
    label: 'Other building completion and finishing work n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '43901',
    label: 'Construction of foundations, including pile driving',
    msicCategoryReference: 'F'
  },
  {
    code: '43902',
    label: 'Erection of non-self-manufactured steel elements',
    msicCategoryReference: 'F'
  },
  {
    code: '43903',
    label: 'Scaffolds and work platform erecting and dismantling',
    msicCategoryReference: 'F'
  },
  {
    code: '43904',
    label: 'Bricklaying and stone setting',
    msicCategoryReference: 'F'
  },
  {
    code: '43905',
    label: 'Construction of outdoor swimming pools',
    msicCategoryReference: 'F'
  },
  {
    code: '43906',
    label: 'Steam cleaning, sand blasting and similar activities for building exteriors',
    msicCategoryReference: 'F'
  },
  {
    code: '43907',
    label: 'Renting of construction machinery and equipment with operator (e.g. cranes)',
    msicCategoryReference: 'F'
  },
  {
    code: '43909',
    label: 'Other specialized construction activities, n.e.c.',
    msicCategoryReference: 'F'
  },
  {
    code: '45101',
    label: 'Wholesale and retail of new motor vehicles',
    msicCategoryReference: 'G'
  },
  {
    code: '45102',
    label: 'Wholesale and retail of used motor vehicles',
    msicCategoryReference: 'G'
  },
  {
    code: '45103',
    label: 'Sale of industrial, commercial and agriculture vehicles – new',
    msicCategoryReference: 'G'
  },
  {
    code: '45104',
    label: 'Sale of industrial, commercial and agriculture vehicles – used',
    msicCategoryReference: 'G'
  },
  {
    code: '45105',
    label: 'Sale by commission agents',
    msicCategoryReference: 'G'
  },
  {
    code: '45106',
    label: 'Car auctions',
    msicCategoryReference: 'G'
  },
  {
    code: '45109',
    label: 'Sale of other motor vehicles n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '45201',
    label: 'Maintenance and repair of motor vehicles',
    msicCategoryReference: 'G'
  },
  {
    code: '45202',
    label: 'Spraying and painting',
    msicCategoryReference: 'G'
  },
  {
    code: '45203',
    label: 'Washing and polishing (car wash)',
    msicCategoryReference: 'G'
  },
  {
    code: '45204',
    label: 'Repair of motor vehicle seats',
    msicCategoryReference: 'G'
  },
  {
    code: '45205',
    label: 'Installation of parts and accessories not as part of the manufacturing process',
    msicCategoryReference: 'G'
  },
  {
    code: '45300',
    label: 'Wholesale and retail sale of all kinds of parts, components, supplies, tools and accessories for motor vehicles',
    msicCategoryReference: 'G'
  },
  {
    code: '45401',
    label: 'Wholesale and retail sale of motorcycles',
    msicCategoryReference: 'G'
  },
  {
    code: '45402',
    label: 'Wholesale and retail sale of parts and accessories for motorcycles',
    msicCategoryReference: 'G'
  },
  {
    code: '45403',
    label: 'Repair and maintenance of motorcycles',
    msicCategoryReference: 'G'
  },
  {
    code: '46100',
    label: 'Wholesale on a fee or contract basis',
    msicCategoryReference: 'G'
  },
  {
    code: '46201',
    label: 'Wholesale of rubber',
    msicCategoryReference: 'G'
  },
  {
    code: '46202',
    label: 'Wholesale of palm oil',
    msicCategoryReference: 'G'
  },
  {
    code: '46203',
    label: 'Wholesale of lumber and timber',
    msicCategoryReference: 'G'
  },
  {
    code: '46204',
    label: 'Wholesale of flowers and plants',
    msicCategoryReference: 'G'
  },
  {
    code: '46205',
    label: 'Wholesale of livestock',
    msicCategoryReference: 'G'
  },
  {
    code: '46209',
    label: 'Wholesale of agricultural raw material and live animal n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46311',
    label: 'Wholesale of meat, poultry and eggs',
    msicCategoryReference: 'G'
  },
  {
    code: '46312',
    label: 'Wholesale of fish and other seafood',
    msicCategoryReference: 'G'
  },
  {
    code: '46313',
    label: 'Wholesale of fruits',
    msicCategoryReference: 'G'
  },
  {
    code: '46314',
    label: 'Wholesale of vegetables',
    msicCategoryReference: 'G'
  },
  {
    code: '46319',
    label: 'Wholesale of meat, fish, fruits and vegetables n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46321',
    label: 'Wholesale of rice, other grains, flour and sugars',
    msicCategoryReference: 'G'
  },
  {
    code: '46322',
    label: 'Wholesale of dairy products',
    msicCategoryReference: 'G'
  },
  {
    code: '46323',
    label: 'Wholesale of confectionary',
    msicCategoryReference: 'G'
  },
  {
    code: '46324',
    label: 'Wholesale of  biscuits, cakes, breads and other bakery products',
    msicCategoryReference: 'G'
  },
  {
    code: '46325',
    label: 'Wholesale of coffee, tea, cocoa and other beverages',
    msicCategoryReference: 'G'
  },
  {
    code: '46326',
    label: 'Wholesale of beer, wine and spirits',
    msicCategoryReference: 'G'
  },
  {
    code: '46327',
    label: 'Wholesale of tobacco, cigar, cigarettes',
    msicCategoryReference: 'G'
  },
  {
    code: '46329',
    label: 'Wholesale of other foodstuffs',
    msicCategoryReference: 'G'
  },
  {
    code: '46411',
    label: 'Wholesale of yarn and fabrics',
    msicCategoryReference: 'G'
  },
  {
    code: '46412',
    label: 'Wholesale of household linen, towels, blankets',
    msicCategoryReference: 'G'
  },
  {
    code: '46413',
    label: 'Wholesale of clothing',
    msicCategoryReference: 'G'
  },
  {
    code: '46414',
    label: 'Wholesale of clothing accessories',
    msicCategoryReference: 'G'
  },
  {
    code: '46415',
    label: 'Wholesale of fur articles',
    msicCategoryReference: 'G'
  },
  {
    code: '46416',
    label: 'Wholesale of footwear',
    msicCategoryReference: 'G'
  },
  {
    code: '46417',
    label: 'Wholesale of haberdashery',
    msicCategoryReference: 'G'
  },
  {
    code: '46419',
    label: 'Wholesale of textiles, clothing n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46421',
    label: 'Wholesale of pharmaceutical and medical goods',
    msicCategoryReference: 'G'
  },
  {
    code: '46422',
    label: 'Wholesale of perfumeries, cosmetics, soap and toiletries',
    msicCategoryReference: 'G'
  },
  {
    code: '46431',
    label: 'Wholesale of bicycles and their parts and accessories',
    msicCategoryReference: 'G'
  },
  {
    code: '46432',
    label: 'Wholesale of photographic and optical goods',
    msicCategoryReference: 'G'
  },
  {
    code: '46433',
    label: 'Wholesale of leather goods and travel accessories',
    msicCategoryReference: 'G'
  },
  {
    code: '46434',
    label: 'Wholesale of musical instruments, games and toys, sports goods',
    msicCategoryReference: 'G'
  },
  {
    code: '46441',
    label: 'Wholesale of handicrafts and artificial flowers',
    msicCategoryReference: 'G'
  },
  {
    code: '46442',
    label: 'Wholesale of cut flowers and plants',
    msicCategoryReference: 'G'
  },
  {
    code: '46443',
    label: 'Wholesale of watches and clocks',
    msicCategoryReference: 'G'
  },
  {
    code: '46444',
    label: 'Wholesale of jewellery',
    msicCategoryReference: 'G'
  },
  {
    code: '46491',
    label: 'Wholesale of household furniture',
    msicCategoryReference: 'G'
  },
  {
    code: '46492',
    label: 'Wholesale of household appliances',
    msicCategoryReference: 'G'
  },
  {
    code: '46493',
    label: 'Wholesale of lighting equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '46494',
    label: 'Wholesale of household utensils and cutlery, crockery, glassware, chinaware and pottery',
    msicCategoryReference: 'G'
  },
  {
    code: '46495',
    label: 'Wholesale of woodenware, wickerwork and corkware',
    msicCategoryReference: 'G'
  },
  {
    code: '46496',
    label: 'Wholesale of electrical and electronic goods',
    msicCategoryReference: 'G'
  },
  {
    code: '46497',
    label: 'Wholesale of stationery, books, magazines and newspapers',
    msicCategoryReference: 'G'
  },
  {
    code: '46499',
    label: 'Wholesale of other household goods n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46510',
    label: 'Wholesale of computer hardware, software and peripherals',
    msicCategoryReference: 'G'
  },
  {
    code: '46521',
    label: 'Wholesale of telephone and telecommunications equipment, cell phones, pagers',
    msicCategoryReference: 'G'
  },
  {
    code: '46522',
    label: 'Wholesale of electronic components and wiring accessories',
    msicCategoryReference: 'G'
  },
  {
    code: '46531',
    label: 'Wholesale of agricultural machinery, equipment and supplies',
    msicCategoryReference: 'G'
  },
  {
    code: '46532',
    label: 'Wholesale of lawn mowers however operated',
    msicCategoryReference: 'G'
  },
  {
    code: '46591',
    label: 'Wholesale of office machinery and business equipment, except computers and computer peripheral equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '46592',
    label: 'Wholesale of office furniture',
    msicCategoryReference: 'G'
  },
  {
    code: '46593',
    label: 'Wholesale of computer-controlled machines tools',
    msicCategoryReference: 'G'
  },
  {
    code: '46594',
    label: 'Wholesale of industrial machinery, equipment and supplies',
    msicCategoryReference: 'G'
  },
  {
    code: '46595',
    label: 'Wholesale of construction and civil engineering machinery and equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '46596',
    label: 'Wholesale of lift escalators, air-conditioning, security and fire fighting equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '46599',
    label: 'Wholesale of other machinery for use in industry, trade and navigation and other services n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46611',
    label: 'Wholesale of petrol, diesel, lubricants',
    msicCategoryReference: 'G'
  },
  {
    code: '46612',
    label: 'Wholesale of liquefied petroleum gas',
    msicCategoryReference: 'G'
  },
  {
    code: '46619',
    label: 'Wholesale of other solid, liquid and gaseous fuels and related products n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46621',
    label: 'Wholesale of ferrous and non-ferrous metal ores and metals',
    msicCategoryReference: 'G'
  },
  {
    code: '46622',
    label: 'Wholesale of ferrous and non-ferrous semi-finished metal ores and products n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46631',
    label: 'Wholesale of logs, sawn timber, plywood, veneer and related products',
    msicCategoryReference: 'G'
  },
  {
    code: '46632',
    label: 'Wholesale of paints and varnish',
    msicCategoryReference: 'G'
  },
  {
    code: '46633',
    label: 'Wholesale of construction materials',
    msicCategoryReference: 'G'
  },
  {
    code: '46634',
    label: 'Wholesale of fittings and fixtures',
    msicCategoryReference: 'G'
  },
  {
    code: '46635',
    label: 'Wholesale of hot water heaters',
    msicCategoryReference: 'G'
  },
  {
    code: '46636',
    label: 'Wholesale of sanitary installation and equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '46637',
    label: 'Wholesale of tools',
    msicCategoryReference: 'G'
  },
  {
    code: '46639',
    label: 'Wholesale of other construction materials, hardware, plumbing and heating equipment and supplies n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '46691',
    label: 'Wholesale of industrial chemicals',
    msicCategoryReference: 'G'
  },
  {
    code: '46692',
    label: 'Wholesale of fertilizers and agrochemical products',
    msicCategoryReference: 'G'
  },
  {
    code: '46693',
    label: 'Wholesale of plastic materials in primary forms',
    msicCategoryReference: 'G'
  },
  {
    code: '46694',
    label: 'Wholesale of rubber scrap',
    msicCategoryReference: 'G'
  },
  {
    code: '46695',
    label: 'Wholesale of textile fibres',
    msicCategoryReference: 'G'
  },
  {
    code: '46696',
    label: 'Wholesale of paper in bulk, packaging materials',
    msicCategoryReference: 'G'
  },
  {
    code: '46697',
    label: 'Wholesale of precious stones',
    msicCategoryReference: 'G'
  },
  {
    code: '46698',
    label: 'Wholesale of metal and non-metal waste and scrap and materials for recycling',
    msicCategoryReference: 'G'
  },
  {
    code: '46699',
    label: 'Dismantling of automobiles, computer, televisions and other equipment to obtain and re-sell usable parts',
    msicCategoryReference: 'G'
  },
  {
    code: '46901',
    label: 'Wholesale of aquarium fishes, pet birds and animals',
    msicCategoryReference: 'G'
  },
  {
    code: '46902',
    label: 'Wholesale of animal/pet food',
    msicCategoryReference: 'G'
  },
  {
    code: '46909',
    label: 'Wholesale of a variety of goods without any particular specialization n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '47111',
    label: 'Provision stores',
    msicCategoryReference: 'G'
  },
  {
    code: '47112',
    label: 'Supermarket',
    msicCategoryReference: 'G'
  },
  {
    code: '47113',
    label: 'Mini market',
    msicCategoryReference: 'G'
  },
  {
    code: '47114',
    label: 'Convenience stores',
    msicCategoryReference: 'G'
  },
  {
    code: '47191',
    label: 'Department stores',
    msicCategoryReference: 'G'
  },
  {
    code: '47192',
    label: 'Department stores and supermarket',
    msicCategoryReference: 'G'
  },
  {
    code: '47193',
    label: 'Hypermarket',
    msicCategoryReference: 'G'
  },
  {
    code: '47194',
    label: 'News agent and miscellaneous goods store',
    msicCategoryReference: 'G'
  },
  {
    code: '47199',
    label: 'Other retail sale in non-specialized stores n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '47211',
    label: 'Retail sale of rice, flour, other grains and sugars',
    msicCategoryReference: 'G'
  },
  {
    code: '47212',
    label: 'Retail sale of fresh or preserved vegetables and fruits',
    msicCategoryReference: 'G'
  },
  {
    code: '47213',
    label: 'Retail sale of dairy products and eggs',
    msicCategoryReference: 'G'
  },
  {
    code: '47214',
    label: 'Retail sale of meat and meat products (including poultry)',
    msicCategoryReference: 'G'
  },
  {
    code: '47215',
    label: 'Retail sale of fish, other seafood and products thereof',
    msicCategoryReference: 'G'
  },
  {
    code: '47216',
    label: 'Retail sale of bakery products and sugar confectionery',
    msicCategoryReference: 'G'
  },
  {
    code: '47217',
    label: 'Retail sale of mee, kuey teow, mee hoon, wantan skins and other food products made from flour or soya',
    msicCategoryReference: 'G'
  },
  {
    code: '47219',
    label: 'Retail sale of other food products n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '47221',
    label: 'Retail sale of beer, wine and spirits',
    msicCategoryReference: 'G'
  },
  {
    code: '47222',
    label: 'Retail sale of tea, coffee, soft drinks, mineral water and other beverages',
    msicCategoryReference: 'G'
  },
  {
    code: '47230',
    label: 'Retail sale of tobacco products in specialized store',
    msicCategoryReference: 'G'
  },
  {
    code: '47300',
    label: 'Retail sale of automotive fuel in specialized stores',
    msicCategoryReference: 'G'
  },
  {
    code: '47412',
    label: 'Retail sale of video game consoles and non-customized software',
    msicCategoryReference: 'G'
  },
  {
    code: '47413',
    label: 'Retail sale of telecommunication equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '47420',
    label: 'Retail sale of audio and video equipment in specialized store',
    msicCategoryReference: 'G'
  },
  {
    code: '47510',
    label: 'Retail sale of textiles in specialized stores',
    msicCategoryReference: 'G'
  },
  {
    code: '47531',
    label: 'Retail sale of carpets and rugs',
    msicCategoryReference: 'G'
  },
  {
    code: '47532',
    label: 'Retail sale of curtains and net curtains',
    msicCategoryReference: 'G'
  },
  {
    code: '47533',
    label: 'Retail sale of wallpaper and floor coverings',
    msicCategoryReference: 'G'
  },
  {
    code: '47591',
    label: 'Retail sale of household furniture',
    msicCategoryReference: 'G'
  },
  {
    code: '47592',
    label: 'Retail sale of articles for lighting',
    msicCategoryReference: 'G'
  },
  {
    code: '47593',
    label: 'Retail sale of household utensils and cutlery, crockery, glassware, chinaware and pottery',
    msicCategoryReference: 'G'
  },
  {
    code: '47594',
    label: 'Retail sale of wood, cork goods and wickerwork goods',
    msicCategoryReference: 'G'
  },
  {
    code: '47595',
    label: 'Retail sale of household appliances',
    msicCategoryReference: 'G'
  },
  {
    code: '47596',
    label: 'Retail sale of musical instruments and scores',
    msicCategoryReference: 'G'
  },
  {
    code: '47597',
    label: 'Retail sale of security systems',
    msicCategoryReference: 'G'
  },
  {
    code: '47598',
    label: 'Retail sale of household articles and equipment n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '47611',
    label: 'Retail sale of office supplies and equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '47612',
    label: 'Retail sale of books, newspapers and stationary',
    msicCategoryReference: 'G'
  },
  {
    code: '47631',
    label: 'Retail sale of sports goods and equipments',
    msicCategoryReference: 'G'
  },
  {
    code: '47632',
    label: 'Retail sale of fishing equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '47633',
    label: 'Retail sale of camping goods',
    msicCategoryReference: 'G'
  },
  {
    code: '47634',
    label: 'Retail sale of boats and equipments',
    msicCategoryReference: 'G'
  },
  {
    code: '47635',
    label: 'Retail sale of bicycles and related parts and accessories',
    msicCategoryReference: 'G'
  },
  {
    code: '47640',
    label: 'Retail sale of games and toys, made of all materials',
    msicCategoryReference: 'G'
  },
  {
    code: '47711',
    label: 'Retail sale of articles of clothing, articles of fur and clothing accessories',
    msicCategoryReference: 'G'
  },
  {
    code: '47712',
    label: 'Retail sale of footwear',
    msicCategoryReference: 'G'
  },
  {
    code: '47713',
    label: 'Retail sale of leather goods, accessories of leather and leather substitutes',
    msicCategoryReference: 'G'
  },
  {
    code: '47721',
    label: 'Stores specialized in retail sale of pharmaceuticals, medical and orthopaedic goods',
    msicCategoryReference: 'G'
  },
  {
    code: '47722',
    label: 'Stores specialized in retail sale of perfumery, cosmetic and toilet articles',
    msicCategoryReference: 'G'
  },
  {
    code: '47731',
    label: 'Retail sale of photographic and precision equipment',
    msicCategoryReference: 'G'
  },
  {
    code: '47732',
    label: 'Retail sale of watches and clocks',
    msicCategoryReference: 'G'
  },
  {
    code: '47733',
    label: 'Retail sale of jewellery',
    msicCategoryReference: 'G'
  },
  {
    code: '47734',
    label: 'Retail sale of flowers, plants, seeds, fertilizers',
    msicCategoryReference: 'G'
  },
  {
    code: '47735',
    label: 'Retail sale of souvenirs, craftwork and religious articles',
    msicCategoryReference: 'G'
  },
  {
    code: '47736',
    label: 'Retail sale of household fuel oil, cooking gas, coal and fuel wood',
    msicCategoryReference: 'G'
  },
  {
    code: '47737',
    label: 'Retail sale of spectacles and other optical goods',
    msicCategoryReference: 'G'
  },
  {
    code: '47738',
    label: 'Retail sale of aquarium fishes, pet animals and pet food',
    msicCategoryReference: 'G'
  },
  {
    code: '47739',
    label: 'Other retail sale of new goods in specialized stores n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '47741',
    label: 'Retail sale of second-hand books',
    msicCategoryReference: 'G'
  },
  {
    code: '47742',
    label: 'Retail sale of second-hand electrical and electronic goods',
    msicCategoryReference: 'G'
  },
  {
    code: '47743',
    label: 'Retail sale of antiques',
    msicCategoryReference: 'G'
  },
  {
    code: '47744',
    label: 'Activities of auctioning houses (retail)',
    msicCategoryReference: 'G'
  },
  {
    code: '47749',
    label: 'Retail sale of second-hand goods n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '47810',
    label: 'Retail sale of food, beverages and tobacco products via stalls or markets',
    msicCategoryReference: 'G'
  },
  {
    code: '47820',
    label: 'Retail sale of textiles, clothing and footwear via stalls or markets',
    msicCategoryReference: 'G'
  },
  {
    code: '47891',
    label: 'Retail sale of carpets and rugs via stalls or markets',
    msicCategoryReference: 'G'
  },
  {
    code: '47893',
    label: 'Retail sale of games and toys via stalls or markets',
    msicCategoryReference: 'G'
  },
  {
    code: '47894',
    label: 'Retail sale of household appliances and consumer electronics via stall or markets',
    msicCategoryReference: 'G'
  },
  {
    code: '47895',
    label: 'Retail sale of music and video recordings via stall or markets',
    msicCategoryReference: 'G'
  },
  {
    code: '47911',
    label: 'Retail sale of any kind of product by mail order',
    msicCategoryReference: 'G'
  },
  {
    code: '47912',
    label: 'Retail sale of any kind of product over the Internet',
    msicCategoryReference: 'G'
  },
  {
    code: '47913',
    label: 'Direct sale via television, radio and telephone',
    msicCategoryReference: 'G'
  },
  {
    code: '47914',
    label: 'Internet retail auctions',
    msicCategoryReference: 'G'
  },
  {
    code: '47992',
    label: 'Retail sale of any kind of product through vending machines',
    msicCategoryReference: 'G'
  },
  {
    code: '47999',
    label: 'Other retail sale not in stores, stalls or markets n.e.c.',
    msicCategoryReference: 'G'
  },
  {
    code: '49110',
    label: 'Passenger transport by inter-urban railways',
    msicCategoryReference: 'H'
  },
  {
    code: '49120',
    label: 'Freight transport by inter-urban, suburban and urban railways',
    msicCategoryReference: 'H'
  },
  {
    code: '49211',
    label: 'City bus services',
    msicCategoryReference: 'H'
  },
  {
    code: '49212',
    label: 'Urban and suburban railway passenger transport service',
    msicCategoryReference: 'H'
  },
  {
    code: '49221',
    label: 'Express bus services',
    msicCategoryReference: 'H'
  },
  {
    code: '49222',
    label: 'Employees bus services',
    msicCategoryReference: 'H'
  },
  {
    code: '49223',
    label: 'School bus services',
    msicCategoryReference: 'H'
  },
  {
    code: '49224',
    label: 'Taxi operation and limousine services',
    msicCategoryReference: 'H'
  },
  {
    code: '49225',
    label: 'Rental of cars with driver',
    msicCategoryReference: 'H'
  },
  {
    code: '49229',
    label: 'Other passenger land transport n.e.c.',
    msicCategoryReference: 'H'
  },
  {
    code: '49230',
    label: 'Freight transport by road',
    msicCategoryReference: 'H'
  },
  {
    code: '49300',
    label: 'Transport via pipeline',
    msicCategoryReference: 'H'
  },
  {
    code: '50111',
    label: 'Operation of excursion, cruise or sightseeing boats',
    msicCategoryReference: 'H'
  },
  {
    code: '50112',
    label: 'Operation of ferries, water taxis',
    msicCategoryReference: 'H'
  },
  {
    code: '50113',
    label: 'Rental of pleasure boats with crew for sea and coastal water transport',
    msicCategoryReference: 'H'
  },
  {
    code: '50121',
    label: 'Transport of freight overseas and coastal waters, whether scheduled or not',
    msicCategoryReference: 'H'
  },
  {
    code: '50122',
    label: 'Transport by towing or pushing of barges, oil rigs',
    msicCategoryReference: 'H'
  },
  {
    code: '50211',
    label: 'Transport of passenger via rivers, canals, lakes and other inland waterways',
    msicCategoryReference: 'H'
  },
  {
    code: '50212',
    label: 'Rental of pleasure boats with crew for inland water transport',
    msicCategoryReference: 'H'
  },
  {
    code: '50220',
    label: 'Transport of freight via rivers, canals, lakes and other inland waterways',
    msicCategoryReference: 'H'
  },
  {
    code: '51101',
    label: 'Transport of passengers by air over regular routes and on regular schedules',
    msicCategoryReference: 'H'
  },
  {
    code: '51102',
    label: 'Non-scheduled transport of passenger by air',
    msicCategoryReference: 'H'
  },
  {
    code: '51103',
    label: 'Renting of air-transport equipment with operator for the purpose of passenger transportation',
    msicCategoryReference: 'H'
  },
  {
    code: '51201',
    label: 'Transport freight by air over regular routes and on regular schedules',
    msicCategoryReference: 'H'
  },
  {
    code: '51202',
    label: 'Non-scheduled transport of freight by air',
    msicCategoryReference: 'H'
  },
  {
    code: '51203',
    label: 'Renting of air-transport equipment with operator for the purpose of freight transportation',
    msicCategoryReference: 'H'
  },
  {
    code: '52100',
    label: 'Warehousing and storage services',
    msicCategoryReference: 'H'
  },
  {
    code: '52211',
    label: 'Operation of terminal facilities',
    msicCategoryReference: 'H'
  },
  {
    code: '52212',
    label: 'Towing and road side assistance',
    msicCategoryReference: 'H'
  },
  {
    code: '52213',
    label: 'Operation of parking facilities for motor vehicles (parking lots)',
    msicCategoryReference: 'H'
  },
  {
    code: '52214',
    label: 'Highway, bridge and tunnel operation services',
    msicCategoryReference: 'H'
  },
  {
    code: '52219',
    label: 'Other service activities incidental to land transportation n.e.c.',
    msicCategoryReference: 'H'
  },
  {
    code: '52221',
    label: 'Port, harbours and piers operation services',
    msicCategoryReference: 'H'
  },
  {
    code: '52222',
    label: 'Vessel salvage and refloating services',
    msicCategoryReference: 'H'
  },
  {
    code: '52229',
    label: 'Other service activities incidental to water transportation n.e.c.',
    msicCategoryReference: 'H'
  },
  {
    code: '52231',
    label: 'Operation of terminal facilities',
    msicCategoryReference: 'H'
  },
  {
    code: '52232',
    label: 'Airport and air-traffic-control activities',
    msicCategoryReference: 'H'
  },
  {
    code: '52233',
    label: 'Ground service activities on airfields',
    msicCategoryReference: 'H'
  },
  {
    code: '52234',
    label: 'Fire fighting and fire-prevention services at airports',
    msicCategoryReference: 'H'
  },
  {
    code: '52239',
    label: 'Other service activities incidental to air transportation n.e.c.',
    msicCategoryReference: 'H'
  },
  {
    code: '52241',
    label: 'Stevedoring services',
    msicCategoryReference: 'H'
  },
  {
    code: '52249',
    label: 'Other cargo handling activities n.e.c.',
    msicCategoryReference: 'H'
  },
  {
    code: '52291',
    label: 'Forwarding of freight',
    msicCategoryReference: 'H'
  },
  {
    code: '52292',
    label: 'Brokerage for ship and aircraft space',
    msicCategoryReference: 'H'
  },
  {
    code: '52299',
    label: 'Other transportation support activities n.e.c.',
    msicCategoryReference: 'H'
  },
  {
    code: '53100',
    label: 'National postal services',
    msicCategoryReference: 'H'
  },
  {
    code: '53200',
    label: 'Courier activities other than national post activities',
    msicCategoryReference: 'H'
  },
  {
    code: '55101',
    label: 'Hotels and resort hotels',
    msicCategoryReference: 'I'
  },
  {
    code: '55102',
    label: 'Motels',
    msicCategoryReference: 'I'
  },
  {
    code: '55103',
    label: 'Apartment hotels',
    msicCategoryReference: 'I'
  },
  {
    code: '55104',
    label: 'Chalets',
    msicCategoryReference: 'I'
  },
  {
    code: '55105',
    label: 'Rest house/guest house',
    msicCategoryReference: 'I'
  },
  {
    code: '55106',
    label: 'Bed and breakfast units',
    msicCategoryReference: 'I'
  },
  {
    code: '55107',
    label: 'Hostels',
    msicCategoryReference: 'I'
  },
  {
    code: '55108',
    label: 'Home stay',
    msicCategoryReference: 'I'
  },
  {
    code: '55109',
    label: 'Other short term accommodation activities n.e.c.',
    msicCategoryReference: 'I'
  },
  {
    code: '55200',
    label: 'Camping grounds, recreational vehicle parks and trailer parks',
    msicCategoryReference: 'I'
  },
  {
    code: '55900',
    label: 'Other accommodation',
    msicCategoryReference: 'I'
  },
  {
    code: '56103',
    label: 'Fast-food restaurants',
    msicCategoryReference: 'I'
  },
  {
    code: '56104',
    label: 'Ice cream truck vendors and parlours',
    msicCategoryReference: 'I'
  },
  {
    code: '56105',
    label: 'Mobile food carts',
    msicCategoryReference: 'I'
  },
  {
    code: '56106',
    label: 'Food stalls/hawkers',
    msicCategoryReference: 'I'
  },
  {
    code: '56107',
    label: 'Food or beverage, food and beverage preparation in market stalls/hawkers',
    msicCategoryReference: 'I'
  },
  {
    code: '56210',
    label: 'Event/food caterers',
    msicCategoryReference: 'I'
  },
  {
    code: '56290',
    label: 'Other food service activities',
    msicCategoryReference: 'I'
  },
  {
    code: '56301',
    label: 'Pubs, bars, discotheques, coffee houses, cocktail lounges and karaoke',
    msicCategoryReference: 'I'
  },
  {
    code: '56302',
    label: 'Coffee shops',
    msicCategoryReference: 'I'
  },
  {
    code: '56303',
    label: 'Drink stalls/hawkers',
    msicCategoryReference: 'I'
  },
  {
    code: '56304',
    label: 'Mobile beverage',
    msicCategoryReference: 'I'
  },
  {
    code: '56309',
    label: 'Others drinking places n.e.c.',
    msicCategoryReference: 'I'
  },
  {
    code: '58110',
    label: 'Publishing of books, brochures and other publications',
    msicCategoryReference: 'J'
  },
  {
    code: '58120',
    label: 'Publishing of mailing lists, telephone book, other directories',
    msicCategoryReference: 'J'
  },
  {
    code: '58130',
    label: 'Publishing of newspapers, journals, magazines and periodicals in print or electronic form',
    msicCategoryReference: 'J'
  },
  {
    code: '58190',
    label:
      'Publishing of catalogues, photos, engraving and postcards, greeting cards, forms, posters, reproduction of works of art, advertising material and other printed matter n.e.c.',
    msicCategoryReference: 'J'
  },
  {
    code: '58201',
    label: 'Business and other applications',
    msicCategoryReference: 'J'
  },
  {
    code: '58202',
    label: 'Computer games for all platforms',
    msicCategoryReference: 'J'
  },
  {
    code: '58203',
    label: 'Operating systems',
    msicCategoryReference: 'J'
  },
  {
    code: '59110',
    label: 'Motion picture, video and television programme production activities',
    msicCategoryReference: 'J'
  },
  {
    code: '59120',
    label: 'Motion picture, video and television programme post-production activities',
    msicCategoryReference: 'J'
  },
  {
    code: '59130',
    label: 'Motion picture, video and television programme distribution activities',
    msicCategoryReference: 'J'
  },
  {
    code: '59140',
    label: 'Motion picture projection activities',
    msicCategoryReference: 'J'
  },
  {
    code: '59200',
    label: 'Sound recording and music publishing activities',
    msicCategoryReference: 'J'
  },
  {
    code: '60100',
    label: 'Radio broadcasting',
    msicCategoryReference: 'J'
  },
  {
    code: '60200',
    label: 'Television programming and broadcasting activities',
    msicCategoryReference: 'J'
  },
  {
    code: '61101',
    label: 'Wired telecommunications services',
    msicCategoryReference: 'J'
  },
  {
    code: '61102',
    label: 'Internet access providers by the operator of the wired infrastructure',
    msicCategoryReference: 'J'
  },
  {
    code: '61201',
    label: 'Wireless telecommunications services',
    msicCategoryReference: 'J'
  },
  {
    code: '61202',
    label: 'Internet access providers by the operator of the wireless infrastructure',
    msicCategoryReference: 'J'
  },
  {
    code: '61300',
    label: 'Satellite telecommunications services',
    msicCategoryReference: 'J'
  },
  {
    code: '61901',
    label: 'Provision of Internet access over networks between the client and the ISP not owned or controlled by the ISP',
    msicCategoryReference: 'J'
  },
  {
    code: '61902',
    label: 'Provision of telecommunications services over existing telecom connection',
    msicCategoryReference: 'J'
  },
  {
    code: '61903',
    label: 'Telecommunications resellers',
    msicCategoryReference: 'J'
  },
  {
    code: '61904',
    label: 'Provision of telecommunications services over existing telecom connections VOIP (Voice Over Internet Protocol) provision',
    msicCategoryReference: 'J'
  },
  {
    code: '61905',
    label: 'Provision of specialized telecommunications applications',
    msicCategoryReference: 'J'
  },
  {
    code: '61909',
    label: 'Other telecommunications activities n.e.c.',
    msicCategoryReference: 'J'
  },
  {
    code: '62010',
    label: 'Computer programming activities',
    msicCategoryReference: 'J'
  },
  {
    code: '62021',
    label: 'Computer consultancy',
    msicCategoryReference: 'J'
  },
  {
    code: '62022',
    label: 'Computer facilities management activities',
    msicCategoryReference: 'J'
  },
  {
    code: '62091',
    label: 'Information Communication Technology (ICT) system security',
    msicCategoryReference: 'J'
  },
  {
    code: '62099',
    label: 'Other information technology service activities n.e.c.',
    msicCategoryReference: 'J'
  },
  {
    code: '63111',
    label: 'Activities of providing infrastructure for hosting, data processing services and related activities',
    msicCategoryReference: 'J'
  },
  {
    code: '63112',
    label: 'Data processing activities',
    msicCategoryReference: 'J'
  },
  {
    code: '63120',
    label: 'Web portals',
    msicCategoryReference: 'J'
  },
  {
    code: '63910',
    label: 'News syndicate and news agency activities',
    msicCategoryReference: 'J'
  },
  {
    code: '63990',
    label: 'Other information service activities n.e.c.',
    msicCategoryReference: 'J'
  },
  {
    code: '64110',
    label: 'Central banking',
    msicCategoryReference: 'K'
  },
  {
    code: '64191',
    label: 'Commercial Banks',
    msicCategoryReference: 'K'
  },
  {
    code: '64192',
    label: 'Islamic Banks',
    msicCategoryReference: 'K'
  },
  {
    code: '64193',
    label: 'Offshore Banks',
    msicCategoryReference: 'K'
  },
  {
    code: '64194',
    label: 'Investment Banks',
    msicCategoryReference: 'K'
  },
  {
    code: '64195',
    label: 'Development financial institutions (with deposit taking functions)',
    msicCategoryReference: 'K'
  },
  {
    code: '64199',
    label: 'Other monetary intermediation (with deposit taking functions) n.e.c.',
    msicCategoryReference: 'K'
  },
  {
    code: '64200',
    label: 'Activities of holding companies',
    msicCategoryReference: 'K'
  },
  {
    code: '64301',
    label: 'Venture capital companies',
    msicCategoryReference: 'K'
  },
  {
    code: '64302',
    label: 'Unit trust fund excludes REITs',
    msicCategoryReference: 'K'
  },
  {
    code: '64303',
    label: 'Property unit trust (REITs)',
    msicCategoryReference: 'K'
  },
  {
    code: '64304',
    label: 'Other administration of trusts accounts',
    msicCategoryReference: 'K'
  },
  {
    code: '64309',
    label: 'Trusts, funds and similar financial entities n.e.c.',
    msicCategoryReference: 'K'
  },
  {
    code: '64910',
    label: 'Financial leasing activities',
    msicCategoryReference: 'K'
  },
  {
    code: '64921',
    label: 'Development financial institutions (without deposit taking functions)',
    msicCategoryReference: 'K'
  },
  {
    code: '64922',
    label: 'Credit card services',
    msicCategoryReference: 'K'
  },
  {
    code: '64923',
    label: 'Licensed money lending activities',
    msicCategoryReference: 'K'
  },
  {
    code: '64924',
    label: 'Pawnshops and pawnbrokers includes Ar-Rahnu',
    msicCategoryReference: 'K'
  },
  {
    code: '64925',
    label: 'Co-operative with credits functions',
    msicCategoryReference: 'K'
  },
  {
    code: '64929',
    label: 'Other credit granting n.e.c.',
    msicCategoryReference: 'K'
  },
  {
    code: '64991',
    label: 'Factoring companies',
    msicCategoryReference: 'K'
  },
  {
    code: '64992',
    label: 'Representative office of foreign banks',
    msicCategoryReference: 'K'
  },
  {
    code: '64993',
    label: 'Nominee companies',
    msicCategoryReference: 'K'
  },
  {
    code: '64999',
    label: 'Other financial service activities, except insurance/takaful and pension funding n.e.c.',
    msicCategoryReference: 'K'
  },
  {
    code: '65111',
    label: 'Life insurance',
    msicCategoryReference: 'K'
  },
  {
    code: '65112',
    label: 'Family takaful',
    msicCategoryReference: 'K'
  },
  {
    code: '65121',
    label: 'General insurance',
    msicCategoryReference: 'K'
  },
  {
    code: '65122',
    label: 'General takaful',
    msicCategoryReference: 'K'
  },
  {
    code: '65123',
    label: 'Composite insurance',
    msicCategoryReference: 'K'
  },
  {
    code: '65124',
    label: 'Offshore insurance',
    msicCategoryReference: 'K'
  },
  {
    code: '65125',
    label: 'Offshore takaful',
    msicCategoryReference: 'K'
  },
  {
    code: '65201',
    label: 'Life reinsurance',
    msicCategoryReference: 'K'
  },
  {
    code: '65202',
    label: 'Family retakaful',
    msicCategoryReference: 'K'
  },
  {
    code: '65203',
    label: 'General reinsurance',
    msicCategoryReference: 'K'
  },
  {
    code: '65204',
    label: 'General retakaful',
    msicCategoryReference: 'K'
  },
  {
    code: '65205',
    label: 'Composite retakaful',
    msicCategoryReference: 'K'
  },
  {
    code: '65206',
    label: 'Offshore reinsurance',
    msicCategoryReference: 'K'
  },
  {
    code: '65207',
    label: 'Offshore retakaful',
    msicCategoryReference: 'K'
  },
  {
    code: '65301',
    label: 'Pension funding',
    msicCategoryReference: 'K'
  },
  {
    code: '65302',
    label: 'Provident funding',
    msicCategoryReference: 'K'
  },
  {
    code: '66111',
    label: 'Stock exchanges',
    msicCategoryReference: 'K'
  },
  {
    code: '66112',
    label: 'Exchanges for commodity contracts',
    msicCategoryReference: 'K'
  },
  {
    code: '66113',
    label: 'Securities exchange',
    msicCategoryReference: 'K'
  },
  {
    code: '66114',
    label: 'Exchanges for commodity futures contracts',
    msicCategoryReference: 'K'
  },
  {
    code: '66119',
    label: 'Administration of financial markets n.e.c.',
    msicCategoryReference: 'K'
  },
  {
    code: '66121',
    label: 'Stock, share and bond brokers',
    msicCategoryReference: 'K'
  },
  {
    code: '66122',
    label: 'Commodity brokers and dealers',
    msicCategoryReference: 'K'
  },
  {
    code: '66123',
    label: 'Gold bullion dealers',
    msicCategoryReference: 'K'
  },
  {
    code: '66124',
    label: 'Foreign exchange broker and dealers (Bureaux de change)',
    msicCategoryReference: 'K'
  },
  {
    code: '66125',
    label: 'Money-changing services',
    msicCategoryReference: 'K'
  },
  {
    code: '66129',
    label: 'Other financial and commodity futures brokers and dealers',
    msicCategoryReference: 'K'
  },
  {
    code: '66191',
    label: 'Investment advisory services',
    msicCategoryReference: 'K'
  },
  {
    code: '66192',
    label: 'Financial consultancy services',
    msicCategoryReference: 'K'
  },
  {
    code: '66199',
    label: 'Activities auxiliary to finance n.e.c.',
    msicCategoryReference: 'K'
  },
  {
    code: '66211',
    label: 'Insurance adjusting service',
    msicCategoryReference: 'K'
  },
  {
    code: '66212',
    label: 'Takaful adjusting service',
    msicCategoryReference: 'K'
  },
  {
    code: '66221',
    label: 'Insurance agents',
    msicCategoryReference: 'K'
  },
  {
    code: '66222',
    label: 'Takaful agents',
    msicCategoryReference: 'K'
  },
  {
    code: '66223',
    label: 'Insurance brokers',
    msicCategoryReference: 'K'
  },
  {
    code: '66224',
    label: 'Takaful brokers',
    msicCategoryReference: 'K'
  },
  {
    code: '66290',
    label: 'Other activities auxiliary to insurance, takaful and pension funding',
    msicCategoryReference: 'K'
  },
  {
    code: '66301',
    label: 'Management of pension funds',
    msicCategoryReference: 'K'
  },
  {
    code: '66302',
    label: 'Assets/portfolio management',
    msicCategoryReference: 'K'
  },
  {
    code: '66303',
    label: 'Unit trust management companies',
    msicCategoryReference: 'K'
  },
  {
    code: '68101',
    label: 'Buying, selling, renting and operating of self-owned or leased real estate – residential buildings',
    msicCategoryReference: 'L'
  },
  {
    code: '68102',
    label: 'Buying, selling, renting and operating of self-owned or leased real estate – non-residential buildings',
    msicCategoryReference: 'L'
  },
  {
    code: '68103',
    label: 'Buying, selling, renting and operating of self-owned or leased real estate – land',
    msicCategoryReference: 'L'
  },
  {
    code: '68104',
    label: 'Development of building projects for own operation, i.e. for renting of space in these buildings',
    msicCategoryReference: 'L'
  },
  {
    code: '68109',
    label: 'Real estate activities with own or leased property n.e.c.',
    msicCategoryReference: 'L'
  },
  {
    code: '68201',
    label: 'Activities of real estate agents and brokers for buying, selling and renting of real estate',
    msicCategoryReference: 'L'
  },
  {
    code: '68202',
    label: 'Management of real estate on a fee or contract basis',
    msicCategoryReference: 'L'
  },
  {
    code: '68203',
    label: 'Appraisal services for real estate',
    msicCategoryReference: 'L'
  },
  {
    code: '68209',
    label: 'Real estate activities on a fee or contract basis n.e.c.',
    msicCategoryReference: 'L'
  },
  {
    code: '69100',
    label: 'Legal activities',
    msicCategoryReference: 'M'
  },
  {
    code: '69200',
    label: 'Accounting, bookkeeping and auditing activities; tax consultancy',
    msicCategoryReference: 'M'
  },
  {
    code: '70100',
    label: 'Activities of head offices',
    msicCategoryReference: 'M'
  },
  {
    code: '70201',
    label: 'Business management consultancy services',
    msicCategoryReference: 'M'
  },
  {
    code: '70202',
    label: 'Human resource consultancy services',
    msicCategoryReference: 'M'
  },
  {
    code: '70203',
    label: 'Consultancy services in public relation and communications',
    msicCategoryReference: 'M'
  },
  {
    code: '70209',
    label: 'Other management consultancy activities n.e.c',
    msicCategoryReference: 'M'
  },
  {
    code: '71101',
    label: 'Architectural services',
    msicCategoryReference: 'M'
  },
  {
    code: '71102',
    label: 'Engineering services',
    msicCategoryReference: 'M'
  },
  {
    code: '71103',
    label: 'Land surveying services',
    msicCategoryReference: 'M'
  },
  {
    code: '71109',
    label: 'Other architectural and engineering activities and related technical consultancy n.e.c.',
    msicCategoryReference: 'M'
  },
  {
    code: '71200',
    label: 'Technical testing and analysis',
    msicCategoryReference: 'M'
  },
  {
    code: '72101',
    label: 'Research and development on natural sciences',
    msicCategoryReference: 'M'
  },
  {
    code: '72102',
    label: 'Research and development on engineering and technology',
    msicCategoryReference: 'M'
  },
  {
    code: '72103',
    label: 'Research and development on medical sciences',
    msicCategoryReference: 'M'
  },
  {
    code: '72104',
    label: 'Research and development on biotechnology',
    msicCategoryReference: 'M'
  },
  {
    code: '72105',
    label: 'Research and development on agricultural sciences',
    msicCategoryReference: 'M'
  },
  {
    code: '72106',
    label: 'Research and development on Information Communication Technology (ICT)',
    msicCategoryReference: 'M'
  },
  {
    code: '72109',
    label: 'Research and development on other natural science and engineering n.e.c.',
    msicCategoryReference: 'M'
  },
  {
    code: '72201',
    label: 'Research and development on social sciences',
    msicCategoryReference: 'M'
  },
  {
    code: '72202',
    label: 'Research and development on humanities',
    msicCategoryReference: 'M'
  },
  {
    code: '72209',
    label: 'Research and development of other social sciences and humanities n.e.c.',
    msicCategoryReference: 'M'
  },
  {
    code: '73100',
    label: 'Advertising',
    msicCategoryReference: 'M'
  },
  {
    code: '73200',
    label: 'Market research and public opinion polling',
    msicCategoryReference: 'M'
  },
  {
    code: '74101',
    label: 'Activities of interior decorators',
    msicCategoryReference: 'M'
  },
  {
    code: '74102',
    label: 'Services of graphic designers',
    msicCategoryReference: 'M'
  },
  {
    code: '74103',
    label: 'Fashion design services',
    msicCategoryReference: 'M'
  },
  {
    code: '74109',
    label: 'Specialized design activities n.e.c.',
    msicCategoryReference: 'M'
  },
  {
    code: '74200',
    label: 'Photographic activities',
    msicCategoryReference: 'M'
  },
  {
    code: '74901',
    label: 'Translation and interpretation activities',
    msicCategoryReference: 'M'
  },
  {
    code: '74902',
    label: 'Business brokerage activities',
    msicCategoryReference: 'M'
  },
  {
    code: '74903',
    label: 'Security consulting',
    msicCategoryReference: 'M'
  },
  {
    code: '74904',
    label: 'Activities of quantity surveyors',
    msicCategoryReference: 'M'
  },
  {
    code: '74905',
    label: 'Activities of consultants other than architecture, engineering and management consultants',
    msicCategoryReference: 'M'
  },
  {
    code: '74909',
    label: 'Any other professional, scientific and technical activities n.e.c.',
    msicCategoryReference: 'M'
  },
  {
    code: '75000',
    label: 'VETERINARY ACTIVITIES',
    msicCategoryReference: 'M'
  },
  {
    code: '77101',
    label: 'Renting and operational leasing of passenger cars (without driver)',
    msicCategoryReference: 'N'
  },
  {
    code: '77102',
    label: 'Renting and operational leasing of trucks, utility trailers and recreational vehicles',
    msicCategoryReference: 'N'
  },
  {
    code: '77211',
    label: 'Renting and leasing of pleasure boats, canoes, sailboats',
    msicCategoryReference: 'N'
  },
  {
    code: '77212',
    label: 'Renting and leasing of bicycles',
    msicCategoryReference: 'N'
  },
  {
    code: '77213',
    label: 'Renting and leasing of beach chairs and umbrellas',
    msicCategoryReference: 'N'
  },
  {
    code: '77219',
    label: 'Renting and leasing of other sports equipment n.e.c.',
    msicCategoryReference: 'N'
  },
  {
    code: '77220',
    label: 'Renting of video tapes, records, CDs, DVDs',
    msicCategoryReference: 'N'
  },
  {
    code: '77291',
    label: 'Renting and leasing of textiles, wearing apparel and footwear',
    msicCategoryReference: 'N'
  },
  {
    code: '77292',
    label: 'Renting and leasing of furniture, pottery and glass, kitchen and tableware, electrical appliances and house wares',
    msicCategoryReference: 'N'
  },
  {
    code: '77293',
    label: 'Renting and leasing of jewellery, musical instruments, scenery and costumes',
    msicCategoryReference: 'N'
  },
  {
    code: '77294',
    label: 'Renting and leasing of books, journals and magazines',
    msicCategoryReference: 'N'
  },
  {
    code: '77295',
    label: 'Renting and leasing of machinery and equipment used by amateurs or as a hobby',
    msicCategoryReference: 'N'
  },
  {
    code: '77296',
    label: 'Renting of flowers and plants',
    msicCategoryReference: 'N'
  },
  {
    code: '77297',
    label: 'Renting and leasing of electronic equipment for household use',
    msicCategoryReference: 'N'
  },
  {
    code: '77299',
    label: 'Renting and leasing of other personal and household goods n.e.c.',
    msicCategoryReference: 'N'
  },
  {
    code: '77301',
    label:
      'Renting and operational leasing, without operator, of other machinery and equipment that are generally used as capital goods by industries',
    msicCategoryReference: 'N'
  },
  {
    code: '77302',
    label: 'Renting and operational leasing of land-transport equipment (other than motor vehicles) without drivers',
    msicCategoryReference: 'N'
  },
  {
    code: '77303',
    label: 'Renting and operational leasing of water-transport equipment without operator',
    msicCategoryReference: 'N'
  },
  {
    code: '77304',
    label: 'Renting and operational leasing of air transport equipment without operator',
    msicCategoryReference: 'N'
  },
  {
    code: '77305',
    label: 'Renting and operational leasing of agricultural and forestry machinery and equipment without operator',
    msicCategoryReference: 'N'
  },
  {
    code: '77306',
    label: 'Renting and operational leasing of construction and civil-engineering machinery and equipment without operator',
    msicCategoryReference: 'N'
  },
  {
    code: '77307',
    label: 'Rental and operational leasing of office machinery and equipment without operator',
    msicCategoryReference: 'N'
  },
  {
    code: '77309',
    label: 'Renting and leasing of other machinery, equipment and tangible goods n.e.c.',
    msicCategoryReference: 'N'
  },
  {
    code: '77400',
    label: 'Leasing of intellectual property and similar products, except copyrighted works',
    msicCategoryReference: 'N'
  },
  {
    code: '78100',
    label: 'Activities of employment placement agencies',
    msicCategoryReference: 'N'
  },
  {
    code: '78200',
    label: 'Temporary employment agency activities',
    msicCategoryReference: 'N'
  },
  {
    code: '78300',
    label: 'Provision of human resources for client businesses',
    msicCategoryReference: 'N'
  },
  {
    code: '79110',
    label: 'Travel agency activities',
    msicCategoryReference: 'N'
  },
  {
    code: '79120',
    label: 'Tour operator activities',
    msicCategoryReference: 'N'
  },
  {
    code: '79900',
    label: 'Other reservation service and related activities',
    msicCategoryReference: 'N'
  },
  {
    code: '80100',
    label: 'Private security activities',
    msicCategoryReference: 'N'
  },
  {
    code: '80200',
    label: 'Security systems service activities',
    msicCategoryReference: 'N'
  },
  {
    code: '80300',
    label: 'Investigation and detective activities',
    msicCategoryReference: 'N'
  },
  {
    code: '81100',
    label: 'Combined facilities support activities',
    msicCategoryReference: 'N'
  },
  {
    code: '81210',
    label: 'General cleaning of buildings',
    msicCategoryReference: 'N'
  },
  {
    code: '81291',
    label: 'Cleaning of buildings of all types',
    msicCategoryReference: 'N'
  },
  {
    code: '81292',
    label: 'Swimming pool cleaning and maintenance services',
    msicCategoryReference: 'N'
  },
  {
    code: '81293',
    label: 'Cleaning of industrial machinery',
    msicCategoryReference: 'N'
  },
  {
    code: '81294',
    label: 'Cleaning of trains, buses, planes',
    msicCategoryReference: 'N'
  },
  {
    code: '81295',
    label: 'Cleaning of pest control services not in connection with agriculture',
    msicCategoryReference: 'N'
  },
  {
    code: '81296',
    label: 'Disinfecting and exterminating activities',
    msicCategoryReference: 'N'
  },
  {
    code: '81297',
    label: 'Cleaning of sea tankers',
    msicCategoryReference: 'N'
  },
  {
    code: '81299',
    label: 'Other building and industrial cleaning activities, n.e.c.',
    msicCategoryReference: 'N'
  },
  {
    code: '81300',
    label: 'Landscape care and maintenance service activities',
    msicCategoryReference: 'N'
  },
  {
    code: '82110',
    label: 'Combined office administrative service activities',
    msicCategoryReference: 'N'
  },
  {
    code: '82191',
    label: 'Document preparation, editing and/or proofreading',
    msicCategoryReference: 'N'
  },
  {
    code: '82192',
    label: 'Typing, word processing or desktop publishing',
    msicCategoryReference: 'N'
  },
  {
    code: '82193',
    label: 'Secretarial support services',
    msicCategoryReference: 'N'
  },
  {
    code: '82194',
    label: 'Transcription of documents and other secretarial services',
    msicCategoryReference: 'N'
  },
  {
    code: '82195',
    label: 'Provision of mailbox rental and other postal and mailing services',
    msicCategoryReference: 'N'
  },
  {
    code: '82196',
    label: 'Photocopying, duplicating, blueprinting',
    msicCategoryReference: 'N'
  },
  {
    code: '82199',
    label: 'Photocopying, document preparation and other specialized office support activities n.e.c.',
    msicCategoryReference: 'N'
  },
  {
    code: '82200',
    label: 'Activities of call centres',
    msicCategoryReference: 'N'
  },
  {
    code: '82301',
    label: 'Organization, promotions and/or management of event',
    msicCategoryReference: 'N'
  },
  {
    code: '82302',
    label: 'Meeting, incentive, convention, exhibition (MICE)',
    msicCategoryReference: 'N'
  },
  {
    code: '82910',
    label: 'Activities of collection agencies and credit bureaus',
    msicCategoryReference: 'N'
  },
  {
    code: '82920',
    label: 'Packaging activities on a fee or contract basis, whether or not these involve an automated process',
    msicCategoryReference: 'N'
  },
  {
    code: '82990',
    label: 'Other business support service activities n.e.c.',
    msicCategoryReference: 'N'
  },
  {
    code: '84111',
    label: 'General (overall) public administration activities',
    msicCategoryReference: 'O'
  },
  {
    code: '84112',
    label: 'Ancillary service activities for the government as a whole',
    msicCategoryReference: 'O'
  },
  {
    code: '84121',
    label: 'Administrative educational services',
    msicCategoryReference: 'O'
  },
  {
    code: '84122',
    label: 'Administrative health care services',
    msicCategoryReference: 'O'
  },
  {
    code: '84123',
    label: 'Administrative housing and local government services',
    msicCategoryReference: 'O'
  },
  {
    code: '84124',
    label: 'Administrative recreational, cultural, arts and sports services',
    msicCategoryReference: 'O'
  },
  {
    code: '84125',
    label: 'Administrative religious affairs services',
    msicCategoryReference: 'O'
  },
  {
    code: '84126',
    label: 'Administrative welfare services',
    msicCategoryReference: 'O'
  },
  {
    code: '84129',
    label: 'Other community and social affairs services',
    msicCategoryReference: 'O'
  },
  {
    code: '84131',
    label: 'Domestic and international trade affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84132',
    label: 'Agriculture and rural development affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84133',
    label: 'Primary industries affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84134',
    label: 'Public works affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84135',
    label: 'Transport affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84136',
    label: 'Energy, telecommunication and postal affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84137',
    label: 'Tourism affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84138',
    label: 'Human resource affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84139',
    label: 'Other regulation of and contribution to more efficient operation of businesses n.e.c.',
    msicCategoryReference: 'O'
  },
  {
    code: '84210',
    label: 'Foreign affairs',
    msicCategoryReference: 'O'
  },
  {
    code: '84220',
    label: 'Military and civil defence services',
    msicCategoryReference: 'O'
  },
  {
    code: '84231',
    label: 'Police service',
    msicCategoryReference: 'O'
  },
  {
    code: '84232',
    label: 'Prison service',
    msicCategoryReference: 'O'
  },
  {
    code: '84233',
    label: 'Immigration service',
    msicCategoryReference: 'O'
  },
  {
    code: '84234',
    label: 'National registration service',
    msicCategoryReference: 'O'
  },
  {
    code: '84235',
    label: 'Judiciary and legal service',
    msicCategoryReference: 'O'
  },
  {
    code: '84236',
    label: 'Firefighting and fire prevention',
    msicCategoryReference: 'O'
  },
  {
    code: '84239',
    label: 'Other public order and safety affairs related services',
    msicCategoryReference: 'O'
  },
  {
    code: '84300',
    label: 'Compulsory social security activities e.g. SOCSO',
    msicCategoryReference: 'O'
  },
  {
    code: '85101',
    label: 'Pre-primary education (Public)',
    msicCategoryReference: 'P'
  },
  {
    code: '85102',
    label: 'Pre-primary education (Private)',
    msicCategoryReference: 'P'
  },
  {
    code: '85103',
    label: 'Primary education (Public)',
    msicCategoryReference: 'P'
  },
  {
    code: '85104',
    label: 'Primary education (Private)',
    msicCategoryReference: 'P'
  },
  {
    code: '85211',
    label: 'General school secondary education (Public)',
    msicCategoryReference: 'P'
  },
  {
    code: '85212',
    label: 'General school secondary education (Private)',
    msicCategoryReference: 'P'
  },
  {
    code: '85221',
    label: 'Technical and vocational education below the level of higher education (Public)',
    msicCategoryReference: 'P'
  },
  {
    code: '85222',
    label: 'Technical and vocational education below the level of higher education (Private)',
    msicCategoryReference: 'P'
  },
  {
    code: '85301',
    label: 'College and university education (Public)',
    msicCategoryReference: 'P'
  },
  {
    code: '85302',
    label: 'College and university education (Private)',
    msicCategoryReference: 'P'
  },
  {
    code: '85411',
    label: 'Sports instruction',
    msicCategoryReference: 'P'
  },
  {
    code: '85412',
    label: 'Martial arts instruction',
    msicCategoryReference: 'P'
  },
  {
    code: '85419',
    label: 'Any other sports and recreation education n.e.c',
    msicCategoryReference: 'P'
  },
  {
    code: '85421',
    label: 'Music and dancing school',
    msicCategoryReference: 'P'
  },
  {
    code: '85429',
    label: 'Any other cultural education n.e.c.',
    msicCategoryReference: 'P'
  },
  {
    code: '85491',
    label: 'Tuition centre',
    msicCategoryReference: 'P'
  },
  {
    code: '85492',
    label: 'Driving school',
    msicCategoryReference: 'P'
  },
  {
    code: '85493',
    label: 'Religious instruction',
    msicCategoryReference: 'P'
  },
  {
    code: '85494',
    label: 'Computer training',
    msicCategoryReference: 'P'
  },
  {
    code: '85499',
    label: 'Others education n.e.c',
    msicCategoryReference: 'P'
  },
  {
    code: '85500',
    label: 'Educational support services for provision of non-instructional services',
    msicCategoryReference: 'P'
  },
  {
    code: '86101',
    label: 'Hospital activities',
    msicCategoryReference: 'Q'
  },
  {
    code: '86102',
    label: 'Maternity home services (outside hospital)',
    msicCategoryReference: 'Q'
  },
  {
    code: '86201',
    label: 'General medical services',
    msicCategoryReference: 'Q'
  },
  {
    code: '86202',
    label: 'Specialized medical services',
    msicCategoryReference: 'Q'
  },
  {
    code: '86203',
    label: 'Dental services',
    msicCategoryReference: 'Q'
  },
  {
    code: '86901',
    label: 'Dialysis Centres',
    msicCategoryReference: 'Q'
  },
  {
    code: '86902',
    label: 'Medical laboratories',
    msicCategoryReference: 'Q'
  },
  {
    code: '86903',
    label: 'Physiotherapy and occupational therapy service',
    msicCategoryReference: 'Q'
  },
  {
    code: '86904',
    label: 'Acupuncture services',
    msicCategoryReference: 'Q'
  },
  {
    code: '86905',
    label: 'Herbalist and homeopathy services',
    msicCategoryReference: 'Q'
  },
  {
    code: '86906',
    label: 'Ambulance services',
    msicCategoryReference: 'Q'
  },
  {
    code: '86909',
    label: 'Other human health services n.e.c.',
    msicCategoryReference: 'Q'
  },
  {
    code: '87101',
    label: 'Homes for the elderly with nursing care',
    msicCategoryReference: 'Q'
  },
  {
    code: '87102',
    label: 'Nursing homes',
    msicCategoryReference: 'Q'
  },
  {
    code: '87103',
    label: 'Palliative or hospices',
    msicCategoryReference: 'Q'
  },
  {
    code: '87201',
    label: 'Drug rehabilitation centres',
    msicCategoryReference: 'Q'
  },
  {
    code: '87209',
    label: 'Other residential care activities for mental retardation n.e.c.',
    msicCategoryReference: 'Q'
  },
  {
    code: '87300',
    label: 'Residential care activities for the elderly and disabled',
    msicCategoryReference: 'Q'
  },
  {
    code: '87901',
    label: 'Orphanages',
    msicCategoryReference: 'Q'
  },
  {
    code: '87902',
    label: 'Welfare homes services',
    msicCategoryReference: 'Q'
  },
  {
    code: '87909',
    label: 'Other residential care activities n.e.c.',
    msicCategoryReference: 'Q'
  },
  {
    code: '88101',
    label: 'Day-care activities for the elderly or for handicapped adults',
    msicCategoryReference: 'Q'
  },
  {
    code: '88109',
    label: 'Others social work activities without accommodation for the elderly and disabled',
    msicCategoryReference: 'Q'
  },
  {
    code: '88901',
    label: 'Counselling service',
    msicCategoryReference: 'Q'
  },
  {
    code: '88902',
    label: 'Child day-care activities',
    msicCategoryReference: 'Q'
  },
  {
    code: '88909',
    label: 'Other social work activities without accommodation n.e.c.',
    msicCategoryReference: 'Q'
  },
  {
    code: '90001',
    label: 'Theatrical producer, singer group band and orchestra entertainment services',
    msicCategoryReference: 'R'
  },
  {
    code: '90002',
    label: 'Operation of concert and theatre halls and other arts facilities',
    msicCategoryReference: 'R'
  },
  {
    code: '90003',
    label: 'Activities of sculptors, painters, cartoonists, engravers, etchers',
    msicCategoryReference: 'R'
  },
  {
    code: '90004',
    label: 'Activities of individual writers, for all subjects',
    msicCategoryReference: 'R'
  },
  {
    code: '90005',
    label: 'Activities of independent journalists',
    msicCategoryReference: 'R'
  },
  {
    code: '90006',
    label: 'Restoring of works of art such as painting',
    msicCategoryReference: 'R'
  },
  {
    code: '90007',
    label: 'Activities of producers or entrepreneurs of arts live events, with or without facilities',
    msicCategoryReference: 'R'
  },
  {
    code: '90009',
    label: 'Creative, arts and entertainment activities n.e.c.',
    msicCategoryReference: 'R'
  },
  {
    code: '91011',
    label: 'Documentation and information activities of libraries of all kinds',
    msicCategoryReference: 'R'
  },
  {
    code: '91012',
    label: 'Stock photo libraries and services',
    msicCategoryReference: 'R'
  },
  {
    code: '91021',
    label: 'Operation of museums of all kinds',
    msicCategoryReference: 'R'
  },
  {
    code: '91022',
    label: 'Operation of historical sites and buildings',
    msicCategoryReference: 'R'
  },
  {
    code: '91031',
    label: 'Operation of botanical and zoological gardens',
    msicCategoryReference: 'R'
  },
  {
    code: '91032',
    label: 'Operation of nature reserves, including wildlife preservation',
    msicCategoryReference: 'R'
  },
  {
    code: '92000',
    label: 'GAMBLING AND BETTING ACTIVITIES',
    msicCategoryReference: 'R'
  },
  {
    code: '93111',
    label: 'Football, hockey, cricket, baseball, badminton, futsal, paintball',
    msicCategoryReference: 'R'
  },
  {
    code: '93112',
    label: 'Racetracks for auto',
    msicCategoryReference: 'R'
  },
  {
    code: '93113',
    label: 'Equestrian clubs',
    msicCategoryReference: 'R'
  },
  {
    code: '93114',
    label: 'Swimming pools and stadiums, ice-skating arenas',
    msicCategoryReference: 'R'
  },
  {
    code: '93115',
    label: 'Track and field stadium',
    msicCategoryReference: 'R'
  },
  {
    code: '93116',
    label: 'Golf courses',
    msicCategoryReference: 'R'
  },
  {
    code: '93117',
    label: 'Bowling centre',
    msicCategoryReference: 'R'
  },
  {
    code: '93118',
    label: 'Fitness centres',
    msicCategoryReference: 'R'
  },
  {
    code: '93119',
    label: 'Organization and operation of outdoor or indoor sports events for professionals or amateurs by organizations with own facilities',
    msicCategoryReference: 'R'
  },
  {
    code: '93120',
    label: 'The operation of sports clubs such as football club, bowling club, swimming club',
    msicCategoryReference: 'R'
  },
  {
    code: '93191',
    label: 'Activities of producers or promoters of sports events, with or without facilities',
    msicCategoryReference: 'R'
  },
  {
    code: '93192',
    label: 'Activities of sports leagues and regulating bodies',
    msicCategoryReference: 'R'
  },
  {
    code: '93193',
    label: 'Activities of related to promotion of sporting events',
    msicCategoryReference: 'R'
  },
  {
    code: '93199',
    label: 'Other sports activities n.e.c.',
    msicCategoryReference: 'R'
  },
  {
    code: '93210',
    label: 'Activities of amusement parks and theme parks',
    msicCategoryReference: 'R'
  },
  {
    code: '93291',
    label: 'Activities of recreation parks and beaches',
    msicCategoryReference: 'R'
  },
  {
    code: '93292',
    label: 'Operation of recreational transport facilities',
    msicCategoryReference: 'R'
  },
  {
    code: '93293',
    label: 'Renting of leisure and pleasure equipment as an integral part of recreational facilities',
    msicCategoryReference: 'R'
  },
  {
    code: '93294',
    label: 'Operation of fairs and shows of a recreational nature',
    msicCategoryReference: 'R'
  },
  {
    code: '93295',
    label: 'Operation of discotheques and dance floors',
    msicCategoryReference: 'R'
  },
  {
    code: '93296',
    label: 'Activities of producers or entrepreneurs of live events other than arts or sports events, with or without facilities',
    msicCategoryReference: 'R'
  },
  {
    code: '93297',
    label: 'Cyber Café/Internet Centre',
    msicCategoryReference: 'R'
  },
  {
    code: '93299',
    label: 'Any other amusement and recreation activities n.e.c.',
    msicCategoryReference: 'R'
  },
  {
    code: '94110',
    label: 'Activities of business and employers membership organizations',
    msicCategoryReference: 'S'
  },
  {
    code: '94120',
    label: 'Activities of professional membership organizations',
    msicCategoryReference: 'S'
  },
  {
    code: '94200',
    label: 'Activities of trade unions',
    msicCategoryReference: 'S'
  },
  {
    code: '94910',
    label: 'Activities of religious organizations',
    msicCategoryReference: 'S'
  },
  {
    code: '94920',
    label: 'Activities of political organizations',
    msicCategoryReference: 'S'
  },
  {
    code: '94990',
    label: 'Activities of other membership organizations n.e.c.',
    msicCategoryReference: 'S'
  },
  {
    code: '95111',
    label: 'Repair of electronic equipment',
    msicCategoryReference: 'S'
  },
  {
    code: '95112',
    label: 'Repair and maintenance of computer terminals',
    msicCategoryReference: 'S'
  },
  {
    code: '95113',
    label: "Repair and maintenance of hand-held computers (PDA's)",
    msicCategoryReference: 'S'
  },
  {
    code: '95121',
    label: 'Repair and maintenance of cordless telephones',
    msicCategoryReference: 'S'
  },
  {
    code: '95122',
    label: 'Repair and maintenance of cellular phones',
    msicCategoryReference: 'S'
  },
  {
    code: '95123',
    label: 'Repair and maintenance of carrier equipment modems',
    msicCategoryReference: 'S'
  },
  {
    code: '95124',
    label: 'Repair and maintenance of fax machines',
    msicCategoryReference: 'S'
  },
  {
    code: '95125',
    label: 'Repair and maintenance of communications transmission equipment',
    msicCategoryReference: 'S'
  },
  {
    code: '95126',
    label: 'Repair and maintenance of two-way radios',
    msicCategoryReference: 'S'
  },
  {
    code: '95127',
    label: 'Repair and maintenance of commercial TV and video cameras',
    msicCategoryReference: 'S'
  },
  {
    code: '95211',
    label: 'Repair and maintenance of television, radio receivers',
    msicCategoryReference: 'S'
  },
  {
    code: '95212',
    label: 'Repair and maintenance of VCR/DVD/VCD',
    msicCategoryReference: 'S'
  },
  {
    code: '95213',
    label: 'Repair and maintenance of CD players',
    msicCategoryReference: 'S'
  },
  {
    code: '95214',
    label: 'Repair and maintenance of household-type video cameras',
    msicCategoryReference: 'S'
  },
  {
    code: '95221',
    label: 'Repair and servicing of household appliances',
    msicCategoryReference: 'S'
  },
  {
    code: '95222',
    label: 'Repair and servicing of home and garden equipment',
    msicCategoryReference: 'S'
  },
  {
    code: '95230',
    label: 'Repair of footwear and leather goods',
    msicCategoryReference: 'S'
  },
  {
    code: '95240',
    label: 'Repair of furniture and home furnishings',
    msicCategoryReference: 'S'
  },
  {
    code: '95291',
    label: 'Repair of bicycles',
    msicCategoryReference: 'S'
  },
  {
    code: '95292',
    label: 'Repair and alteration of clothing',
    msicCategoryReference: 'S'
  },
  {
    code: '95293',
    label: 'Repair and alteration of jewellery',
    msicCategoryReference: 'S'
  },
  {
    code: '95294',
    label: 'Repair of watches, clocks and their parts',
    msicCategoryReference: 'S'
  },
  {
    code: '95295',
    label: 'Repair of sporting goods',
    msicCategoryReference: 'S'
  },
  {
    code: '95296',
    label: 'Repair of musical instruments',
    msicCategoryReference: 'S'
  },
  {
    code: '95299',
    label: 'Repair of other personal and household goods n.e.c.',
    msicCategoryReference: 'S'
  },
  {
    code: '96011',
    label: 'Laundering and dry-cleaning, pressing',
    msicCategoryReference: 'S'
  },
  {
    code: '96012',
    label: "Carpet and rug shampooing, and drapery and curtain cleaning, whether on clients' premises or not",
    msicCategoryReference: 'S'
  },
  {
    code: '96013',
    label: 'Provision of linens, work uniforms and related items by laundries',
    msicCategoryReference: 'S'
  },
  {
    code: '96014',
    label: 'Diaper supply services',
    msicCategoryReference: 'S'
  },
  {
    code: '96020',
    label: 'Hairdressing and other beauty treatment',
    msicCategoryReference: 'S'
  },
  {
    code: '96031',
    label: "Preparing the dead for burial or cremation and embalming and morticians' services",
    msicCategoryReference: 'S'
  },
  {
    code: '96032',
    label: 'Providing burial or cremation services',
    msicCategoryReference: 'S'
  },
  {
    code: '96033',
    label: 'Rental of equipped space in funeral parlours',
    msicCategoryReference: 'S'
  },
  {
    code: '96034',
    label: 'Rental or sale of graves',
    msicCategoryReference: 'S'
  },
  {
    code: '96035',
    label: 'Maintenance of graves and mausoleums',
    msicCategoryReference: 'S'
  },
  {
    code: '96091',
    label: 'Activities of sauna, steam baths, massage salons',
    msicCategoryReference: 'S'
  },
  {
    code: '96092',
    label: "Astrological and spiritualists' activities",
    msicCategoryReference: 'S'
  },
  {
    code: '96093',
    label: 'Social activities such as escort services, dating services, services of marriage bureaux',
    msicCategoryReference: 'S'
  },
  {
    code: '96094',
    label: 'Pet care services',
    msicCategoryReference: 'S'
  },
  {
    code: '96095',
    label: 'Genealogical organizations',
    msicCategoryReference: 'S'
  },
  {
    code: '96096',
    label: 'Shoe shiners, porters, valet car parkers',
    msicCategoryReference: 'S'
  },
  {
    code: '96097',
    label: 'Concession operation of coin-operated personal service machines',
    msicCategoryReference: 'S'
  },
  {
    code: '96099',
    label: 'Other service activities n.e.c.',
    msicCategoryReference: 'S'
  },
  {
    code: '97000',
    label: 'Activities of households as employers of domestic personnel',
    msicCategoryReference: 'T'
  },
  {
    code: '98100',
    label: 'Undifferentiated goods-producing activities of private households for own use',
    msicCategoryReference: 'T'
  },
  {
    code: '98200',
    label: 'Undifferentiated service-producing activities of private households for own use',
    msicCategoryReference: 'T'
  },
  {
    code: '99000',
    label: 'Activities of extraterritorial organization and bodies',
    msicCategoryReference: 'U'
  }
];

export const planNameLabel = ['entry', 'starter', 'standard'];
